/* tslint:disable */
/* eslint-disable */
/**
 * ELZA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, operationServerMap } from './base';
/**
 * Type of a UI context object — the discriminator of `AiContextObject`. Names what part of the application the user is working in when an AI request is sent.
 */
export const AiContextType = {
    Fund: 'FUND',
    Node: 'NODE',
    Accesspoint: 'ACCESSPOINT'
};
/**
 * Display block type — the discriminator of `AiDisplayBlock`. The client renders each block by this code, reading the fields of the matching subtype. Additive: new types may appear; a client MUST tolerate an unknown type by rendering a generic \"unsupported content\" placeholder (never dropping the block silently).
 */
export const AiDisplayBlockType = {
    Text: 'TEXT',
    Markdown: 'MARKDOWN',
    Table: 'TABLE',
    DocCitations: 'DOC_CITATIONS'
};
/**
 * Způsob porovnání hodnot filtru
 */
export const AipFilterCriteriaGen = {
    IsNull: 'IS_NULL',
    IsNotNull: 'IS_NOT_NULL',
    Contains: 'CONTAINS',
    DoesNotContain: 'DOES_NOT_CONTAIN',
    Equals: 'EQUALS',
    Between: 'BETWEEN'
};
/**
 * Aip package type
 */
export const AipType = {
    PackageInfo: 'PACKAGE_INFO',
    Archdesc: 'ARCHDESC',
    MetadataBase: 'METADATA_BASE',
    AipBase: 'AIP_BASE',
    AipRaw: 'AIP_RAW'
};
/**
 * AIP update type
 */
export const AipUpdateType = {
    DbUpdate: 'DB_UPDATE',
    DownloadUpdate: 'DOWNLOAD_UPDATE',
    ForceUpdate: 'FORCE_UPDATE'
};
/**
 * Area in which the access-point search runs.
 */
export const ApSearchArea = {
    PreferNames: 'PREFER_NAMES',
    AllNames: 'ALL_NAMES',
    AllParts: 'ALL_PARTS',
    EntityCode: 'ENTITY_CODE'
};
/**
 * Search strategy for criteria-based access-point queries (name / username fields).
 */
export const ApSearchType = {
    Disabled: 'DISABLED',
    Join: 'JOIN',
    Fulltext: 'FULLTEXT',
    RightSideLike: 'RIGHT_SIDE_LIKE'
};
/**
 * States of ApState
 */
export const ApStateApproval = {
    New: 'NEW',
    ToApprove: 'TO_APPROVE',
    Approved: 'APPROVED',
    ToAmend: 'TO_AMEND'
};
/**
 * Stav běhu hromadné akce.
 */
export const BulkActionRunState = {
    Waiting: 'WAITING',
    Planned: 'PLANNED',
    Running: 'RUNNING',
    Finished: 'FINISHED',
    Error: 'ERROR',
    Interrupted: 'INTERRUPTED',
    Outdated: 'OUTDATED'
};
/**
 * Kind of target environment a publication type connects to.
 */
export const ConnectionType = {
    Development: 'DEVELOPMENT',
    Test: 'TEST',
    Production: 'PRODUCTION'
};
/**
 * Dao type
 */
export const DaDaoType = {
    Representation: 'REPRESENTATION',
    Logical: 'LOGICAL',
    File: 'FILE',
    Metaamd: 'METAAMD',
    Metadmdinherent: 'METADMDINHERENT',
    Metadmdcontextual: 'METADMDCONTEXTUAL'
};
/**
 * Data types for ItemData classes
 */
export const DataType = {
    Int: 'INT',
    String: 'STRING',
    Text: 'TEXT',
    Unitdate: 'UNITDATE',
    Unitid: 'UNITID',
    FormattedText: 'FORMATTED_TEXT',
    Coordinates: 'COORDINATES',
    RecordRef: 'RECORD_REF',
    Decimal: 'DECIMAL',
    Structured: 'STRUCTURED',
    Enum: 'ENUM',
    FileRef: 'FILE_REF',
    JsonTable: 'JSON_TABLE',
    Date: 'DATE',
    UriRef: 'URI_REF',
    Bit: 'BIT'
};
/**
 * Aggregated badge state computed by the server from all issues on a binding.  NONE      no issues NEUTRAL   only WARNING issues with status IR_ALL_REVISIONS_OK / IR_REVISION_OK NEW       at least one WARNING with status absent ATTENTION any ERROR, or any status = IR_FIX_NEEDED — single most prominent icon
 */
export const ExtIssueIconState = {
    None: 'NONE',
    Neutral: 'NEUTRAL',
    New: 'NEW',
    Attention: 'ATTENTION'
};
/**
 * Severity of a CAM-side issue attached to an entity binding.
 */
export const ExtIssueSeverity = {
    Warning: 'WARNING',
    Error: 'ERROR'
};
/**
 * Resolution state of an issue. Absent on the wire = new issue not yet evaluated by the user.
 */
export const ExtIssueStatus = {
    IrAllRevisionsOk: 'IR_ALL_REVISIONS_OK',
    IrFixNeeded: 'IR_FIX_NEEDED',
    IrRevisionOk: 'IR_REVISION_OK'
};
/**
 * Role of a participant on an entity revision.
 */
export const ExtParticipantRole = {
    Author: 'AUTHOR',
    Approval: 'APPROVAL'
};
/**
 * Type of field for FieldValueFilter
 */
export const FieldType = {
    FondsField: 'FONDS_FIELD',
    NodeField: 'NODE_FIELD',
    DescItem: 'DESC_ITEM'
};
/**
 * Types of filters
 */
export const FilterType = {
    FieldValue: 'fieldValue',
    Contains: 'contains',
    Logical: 'logical'
};
/**
 * Funds specific field names  Fields are used for FundsFilterField.
 */
export const FondsFieldName = {
    FondsId: 'fondsId',
    Name: 'name',
    CreateDate: 'createDate',
    InternalCode: 'internalCode',
    FondsNumber: 'fondsNumber',
    Unitdate: 'unitdate',
    Mark: 'mark',
    InstitutionId: 'institutionId',
    InstitutionCode: 'institutionCode'
};
/**
 * Filter for file system items by link status
 */
export const FsItemFilterByLinked = {
    All: 'ALL',
    Linked: 'LINKED',
    Unlinked: 'UNLINKED'
};
/**
 * File sorting type
 */
export const FsItemSortType = {
    NameAsc: 'NAME_ASC',
    NameDesc: 'NAME_DESC',
    SizeAsc: 'SIZE_ASC',
    SizeDesc: 'SIZE_DESC'
};
/**
 * File system item type
 */
export const FsItemType = {
    Folder: 'FOLDER',
    File: 'FILE'
};
/**
 * Display hint for items of `dataType == INT`.
 */
export const ItemDisplayType = {
    Number: 'NUMBER',
    Duration: 'DURATION'
};
/**
 * Link type
 */
export const LinkType = {
    Aip: 'AIP',
    PartAip: 'PART_AIP',
    ComponentAip: 'COMPONENT_AIP'
};
/**
 * Item mandatory type
 */
export const MandatoryType = {
    Required: 'REQUIRED',
    Recommended: 'RECOMMENDED',
    Possible: 'POSSIBLE',
    Impossible: 'IMPOSSIBLE'
};
/**
 * Stav JP
 */
export const NodeConformityState = {
    Ok: 'OK',
    Err: 'ERR'
};
/**
 * Node specific field names  Node fields are used for FieldValueFilter.
 */
export const NodeFieldName = {
    ConformityError: 'conformityError',
    ConformityMissing: 'conformityMissing',
    Uuid: 'uuid'
};
/**
 * Operation type for FieldValueFilter
 */
export const OperationCompareType = {
    Eq: 'EQ',
    Neq: 'NEQ',
    Gt: 'GT',
    Lt: 'LT',
    Gte: 'GTE',
    Lte: 'LTE',
    Startwith: 'STARTWITH',
    Endwith: 'ENDWITH',
    Contains: 'CONTAINS',
    Intersect: 'INTERSECT',
    IsIn: 'IS_IN',
    IsNull: 'IS_NULL',
    NotNull: 'NOT_NULL'
};
/**
 * Operation type for LogicalFilter
 */
export const OperationLogicalType = {
    And: 'AND',
    Or: 'OR'
};
/**
 * Generator startup status
 */
export const OutputRequestStatus = {
    Ok: 'OK',
    DetectChange: 'DETECT_CHANGE',
    RecommendedActionNotRun: 'RECOMMENDED_ACTION_NOT_RUN'
};
/**
 * Output state
 */
export const OutputState = {
    Open: 'OPEN',
    Computing: 'COMPUTING',
    Generating: 'GENERATING',
    Finished: 'FINISHED',
    Outdated: 'OUTDATED'
};
/**
 * Outcome reported back to Elza by the publication system.
 */
export const PublicationReportStatus = {
    Ok: 'OK',
    Error: 'ERROR'
};
/**
 * Internal-only view of a publication\'s life-cycle state. Mirrors {
 */
export const PublicationStateInternal = {
    New: 'NEW',
    Prepared: 'PREPARED',
    Fetched: 'FETCHED',
    Published: 'PUBLISHED',
    PrepareError: 'PREPARE_ERROR',
    PublishError: 'PUBLISH_ERROR',
    Invalidated: 'INVALIDATED'
};
/**
 * Výčet stavů aktualizace AIPu
 */
export const QueueItemState = {
    Update: 'UPDATE',
    ImportNew: 'IMPORT_NEW',
    ImportOk: 'IMPORT_OK',
    ImportError: 'IMPORT_ERROR',
    ExportNew: 'EXPORT_NEW',
    ExportOk: 'EXPORT_OK',
    ExportError: 'EXPORT_ERROR'
};
/**
 * Method of replacing ApAccessPoint
 */
export const ReplaceType = {
    Simple: 'SIMPLE',
    CopyAll: 'COPY_ALL'
};
/**
 * Types of report output formats
 */
export const ReportReportFormat = {
    Json: 'JSON',
    Csv: 'CSV'
};
/**
 * Types of statistics values
 */
export const ReportValueType = {
    Int: 'INT',
    String: 'STRING',
    Boolean: 'BOOLEAN',
    Date: 'DATE',
    UserId: 'USER_ID',
    GroupId: 'GROUP_ID',
    FundId: 'FUND_ID',
    ApId: 'AP_ID',
    ItemTypeId: 'ITEM_TYPE_ID',
    ItemSpecId: 'ITEM_SPEC_ID',
    ScopeId: 'SCOPE_ID',
    ApTypeId: 'AP_TYPE_ID'
};
/**
 * Status of async request
 */
export const RequestProcessState = {
    Pending: 'PENDING',
    Processing: 'PROCESSING',
    Finished: 'FINISHED',
    Error: 'ERROR'
};
/**
 * Request state
 */
export const RequestState = {
    Open: 'OPEN',
    Queued: 'QUEUED',
    Sent: 'SENT',
    Processed: 'PROCESSED',
    Rejected: 'REJECTED'
};
/**
 * States of ApRevState
 */
export const RevisionState = {
    Active: 'ACTIVE',
    ToApprove: 'TO_APPROVE',
    ToAmend: 'TO_AMEND'
};
/**
 * Order of sorting
 */
export const SortingOrder = {
    Asc: 'asc',
    Desc: 'desc'
};
export const StructuredObjectStateEnum = {
    Ok: 'OK',
    Error: 'ERROR',
    Temp: 'TEMP'
};
/**
 * Progres synchronizace
 */
export const SyncProgress = {
    UploadPending: 'UPLOAD_PENDING',
    UploadStarted: 'UPLOAD_STARTED'
};
/**
 * Stav synchronizace
 */
export const SyncState = {
    SyncOk: 'SYNC_OK',
    NotSynced: 'NOT_SYNCED',
    LocalChange: 'LOCAL_CHANGE'
};
/**
 * Entity type for task
 */
export const TasksEntityType = {
    Ap: 'AP',
    ApRev: 'AP_REV'
};
/**
 * Task status
 */
export const TasksStatus = {
    New: 'NEW',
    Cancelled: 'CANCELLED',
    Finished: 'FINISHED'
};
/**
 * Type of update Item
 */
export const UpdateOp = {
    Create: 'CREATE',
    Update: 'UPDATE',
    Delete: 'DELETE'
};
/**
 * AccesspointInternalApi - axios parameter creator
 */
export const AccesspointInternalApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Paginated history of binding revisions, newest first, built from ap_binding_state and ap_binding_participant. Participants within each revision are ordered by lastChange (ascending).
         * @param {number} bindingId id of binding
         * @param {number} [offset]
         * @param {number} [limit] server caps at 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointBindingGetBindingHistory: (bindingId_1, offset_1, limit_1, ...args_1) => __awaiter(this, [bindingId_1, offset_1, limit_1, ...args_1], void 0, function* (bindingId, offset, limit, options = {}) {
            // verify required parameter 'bindingId' is not null or undefined
            assertParamExists('accessPointBindingGetBindingHistory', 'bindingId', bindingId);
            const localVarPath = `/binding/{bindingId}/history`
                .replace(`{${"bindingId"}}`, encodeURIComponent(String(bindingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List CAM-side issues attached to a binding.
         * @param {number} bindingId id of binding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointBindingGetBindingIssues: (bindingId_1, ...args_1) => __awaiter(this, [bindingId_1, ...args_1], void 0, function* (bindingId, options = {}) {
            // verify required parameter 'bindingId' is not null or undefined
            assertParamExists('accessPointBindingGetBindingIssues', 'bindingId', bindingId);
            const localVarPath = `/binding/{bindingId}/issues`
                .replace(`{${"bindingId"}}`, encodeURIComponent(String(bindingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AccesspointInternalApi - functional programming interface
 */
export const AccesspointInternalApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccesspointInternalApiAxiosParamCreator(configuration);
    return {
        /**
         * Paginated history of binding revisions, newest first, built from ap_binding_state and ap_binding_participant. Participants within each revision are ordered by lastChange (ascending).
         * @param {number} bindingId id of binding
         * @param {number} [offset]
         * @param {number} [limit] server caps at 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointBindingGetBindingHistory(bindingId, offset, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointBindingGetBindingHistory(bindingId, offset, limit, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointInternalApi.accessPointBindingGetBindingHistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * List CAM-side issues attached to a binding.
         * @param {number} bindingId id of binding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointBindingGetBindingIssues(bindingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointBindingGetBindingIssues(bindingId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointInternalApi.accessPointBindingGetBindingIssues']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AccesspointInternalApi - factory interface
 */
export const AccesspointInternalApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccesspointInternalApiFp(configuration);
    return {
        /**
         * Paginated history of binding revisions, newest first, built from ap_binding_state and ap_binding_participant. Participants within each revision are ordered by lastChange (ascending).
         * @param {number} bindingId id of binding
         * @param {number} [offset]
         * @param {number} [limit] server caps at 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointBindingGetBindingHistory(bindingId, offset, limit, options) {
            return localVarFp.accessPointBindingGetBindingHistory(bindingId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * List CAM-side issues attached to a binding.
         * @param {number} bindingId id of binding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointBindingGetBindingIssues(bindingId, options) {
            return localVarFp.accessPointBindingGetBindingIssues(bindingId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccesspointInternalApi - object-oriented interface
 */
export class AccesspointInternalApi extends BaseAPI {
    /**
     * Paginated history of binding revisions, newest first, built from ap_binding_state and ap_binding_participant. Participants within each revision are ordered by lastChange (ascending).
     * @param {number} bindingId id of binding
     * @param {number} [offset]
     * @param {number} [limit] server caps at 100
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointBindingGetBindingHistory(bindingId, offset, limit, options) {
        return AccesspointInternalApiFp(this.configuration).accessPointBindingGetBindingHistory(bindingId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List CAM-side issues attached to a binding.
     * @param {number} bindingId id of binding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointBindingGetBindingIssues(bindingId, options) {
        return AccesspointInternalApiFp(this.configuration).accessPointBindingGetBindingIssues(bindingId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AccesspointsApi - axios parameter creator
 */
export const AccesspointsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Asynchronously export access points matching the given filter to CSV.  Returns the request id; poll /io/export-status/{id} and download the result via /io/file/{id}. Results are ordered by accessPointId ascending. Empty body / null fields means \"all access points visible to the user\".
         * @param {AccessPointBatchExportParams} accessPointBatchExportParams filter selecting the access points to export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointBatchExport: (accessPointBatchExportParams_1, ...args_1) => __awaiter(this, [accessPointBatchExportParams_1, ...args_1], void 0, function* (accessPointBatchExportParams, options = {}) {
            // verify required parameter 'accessPointBatchExportParams' is not null or undefined
            assertParamExists('accessPointBatchExport', 'accessPointBatchExportParams', accessPointBatchExportParams);
            const localVarPath = `/accesspoint/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accessPointBatchExportParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Change state of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {ApStateUpdate} apStateUpdate data for change ApState
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {number} [assignTo] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointChangeState: (id_1, apStateUpdate_1, apVersion_1, assignTo_1, ...args_1) => __awaiter(this, [id_1, apStateUpdate_1, apVersion_1, assignTo_1, ...args_1], void 0, function* (id, apStateUpdate, apVersion, assignTo, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointChangeState', 'id', id);
            // verify required parameter 'apStateUpdate' is not null or undefined
            assertParamExists('accessPointChangeState', 'apStateUpdate', apStateUpdate);
            const localVarPath = `/accesspoint/{id}/state`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            if (assignTo !== undefined) {
                localVarQueryParameter['assignTo'] = assignTo;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(apStateUpdate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Change state of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {RevStateChange} revStateChange data for change state of revision of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {number} [assignTo] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointChangeStateRevision: (id_1, revStateChange_1, apVersion_1, assignTo_1, ...args_1) => __awaiter(this, [id_1, revStateChange_1, apVersion_1, assignTo_1, ...args_1], void 0, function* (id, revStateChange, apVersion, assignTo, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointChangeStateRevision', 'id', id);
            // verify required parameter 'revStateChange' is not null or undefined
            assertParamExists('accessPointChangeStateRevision', 'revStateChange', revStateChange);
            const localVarPath = `/accesspoint/{id}/revision/state`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            if (assignTo !== undefined) {
                localVarQueryParameter['assignTo'] = assignTo;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(revStateChange, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Copying an archive entity
         * @param {string} id id of accesspoint
         * @param {CopyAccessPointDetail} copyAccessPointDetail additional copy options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCopyAccessPoint: (id_1, copyAccessPointDetail_1, ...args_1) => __awaiter(this, [id_1, copyAccessPointDetail_1, ...args_1], void 0, function* (id, copyAccessPointDetail, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointCopyAccessPoint', 'id', id);
            // verify required parameter 'copyAccessPointDetail' is not null or undefined
            assertParamExists('accessPointCopyAccessPoint', 'copyAccessPointDetail', copyAccessPointDetail);
            const localVarPath = `/accesspoint/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(copyAccessPointDetail, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create new part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {object} body data for creating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCreatePart: (id_1, body_1, apVersion_1, ...args_1) => __awaiter(this, [id_1, body_1, apVersion_1, ...args_1], void 0, function* (id, body, apVersion, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointCreatePart', 'id', id);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accessPointCreatePart', 'body', body);
            const localVarPath = `/accesspoint/{id}/part`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creating a new revision of access point
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCreateRevision: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointCreateRevision', 'id', id);
            const localVarPath = `/accesspoint/{id}/revision`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invalidation of access point (delete/replace)
         * @param {string} id id of accesspoint
         * @param {DeleteAccessPointDetail} [deleteAccessPointDetail] addition for method of invalidation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteAccessPoint: (id_1, deleteAccessPointDetail_1, ...args_1) => __awaiter(this, [id_1, deleteAccessPointDetail_1, ...args_1], void 0, function* (id, deleteAccessPointDetail, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointDeleteAccessPoint', 'id', id);
            const localVarPath = `/accesspoint/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAccessPointDetail, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invalidation of access points
         * @param {DeleteAccessPointsDetail} deleteAccessPointsDetail seznam ID nebo UUID, které chceme smazat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteAccessPoints: (deleteAccessPointsDetail_1, ...args_1) => __awaiter(this, [deleteAccessPointsDetail_1, ...args_1], void 0, function* (deleteAccessPointsDetail, options = {}) {
            // verify required parameter 'deleteAccessPointsDetail' is not null or undefined
            assertParamExists('accessPointDeleteAccessPoints', 'deleteAccessPointsDetail', deleteAccessPointsDetail);
            const localVarPath = `/accesspoint`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAccessPointsDetail, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeletePart: (id_1, partId_1, apVersion_1, ...args_1) => __awaiter(this, [id_1, partId_1, apVersion_1, ...args_1], void 0, function* (id, partId, apVersion, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointDeletePart', 'id', id);
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('accessPointDeletePart', 'partId', partId);
            const localVarPath = `/accesspoint/{id}/part/{partId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deleting a revision of access point
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteRevision: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointDeleteRevision', 'id', id);
            const localVarPath = `/accesspoint/{id}/revision`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete part of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of revision
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteRevisionPart: (id_1, partId_1, apVersion_1, ...args_1) => __awaiter(this, [id_1, partId_1, apVersion_1, ...args_1], void 0, function* (id, partId, apVersion, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointDeleteRevisionPart', 'id', id);
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('accessPointDeleteRevisionPart', 'partId', partId);
            const localVarPath = `/accesspoint/{id}/revision/part/{partId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Decision on forced export ELZA -> CAM
         * @param {number} queueItemId id of queue
         * @param {boolean} force force export: yes or no
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointExportForceOrNo: (queueItemId_1, force_1, ...args_1) => __awaiter(this, [queueItemId_1, force_1, ...args_1], void 0, function* (queueItemId, force, options = {}) {
            // verify required parameter 'queueItemId' is not null or undefined
            assertParamExists('accessPointExportForceOrNo', 'queueItemId', queueItemId);
            // verify required parameter 'force' is not null or undefined
            assertParamExists('accessPointExportForceOrNo', 'force', force);
            const localVarPath = `/accesspoint/export/{queueItemId}`
                .replace(`{${"queueItemId"}}`, encodeURIComponent(String(queueItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List of automatically generated elements of the description
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetAutoitems: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointGetAutoitems', 'id', id);
            const localVarPath = `/accesspoint/{id}/autoitems`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get invalidated (deleted) entities
         * @param {number} [page] number of the page
         * @param {number} [pageSize] page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetInvalidatedEntities: (page_1, pageSize_1, ...args_1) => __awaiter(this, [page_1, pageSize_1, ...args_1], void 0, function* (page, pageSize, options = {}) {
            const localVarPath = `/accesspoint/invalidated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a list of entity processors
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetLastParticipants: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointGetLastParticipants', 'id', id);
            const localVarPath = `/accesspoint/{id}/lastParticipants`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List of automatically generated description elements for revision
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetRevAutoitems: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointGetRevAutoitems', 'id', id);
            const localVarPath = `/accesspoint/{id}/revision/autoitems`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Merge ApRevision & ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {ApStateUpdate} apStateUpdate data for change ApState
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointMergeRevision: (id_1, apStateUpdate_1, apVersion_1, ...args_1) => __awaiter(this, [id_1, apStateUpdate_1, apVersion_1, ...args_1], void 0, function* (id, apStateUpdate, apVersion, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointMergeRevision', 'id', id);
            // verify required parameter 'apStateUpdate' is not null or undefined
            assertParamExists('accessPointMergeRevision', 'apStateUpdate', apStateUpdate);
            const localVarPath = `/accesspoint/{id}/revision/merge`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(apStateUpdate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Restore deleted entity and return to original state
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointRestoreAccessPoint: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointRestoreAccessPoint', 'id', id);
            const localVarPath = `/accesspoint/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search for access points. Accepts the same filter inputs as /accesspoint/export (scalar fields + ApAdvanceSearchFilter) plus pagination (from, count) and the criteria-query SearchType selectors.
         * @param {AccessPointSearchParams} accessPointSearchParams filter selecting the access points to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSearch: (accessPointSearchParams_1, ...args_1) => __awaiter(this, [accessPointSearchParams_1, ...args_1], void 0, function* (accessPointSearchParams, options = {}) {
            // verify required parameter 'accessPointSearchParams' is not null or undefined
            assertParamExists('accessPointSearch', 'accessPointSearchParams', accessPointSearchParams);
            const localVarPath = `/accesspoint/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accessPointSearchParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Set the preferred name of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSetPreferName: (id_1, partId_1, apVersion_1, ...args_1) => __awaiter(this, [id_1, partId_1, apVersion_1, ...args_1], void 0, function* (id, partId, apVersion, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointSetPreferName', 'id', id);
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('accessPointSetPreferName', 'partId', partId);
            const localVarPath = `/accesspoint/{id}/part/{partId}/prefer-name`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Set the preferred name of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of revision
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSetPreferNameRevision: (id_1, partId_1, apVersion_1, ...args_1) => __awaiter(this, [id_1, partId_1, apVersion_1, ...args_1], void 0, function* (id, partId, apVersion, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointSetPreferNameRevision', 'id', id);
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('accessPointSetPreferNameRevision', 'partId', partId);
            const localVarPath = `/accesspoint/{id}/revision/part/{partId}/prefer-name`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId id of part
         * @param {object} body data for updating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointUpdatePart: (id_1, partId_1, body_1, apVersion_1, ...args_1) => __awaiter(this, [id_1, partId_1, body_1, apVersion_1, ...args_1], void 0, function* (id, partId, body, apVersion, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointUpdatePart', 'id', id);
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('accessPointUpdatePart', 'partId', partId);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accessPointUpdatePart', 'body', body);
            const localVarPath = `/accesspoint/{id}/part/{partId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a revision part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} revPartId id of revision part
         * @param {object} body data for updating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointUpdateRevisionPart: (id_1, revPartId_1, body_1, apVersion_1, ...args_1) => __awaiter(this, [id_1, revPartId_1, body_1, apVersion_1, ...args_1], void 0, function* (id, revPartId, body, apVersion, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointUpdateRevisionPart', 'id', id);
            // verify required parameter 'revPartId' is not null or undefined
            assertParamExists('accessPointUpdateRevisionPart', 'revPartId', revPartId);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('accessPointUpdateRevisionPart', 'body', body);
            const localVarPath = `/accesspoint/{id}/revision/part/{revPartId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"revPartId"}}`, encodeURIComponent(String(revPartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apVersion !== undefined) {
                localVarQueryParameter['apVersion'] = apVersion;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Validation of an archive entity
         * @param {number} id id of accesspoint
         * @param {boolean} [includeRevision] include revision
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointValidateAccessPoint: (id_1, includeRevision_1, ...args_1) => __awaiter(this, [id_1, includeRevision_1, ...args_1], void 0, function* (id, includeRevision, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessPointValidateAccessPoint', 'id', id);
            const localVarPath = `/accesspoint/{id}/validate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeRevision !== undefined) {
                localVarQueryParameter['includeRevision'] = includeRevision;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AccesspointsApi - functional programming interface
 */
export const AccesspointsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccesspointsApiAxiosParamCreator(configuration);
    return {
        /**
         * Asynchronously export access points matching the given filter to CSV.  Returns the request id; poll /io/export-status/{id} and download the result via /io/file/{id}. Results are ordered by accessPointId ascending. Empty body / null fields means \"all access points visible to the user\".
         * @param {AccessPointBatchExportParams} accessPointBatchExportParams filter selecting the access points to export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointBatchExport(accessPointBatchExportParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointBatchExport(accessPointBatchExportParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointBatchExport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Change state of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {ApStateUpdate} apStateUpdate data for change ApState
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {number} [assignTo] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointChangeState(id, apStateUpdate, apVersion, assignTo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointChangeState(id, apStateUpdate, apVersion, assignTo, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointChangeState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Change state of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {RevStateChange} revStateChange data for change state of revision of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {number} [assignTo] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointChangeStateRevision(id, revStateChange, apVersion, assignTo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointChangeStateRevision(id, revStateChange, apVersion, assignTo, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointChangeStateRevision']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Copying an archive entity
         * @param {string} id id of accesspoint
         * @param {CopyAccessPointDetail} copyAccessPointDetail additional copy options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCopyAccessPoint(id, copyAccessPointDetail, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointCopyAccessPoint(id, copyAccessPointDetail, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointCopyAccessPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create new part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {object} body data for creating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCreatePart(id, body, apVersion, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointCreatePart(id, body, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointCreatePart']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creating a new revision of access point
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCreateRevision(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointCreateRevision(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointCreateRevision']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Invalidation of access point (delete/replace)
         * @param {string} id id of accesspoint
         * @param {DeleteAccessPointDetail} [deleteAccessPointDetail] addition for method of invalidation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteAccessPoint(id, deleteAccessPointDetail, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointDeleteAccessPoint(id, deleteAccessPointDetail, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointDeleteAccessPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Invalidation of access points
         * @param {DeleteAccessPointsDetail} deleteAccessPointsDetail seznam ID nebo UUID, které chceme smazat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteAccessPoints(deleteAccessPointsDetail, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointDeleteAccessPoints(deleteAccessPointsDetail, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointDeleteAccessPoints']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeletePart(id, partId, apVersion, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointDeletePart(id, partId, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointDeletePart']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deleting a revision of access point
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteRevision(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointDeleteRevision(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointDeleteRevision']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete part of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of revision
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteRevisionPart(id, partId, apVersion, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointDeleteRevisionPart(id, partId, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointDeleteRevisionPart']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Decision on forced export ELZA -> CAM
         * @param {number} queueItemId id of queue
         * @param {boolean} force force export: yes or no
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointExportForceOrNo(queueItemId, force, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointExportForceOrNo(queueItemId, force, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointExportForceOrNo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * List of automatically generated elements of the description
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetAutoitems(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointGetAutoitems(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointGetAutoitems']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get invalidated (deleted) entities
         * @param {number} [page] number of the page
         * @param {number} [pageSize] page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetInvalidatedEntities(page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointGetInvalidatedEntities(page, pageSize, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointGetInvalidatedEntities']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get a list of entity processors
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetLastParticipants(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointGetLastParticipants(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointGetLastParticipants']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * List of automatically generated description elements for revision
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetRevAutoitems(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointGetRevAutoitems(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointGetRevAutoitems']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Merge ApRevision & ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {ApStateUpdate} apStateUpdate data for change ApState
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointMergeRevision(id, apStateUpdate, apVersion, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointMergeRevision(id, apStateUpdate, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointMergeRevision']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Restore deleted entity and return to original state
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointRestoreAccessPoint(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointRestoreAccessPoint(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointRestoreAccessPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Search for access points. Accepts the same filter inputs as /accesspoint/export (scalar fields + ApAdvanceSearchFilter) plus pagination (from, count) and the criteria-query SearchType selectors.
         * @param {AccessPointSearchParams} accessPointSearchParams filter selecting the access points to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSearch(accessPointSearchParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointSearch(accessPointSearchParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Set the preferred name of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSetPreferName(id, partId, apVersion, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointSetPreferName(id, partId, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointSetPreferName']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Set the preferred name of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of revision
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSetPreferNameRevision(id, partId, apVersion, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointSetPreferNameRevision(id, partId, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointSetPreferNameRevision']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update a part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId id of part
         * @param {object} body data for updating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointUpdatePart(id, partId, body, apVersion, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointUpdatePart(id, partId, body, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointUpdatePart']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update a revision part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} revPartId id of revision part
         * @param {object} body data for updating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointUpdateRevisionPart(id, revPartId, body, apVersion, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointUpdateRevisionPart(id, revPartId, body, apVersion, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointUpdateRevisionPart']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Validation of an archive entity
         * @param {number} id id of accesspoint
         * @param {boolean} [includeRevision] include revision
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointValidateAccessPoint(id, includeRevision, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPointValidateAccessPoint(id, includeRevision, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccesspointsApi.accessPointValidateAccessPoint']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AccesspointsApi - factory interface
 */
export const AccesspointsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccesspointsApiFp(configuration);
    return {
        /**
         * Asynchronously export access points matching the given filter to CSV.  Returns the request id; poll /io/export-status/{id} and download the result via /io/file/{id}. Results are ordered by accessPointId ascending. Empty body / null fields means \"all access points visible to the user\".
         * @param {AccessPointBatchExportParams} accessPointBatchExportParams filter selecting the access points to export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointBatchExport(accessPointBatchExportParams, options) {
            return localVarFp.accessPointBatchExport(accessPointBatchExportParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Change state of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {ApStateUpdate} apStateUpdate data for change ApState
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {number} [assignTo] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointChangeState(id, apStateUpdate, apVersion, assignTo, options) {
            return localVarFp.accessPointChangeState(id, apStateUpdate, apVersion, assignTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Change state of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {RevStateChange} revStateChange data for change state of revision of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {number} [assignTo] userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointChangeStateRevision(id, revStateChange, apVersion, assignTo, options) {
            return localVarFp.accessPointChangeStateRevision(id, revStateChange, apVersion, assignTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Copying an archive entity
         * @param {string} id id of accesspoint
         * @param {CopyAccessPointDetail} copyAccessPointDetail additional copy options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCopyAccessPoint(id, copyAccessPointDetail, options) {
            return localVarFp.accessPointCopyAccessPoint(id, copyAccessPointDetail, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {object} body data for creating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCreatePart(id, body, apVersion, options) {
            return localVarFp.accessPointCreatePart(id, body, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Creating a new revision of access point
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointCreateRevision(id, options) {
            return localVarFp.accessPointCreateRevision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Invalidation of access point (delete/replace)
         * @param {string} id id of accesspoint
         * @param {DeleteAccessPointDetail} [deleteAccessPointDetail] addition for method of invalidation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteAccessPoint(id, deleteAccessPointDetail, options) {
            return localVarFp.accessPointDeleteAccessPoint(id, deleteAccessPointDetail, options).then((request) => request(axios, basePath));
        },
        /**
         * Invalidation of access points
         * @param {DeleteAccessPointsDetail} deleteAccessPointsDetail seznam ID nebo UUID, které chceme smazat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteAccessPoints(deleteAccessPointsDetail, options) {
            return localVarFp.accessPointDeleteAccessPoints(deleteAccessPointsDetail, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeletePart(id, partId, apVersion, options) {
            return localVarFp.accessPointDeletePart(id, partId, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Deleting a revision of access point
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteRevision(id, options) {
            return localVarFp.accessPointDeleteRevision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete part of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of revision
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointDeleteRevisionPart(id, partId, apVersion, options) {
            return localVarFp.accessPointDeleteRevisionPart(id, partId, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Decision on forced export ELZA -> CAM
         * @param {number} queueItemId id of queue
         * @param {boolean} force force export: yes or no
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointExportForceOrNo(queueItemId, force, options) {
            return localVarFp.accessPointExportForceOrNo(queueItemId, force, options).then((request) => request(axios, basePath));
        },
        /**
         * List of automatically generated elements of the description
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetAutoitems(id, options) {
            return localVarFp.accessPointGetAutoitems(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get invalidated (deleted) entities
         * @param {number} [page] number of the page
         * @param {number} [pageSize] page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetInvalidatedEntities(page, pageSize, options) {
            return localVarFp.accessPointGetInvalidatedEntities(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of entity processors
         * @param {number} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetLastParticipants(id, options) {
            return localVarFp.accessPointGetLastParticipants(id, options).then((request) => request(axios, basePath));
        },
        /**
         * List of automatically generated description elements for revision
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointGetRevAutoitems(id, options) {
            return localVarFp.accessPointGetRevAutoitems(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Merge ApRevision & ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {ApStateUpdate} apStateUpdate data for change ApState
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointMergeRevision(id, apStateUpdate, apVersion, options) {
            return localVarFp.accessPointMergeRevision(id, apStateUpdate, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Restore deleted entity and return to original state
         * @param {string} id id of accesspoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointRestoreAccessPoint(id, options) {
            return localVarFp.accessPointRestoreAccessPoint(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for access points. Accepts the same filter inputs as /accesspoint/export (scalar fields + ApAdvanceSearchFilter) plus pagination (from, count) and the criteria-query SearchType selectors.
         * @param {AccessPointSearchParams} accessPointSearchParams filter selecting the access points to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSearch(accessPointSearchParams, options) {
            return localVarFp.accessPointSearch(accessPointSearchParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the preferred name of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of ApAccessPoint
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSetPreferName(id, partId, apVersion, options) {
            return localVarFp.accessPointSetPreferName(id, partId, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the preferred name of revision of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId partId of revision
         * @param {number} [apVersion] actual version of ApAccessPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointSetPreferNameRevision(id, partId, apVersion, options) {
            return localVarFp.accessPointSetPreferNameRevision(id, partId, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} partId id of part
         * @param {object} body data for updating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointUpdatePart(id, partId, body, apVersion, options) {
            return localVarFp.accessPointUpdatePart(id, partId, body, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a revision part of ApAccessPoint
         * @param {number} id id of accesspoint
         * @param {number} revPartId id of revision part
         * @param {object} body data for updating a part
         * @param {number} [apVersion] accesspoint version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointUpdateRevisionPart(id, revPartId, body, apVersion, options) {
            return localVarFp.accessPointUpdateRevisionPart(id, revPartId, body, apVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Validation of an archive entity
         * @param {number} id id of accesspoint
         * @param {boolean} [includeRevision] include revision
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPointValidateAccessPoint(id, includeRevision, options) {
            return localVarFp.accessPointValidateAccessPoint(id, includeRevision, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccesspointsApi - object-oriented interface
 */
export class AccesspointsApi extends BaseAPI {
    /**
     * Asynchronously export access points matching the given filter to CSV.  Returns the request id; poll /io/export-status/{id} and download the result via /io/file/{id}. Results are ordered by accessPointId ascending. Empty body / null fields means \"all access points visible to the user\".
     * @param {AccessPointBatchExportParams} accessPointBatchExportParams filter selecting the access points to export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointBatchExport(accessPointBatchExportParams, options) {
        return AccesspointsApiFp(this.configuration).accessPointBatchExport(accessPointBatchExportParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Change state of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {ApStateUpdate} apStateUpdate data for change ApState
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {number} [assignTo] userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointChangeState(id, apStateUpdate, apVersion, assignTo, options) {
        return AccesspointsApiFp(this.configuration).accessPointChangeState(id, apStateUpdate, apVersion, assignTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Change state of revision of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {RevStateChange} revStateChange data for change state of revision of ApAccessPoint
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {number} [assignTo] userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointChangeStateRevision(id, revStateChange, apVersion, assignTo, options) {
        return AccesspointsApiFp(this.configuration).accessPointChangeStateRevision(id, revStateChange, apVersion, assignTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Copying an archive entity
     * @param {string} id id of accesspoint
     * @param {CopyAccessPointDetail} copyAccessPointDetail additional copy options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointCopyAccessPoint(id, copyAccessPointDetail, options) {
        return AccesspointsApiFp(this.configuration).accessPointCopyAccessPoint(id, copyAccessPointDetail, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create new part of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {object} body data for creating a part
     * @param {number} [apVersion] accesspoint version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointCreatePart(id, body, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointCreatePart(id, body, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creating a new revision of access point
     * @param {number} id id of accesspoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointCreateRevision(id, options) {
        return AccesspointsApiFp(this.configuration).accessPointCreateRevision(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Invalidation of access point (delete/replace)
     * @param {string} id id of accesspoint
     * @param {DeleteAccessPointDetail} [deleteAccessPointDetail] addition for method of invalidation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointDeleteAccessPoint(id, deleteAccessPointDetail, options) {
        return AccesspointsApiFp(this.configuration).accessPointDeleteAccessPoint(id, deleteAccessPointDetail, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Invalidation of access points
     * @param {DeleteAccessPointsDetail} deleteAccessPointsDetail seznam ID nebo UUID, které chceme smazat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointDeleteAccessPoints(deleteAccessPointsDetail, options) {
        return AccesspointsApiFp(this.configuration).accessPointDeleteAccessPoints(deleteAccessPointsDetail, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete part of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {number} partId partId of ApAccessPoint
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointDeletePart(id, partId, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointDeletePart(id, partId, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deleting a revision of access point
     * @param {number} id id of accesspoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointDeleteRevision(id, options) {
        return AccesspointsApiFp(this.configuration).accessPointDeleteRevision(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete part of revision of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {number} partId partId of revision
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointDeleteRevisionPart(id, partId, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointDeleteRevisionPart(id, partId, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Decision on forced export ELZA -> CAM
     * @param {number} queueItemId id of queue
     * @param {boolean} force force export: yes or no
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointExportForceOrNo(queueItemId, force, options) {
        return AccesspointsApiFp(this.configuration).accessPointExportForceOrNo(queueItemId, force, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List of automatically generated elements of the description
     * @param {string} id id of accesspoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointGetAutoitems(id, options) {
        return AccesspointsApiFp(this.configuration).accessPointGetAutoitems(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get invalidated (deleted) entities
     * @param {number} [page] number of the page
     * @param {number} [pageSize] page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointGetInvalidatedEntities(page, pageSize, options) {
        return AccesspointsApiFp(this.configuration).accessPointGetInvalidatedEntities(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a list of entity processors
     * @param {number} id id of accesspoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointGetLastParticipants(id, options) {
        return AccesspointsApiFp(this.configuration).accessPointGetLastParticipants(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List of automatically generated description elements for revision
     * @param {string} id id of accesspoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointGetRevAutoitems(id, options) {
        return AccesspointsApiFp(this.configuration).accessPointGetRevAutoitems(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Merge ApRevision & ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {ApStateUpdate} apStateUpdate data for change ApState
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointMergeRevision(id, apStateUpdate, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointMergeRevision(id, apStateUpdate, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Restore deleted entity and return to original state
     * @param {string} id id of accesspoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointRestoreAccessPoint(id, options) {
        return AccesspointsApiFp(this.configuration).accessPointRestoreAccessPoint(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for access points. Accepts the same filter inputs as /accesspoint/export (scalar fields + ApAdvanceSearchFilter) plus pagination (from, count) and the criteria-query SearchType selectors.
     * @param {AccessPointSearchParams} accessPointSearchParams filter selecting the access points to search for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointSearch(accessPointSearchParams, options) {
        return AccesspointsApiFp(this.configuration).accessPointSearch(accessPointSearchParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set the preferred name of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {number} partId partId of ApAccessPoint
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointSetPreferName(id, partId, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointSetPreferName(id, partId, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set the preferred name of revision of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {number} partId partId of revision
     * @param {number} [apVersion] actual version of ApAccessPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointSetPreferNameRevision(id, partId, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointSetPreferNameRevision(id, partId, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a part of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {number} partId id of part
     * @param {object} body data for updating a part
     * @param {number} [apVersion] accesspoint version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointUpdatePart(id, partId, body, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointUpdatePart(id, partId, body, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a revision part of ApAccessPoint
     * @param {number} id id of accesspoint
     * @param {number} revPartId id of revision part
     * @param {object} body data for updating a part
     * @param {number} [apVersion] accesspoint version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointUpdateRevisionPart(id, revPartId, body, apVersion, options) {
        return AccesspointsApiFp(this.configuration).accessPointUpdateRevisionPart(id, revPartId, body, apVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Validation of an archive entity
     * @param {number} id id of accesspoint
     * @param {boolean} [includeRevision] include revision
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessPointValidateAccessPoint(id, includeRevision, options) {
        return AccesspointsApiFp(this.configuration).accessPointValidateAccessPoint(id, includeRevision, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminApi - axios parameter creator
 */
export const AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Copy user permissions from another user  Method will append all permissions to given user
         * @param {number} userId ID of target user
         * @param {AdminCopyPermissionParams} adminCopyPermissionParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCopyPermissions: (userId_1, adminCopyPermissionParams_1, ...args_1) => __awaiter(this, [userId_1, adminCopyPermissionParams_1, ...args_1], void 0, function* (userId, adminCopyPermissionParams, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminCopyPermissions', 'userId', userId);
            // verify required parameter 'adminCopyPermissionParams' is not null or undefined
            assertParamExists('adminCopyPermissions', 'adminCopyPermissionParams', adminCopyPermissionParams);
            const localVarPath = `/admin/user/{userId}/copy-permissions`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminCopyPermissionParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invalidate inhibited items (arr_inhibited_item) whose source desc item no longer lies on an ancestor node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteInvalidInhibitedItems: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/admin/arrangement/invalid-inhibited-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return basic statistical info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminInfo: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/admin/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return list of logged users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLoggedUsers: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/admin/info/logged-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creating missing items in arr_cached_node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSyncNodeCache: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/admin/arrangement/missing-cached-nodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminApi - functional programming interface
 */
export const AdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration);
    return {
        /**
         * Copy user permissions from another user  Method will append all permissions to given user
         * @param {number} userId ID of target user
         * @param {AdminCopyPermissionParams} adminCopyPermissionParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCopyPermissions(userId, adminCopyPermissionParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCopyPermissions(userId, adminCopyPermissionParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AdminApi.adminCopyPermissions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Invalidate inhibited items (arr_inhibited_item) whose source desc item no longer lies on an ancestor node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteInvalidInhibitedItems(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminDeleteInvalidInhibitedItems(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AdminApi.adminDeleteInvalidInhibitedItems']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return basic statistical info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminInfo(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminInfo(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AdminApi.adminInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return list of logged users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLoggedUsers(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminLoggedUsers(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AdminApi.adminLoggedUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creating missing items in arr_cached_node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSyncNodeCache(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminSyncNodeCache(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AdminApi.adminSyncNodeCache']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AdminApi - factory interface
 */
export const AdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminApiFp(configuration);
    return {
        /**
         * Copy user permissions from another user  Method will append all permissions to given user
         * @param {number} userId ID of target user
         * @param {AdminCopyPermissionParams} adminCopyPermissionParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCopyPermissions(userId, adminCopyPermissionParams, options) {
            return localVarFp.adminCopyPermissions(userId, adminCopyPermissionParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Invalidate inhibited items (arr_inhibited_item) whose source desc item no longer lies on an ancestor node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteInvalidInhibitedItems(options) {
            return localVarFp.adminDeleteInvalidInhibitedItems(options).then((request) => request(axios, basePath));
        },
        /**
         * Return basic statistical info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminInfo(options) {
            return localVarFp.adminInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of logged users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLoggedUsers(options) {
            return localVarFp.adminLoggedUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * Creating missing items in arr_cached_node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSyncNodeCache(options) {
            return localVarFp.adminSyncNodeCache(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminApi - object-oriented interface
 */
export class AdminApi extends BaseAPI {
    /**
     * Copy user permissions from another user  Method will append all permissions to given user
     * @param {number} userId ID of target user
     * @param {AdminCopyPermissionParams} adminCopyPermissionParams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminCopyPermissions(userId, adminCopyPermissionParams, options) {
        return AdminApiFp(this.configuration).adminCopyPermissions(userId, adminCopyPermissionParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Invalidate inhibited items (arr_inhibited_item) whose source desc item no longer lies on an ancestor node
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminDeleteInvalidInhibitedItems(options) {
        return AdminApiFp(this.configuration).adminDeleteInvalidInhibitedItems(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return basic statistical info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminInfo(options) {
        return AdminApiFp(this.configuration).adminInfo(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return list of logged users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminLoggedUsers(options) {
        return AdminApiFp(this.configuration).adminLoggedUsers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creating missing items in arr_cached_node
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminSyncNodeCache(options) {
        return AdminApiFp(this.configuration).adminSyncNodeCache(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AiproviderApi - axios parameter creator
 */
export const AiproviderApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Cancels a running exchange (best effort; usage already incurred is kept).
         * @param {number} id request id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderCancelRequest: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('aiProviderCancelRequest', 'id', id);
            const localVarPath = `/aiprovider/request/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Starts a new AI conversation: creates the thread, stores and submits its first exchange to the configured provider. State changes are then announced over the WebSocket (event AI_REQUEST carrying conversation and request ids + new state); the client refetches the conversation detail.
         * @param {AiConversationCreate} aiConversationCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderCreateConversation: (aiConversationCreate_1, ...args_1) => __awaiter(this, [aiConversationCreate_1, ...args_1], void 0, function* (aiConversationCreate, options = {}) {
            // verify required parameter 'aiConversationCreate' is not null or undefined
            assertParamExists('aiProviderCreateConversation', 'aiConversationCreate', aiConversationCreate);
            const localVarPath = `/aiprovider/conversation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(aiConversationCreate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Submits a follow-up exchange into an existing conversation (continues the provider-side conversation context).
         * @param {number} id conversation id
         * @param {AiRequestCreate} aiRequestCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderCreateRequest: (id_1, aiRequestCreate_1, ...args_1) => __awaiter(this, [id_1, aiRequestCreate_1, ...args_1], void 0, function* (id, aiRequestCreate, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('aiProviderCreateRequest', 'id', id);
            // verify required parameter 'aiRequestCreate' is not null or undefined
            assertParamExists('aiProviderCreateRequest', 'aiRequestCreate', aiRequestCreate);
            const localVarPath = `/aiprovider/conversation/{id}/request`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(aiRequestCreate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Full refresh of one conversation: the thread with all its exchanges, states and render-ready blocks.
         * @param {number} id conversation id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderGetConversation: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('aiProviderGetConversation', 'id', id);
            const localVarPath = `/aiprovider/conversation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Reads the AI provider\'s service info (protocol version, supported task types, profiles, limits) via the provider\'s GET /info. Doubles as the connection test of the configured AI external system. The response is the provider\'s info document passed through as-is.
         * @param {string} id AI external system ID or CODE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderGetInfo: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('aiProviderGetInfo', 'id', id);
            const localVarPath = `/aiprovider/{id}/info`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The user\'s usage/credit balance at the AI provider, read via the provider\'s GET /usage under the same key selection as task submission (the user\'s personal key when stored, else the instance-wide one). For panel display; refresh after a finished exchange or a quota refusal.
         * @param {string} id AI external system ID or CODE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderGetUsage: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('aiProviderGetUsage', 'id', id);
            const localVarPath = `/aiprovider/{id}/usage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Lists the current user\'s conversations, newest activity first; optionally filtered by context.
         * @param {string} [contextType] context type code filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderListConversations: (contextType_1, ...args_1) => __awaiter(this, [contextType_1, ...args_1], void 0, function* (contextType, options = {}) {
            const localVarPath = `/aiprovider/conversation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (contextType !== undefined) {
                localVarQueryParameter['contextType'] = contextType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * The exchange log of one request — each step with its payload (what exactly was sent to the provider / what came back).
         * @param {number} id request id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderListRequestEvents: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('aiProviderListRequestEvents', 'id', id);
            const localVarPath = `/aiprovider/request/{id}/event`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AiproviderApi - functional programming interface
 */
export const AiproviderApiFp = function (configuration) {
    const localVarAxiosParamCreator = AiproviderApiAxiosParamCreator(configuration);
    return {
        /**
         * Cancels a running exchange (best effort; usage already incurred is kept).
         * @param {number} id request id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderCancelRequest(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiProviderCancelRequest(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AiproviderApi.aiProviderCancelRequest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Starts a new AI conversation: creates the thread, stores and submits its first exchange to the configured provider. State changes are then announced over the WebSocket (event AI_REQUEST carrying conversation and request ids + new state); the client refetches the conversation detail.
         * @param {AiConversationCreate} aiConversationCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderCreateConversation(aiConversationCreate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiProviderCreateConversation(aiConversationCreate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AiproviderApi.aiProviderCreateConversation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Submits a follow-up exchange into an existing conversation (continues the provider-side conversation context).
         * @param {number} id conversation id
         * @param {AiRequestCreate} aiRequestCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderCreateRequest(id, aiRequestCreate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiProviderCreateRequest(id, aiRequestCreate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AiproviderApi.aiProviderCreateRequest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Full refresh of one conversation: the thread with all its exchanges, states and render-ready blocks.
         * @param {number} id conversation id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderGetConversation(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiProviderGetConversation(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AiproviderApi.aiProviderGetConversation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Reads the AI provider\'s service info (protocol version, supported task types, profiles, limits) via the provider\'s GET /info. Doubles as the connection test of the configured AI external system. The response is the provider\'s info document passed through as-is.
         * @param {string} id AI external system ID or CODE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderGetInfo(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiProviderGetInfo(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AiproviderApi.aiProviderGetInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * The user\'s usage/credit balance at the AI provider, read via the provider\'s GET /usage under the same key selection as task submission (the user\'s personal key when stored, else the instance-wide one). For panel display; refresh after a finished exchange or a quota refusal.
         * @param {string} id AI external system ID or CODE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderGetUsage(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiProviderGetUsage(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AiproviderApi.aiProviderGetUsage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Lists the current user\'s conversations, newest activity first; optionally filtered by context.
         * @param {string} [contextType] context type code filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderListConversations(contextType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiProviderListConversations(contextType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AiproviderApi.aiProviderListConversations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * The exchange log of one request — each step with its payload (what exactly was sent to the provider / what came back).
         * @param {number} id request id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderListRequestEvents(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aiProviderListRequestEvents(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AiproviderApi.aiProviderListRequestEvents']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AiproviderApi - factory interface
 */
export const AiproviderApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AiproviderApiFp(configuration);
    return {
        /**
         * Cancels a running exchange (best effort; usage already incurred is kept).
         * @param {number} id request id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderCancelRequest(id, options) {
            return localVarFp.aiProviderCancelRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a new AI conversation: creates the thread, stores and submits its first exchange to the configured provider. State changes are then announced over the WebSocket (event AI_REQUEST carrying conversation and request ids + new state); the client refetches the conversation detail.
         * @param {AiConversationCreate} aiConversationCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderCreateConversation(aiConversationCreate, options) {
            return localVarFp.aiProviderCreateConversation(aiConversationCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Submits a follow-up exchange into an existing conversation (continues the provider-side conversation context).
         * @param {number} id conversation id
         * @param {AiRequestCreate} aiRequestCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderCreateRequest(id, aiRequestCreate, options) {
            return localVarFp.aiProviderCreateRequest(id, aiRequestCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Full refresh of one conversation: the thread with all its exchanges, states and render-ready blocks.
         * @param {number} id conversation id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderGetConversation(id, options) {
            return localVarFp.aiProviderGetConversation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the AI provider\'s service info (protocol version, supported task types, profiles, limits) via the provider\'s GET /info. Doubles as the connection test of the configured AI external system. The response is the provider\'s info document passed through as-is.
         * @param {string} id AI external system ID or CODE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderGetInfo(id, options) {
            return localVarFp.aiProviderGetInfo(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The user\'s usage/credit balance at the AI provider, read via the provider\'s GET /usage under the same key selection as task submission (the user\'s personal key when stored, else the instance-wide one). For panel display; refresh after a finished exchange or a quota refusal.
         * @param {string} id AI external system ID or CODE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderGetUsage(id, options) {
            return localVarFp.aiProviderGetUsage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists the current user\'s conversations, newest activity first; optionally filtered by context.
         * @param {string} [contextType] context type code filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderListConversations(contextType, options) {
            return localVarFp.aiProviderListConversations(contextType, options).then((request) => request(axios, basePath));
        },
        /**
         * The exchange log of one request — each step with its payload (what exactly was sent to the provider / what came back).
         * @param {number} id request id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiProviderListRequestEvents(id, options) {
            return localVarFp.aiProviderListRequestEvents(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AiproviderApi - object-oriented interface
 */
export class AiproviderApi extends BaseAPI {
    /**
     * Cancels a running exchange (best effort; usage already incurred is kept).
     * @param {number} id request id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiProviderCancelRequest(id, options) {
        return AiproviderApiFp(this.configuration).aiProviderCancelRequest(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Starts a new AI conversation: creates the thread, stores and submits its first exchange to the configured provider. State changes are then announced over the WebSocket (event AI_REQUEST carrying conversation and request ids + new state); the client refetches the conversation detail.
     * @param {AiConversationCreate} aiConversationCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiProviderCreateConversation(aiConversationCreate, options) {
        return AiproviderApiFp(this.configuration).aiProviderCreateConversation(aiConversationCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submits a follow-up exchange into an existing conversation (continues the provider-side conversation context).
     * @param {number} id conversation id
     * @param {AiRequestCreate} aiRequestCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiProviderCreateRequest(id, aiRequestCreate, options) {
        return AiproviderApiFp(this.configuration).aiProviderCreateRequest(id, aiRequestCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Full refresh of one conversation: the thread with all its exchanges, states and render-ready blocks.
     * @param {number} id conversation id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiProviderGetConversation(id, options) {
        return AiproviderApiFp(this.configuration).aiProviderGetConversation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Reads the AI provider\'s service info (protocol version, supported task types, profiles, limits) via the provider\'s GET /info. Doubles as the connection test of the configured AI external system. The response is the provider\'s info document passed through as-is.
     * @param {string} id AI external system ID or CODE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiProviderGetInfo(id, options) {
        return AiproviderApiFp(this.configuration).aiProviderGetInfo(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * The user\'s usage/credit balance at the AI provider, read via the provider\'s GET /usage under the same key selection as task submission (the user\'s personal key when stored, else the instance-wide one). For panel display; refresh after a finished exchange or a quota refusal.
     * @param {string} id AI external system ID or CODE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiProviderGetUsage(id, options) {
        return AiproviderApiFp(this.configuration).aiProviderGetUsage(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Lists the current user\'s conversations, newest activity first; optionally filtered by context.
     * @param {string} [contextType] context type code filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiProviderListConversations(contextType, options) {
        return AiproviderApiFp(this.configuration).aiProviderListConversations(contextType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * The exchange log of one request — each step with its payload (what exactly was sent to the provider / what came back).
     * @param {number} id request id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aiProviderListRequestEvents(id, options) {
        return AiproviderApiFp(this.configuration).aiProviderListRequestEvents(id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AipsApi - axios parameter creator
 */
export const AipsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Bulk connect logical structure to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {Array<number>} daAipIdList DaAip ID list
         * @param {number} daLevelViewId DaLevelView ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipBulkConnectLogicToJp: (arrNodeId_1, daAipIdList_1, daLevelViewId_1, ...args_1) => __awaiter(this, [arrNodeId_1, daAipIdList_1, daLevelViewId_1, ...args_1], void 0, function* (arrNodeId, daAipIdList, daLevelViewId, options = {}) {
            // verify required parameter 'arrNodeId' is not null or undefined
            assertParamExists('aipBulkConnectLogicToJp', 'arrNodeId', arrNodeId);
            // verify required parameter 'daAipIdList' is not null or undefined
            assertParamExists('aipBulkConnectLogicToJp', 'daAipIdList', daAipIdList);
            // verify required parameter 'daLevelViewId' is not null or undefined
            assertParamExists('aipBulkConnectLogicToJp', 'daLevelViewId', daLevelViewId);
            const localVarPath = `/aip/bulk-connect-logic-to-jp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (arrNodeId !== undefined) {
                localVarQueryParameter['arrNodeId'] = arrNodeId;
            }
            if (daAipIdList) {
                localVarQueryParameter['daAipIdList'] = daAipIdList.join(COLLECTION_FORMATS.csv);
            }
            if (daLevelViewId !== undefined) {
                localVarQueryParameter['daLevelViewId'] = daLevelViewId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Bulk connect to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {Array<number>} daAipIdList DaAip ID list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipBulkConnectToJp: (arrNodeId_1, daAipIdList_1, ...args_1) => __awaiter(this, [arrNodeId_1, daAipIdList_1, ...args_1], void 0, function* (arrNodeId, daAipIdList, options = {}) {
            // verify required parameter 'arrNodeId' is not null or undefined
            assertParamExists('aipBulkConnectToJp', 'arrNodeId', arrNodeId);
            // verify required parameter 'daAipIdList' is not null or undefined
            assertParamExists('aipBulkConnectToJp', 'daAipIdList', daAipIdList);
            const localVarPath = `/aip/bulk-connect-to-jp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (arrNodeId !== undefined) {
                localVarQueryParameter['arrNodeId'] = arrNodeId;
            }
            if (daAipIdList) {
                localVarQueryParameter['daAipIdList'] = daAipIdList.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Bulk create from selected
         * @param {number} arrNodeId ArrNode ID
         * @param {Array<number>} daAipIdList DaAip ID list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipBulkCreateFromSelected: (arrNodeId_1, daAipIdList_1, ...args_1) => __awaiter(this, [arrNodeId_1, daAipIdList_1, ...args_1], void 0, function* (arrNodeId, daAipIdList, options = {}) {
            // verify required parameter 'arrNodeId' is not null or undefined
            assertParamExists('aipBulkCreateFromSelected', 'arrNodeId', arrNodeId);
            // verify required parameter 'daAipIdList' is not null or undefined
            assertParamExists('aipBulkCreateFromSelected', 'daAipIdList', daAipIdList);
            const localVarPath = `/aip/bulk-create-from-selected`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (arrNodeId !== undefined) {
                localVarQueryParameter['arrNodeId'] = arrNodeId;
            }
            if (daAipIdList) {
                localVarQueryParameter['daAipIdList'] = daAipIdList.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Bulk create from selected and connect to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {Array<number>} daAipIdList DaAip ID list
         * @param {number} daLevelViewId DaLevelView ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipBulkCreateSelectedToJp: (arrNodeId_1, daAipIdList_1, daLevelViewId_1, ...args_1) => __awaiter(this, [arrNodeId_1, daAipIdList_1, daLevelViewId_1, ...args_1], void 0, function* (arrNodeId, daAipIdList, daLevelViewId, options = {}) {
            // verify required parameter 'arrNodeId' is not null or undefined
            assertParamExists('aipBulkCreateSelectedToJp', 'arrNodeId', arrNodeId);
            // verify required parameter 'daAipIdList' is not null or undefined
            assertParamExists('aipBulkCreateSelectedToJp', 'daAipIdList', daAipIdList);
            // verify required parameter 'daLevelViewId' is not null or undefined
            assertParamExists('aipBulkCreateSelectedToJp', 'daLevelViewId', daLevelViewId);
            const localVarPath = `/aip/bulk-create-selected-to-jp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (arrNodeId !== undefined) {
                localVarQueryParameter['arrNodeId'] = arrNodeId;
            }
            if (daAipIdList) {
                localVarQueryParameter['daAipIdList'] = daAipIdList.join(COLLECTION_FORMATS.csv);
            }
            if (daLevelViewId !== undefined) {
                localVarQueryParameter['daLevelViewId'] = daLevelViewId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create JP from selected
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {Array<number>} daDaoIdList DaDao ID List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectJpFromSelected: (arrNodeId_1, daAipId_1, daDaoIdList_1, ...args_1) => __awaiter(this, [arrNodeId_1, daAipId_1, daDaoIdList_1, ...args_1], void 0, function* (arrNodeId, daAipId, daDaoIdList, options = {}) {
            // verify required parameter 'arrNodeId' is not null or undefined
            assertParamExists('aipConnectJpFromSelected', 'arrNodeId', arrNodeId);
            // verify required parameter 'daAipId' is not null or undefined
            assertParamExists('aipConnectJpFromSelected', 'daAipId', daAipId);
            // verify required parameter 'daDaoIdList' is not null or undefined
            assertParamExists('aipConnectJpFromSelected', 'daDaoIdList', daDaoIdList);
            const localVarPath = `/aip/connect-jp-from-selected`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (arrNodeId !== undefined) {
                localVarQueryParameter['arrNodeId'] = arrNodeId;
            }
            if (daAipId !== undefined) {
                localVarQueryParameter['daAipId'] = daAipId;
            }
            if (daDaoIdList) {
                localVarQueryParameter['daDaoIdList'] = daDaoIdList.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create JP and link from selected
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {Array<number>} daDaoIdList DaDao ID List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectJpLinkFromSelected: (arrNodeId_1, daAipId_1, daDaoIdList_1, ...args_1) => __awaiter(this, [arrNodeId_1, daAipId_1, daDaoIdList_1, ...args_1], void 0, function* (arrNodeId, daAipId, daDaoIdList, options = {}) {
            // verify required parameter 'arrNodeId' is not null or undefined
            assertParamExists('aipConnectJpLinkFromSelected', 'arrNodeId', arrNodeId);
            // verify required parameter 'daAipId' is not null or undefined
            assertParamExists('aipConnectJpLinkFromSelected', 'daAipId', daAipId);
            // verify required parameter 'daDaoIdList' is not null or undefined
            assertParamExists('aipConnectJpLinkFromSelected', 'daDaoIdList', daDaoIdList);
            const localVarPath = `/aip/connect-jp-link-from-selected`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (arrNodeId !== undefined) {
                localVarQueryParameter['arrNodeId'] = arrNodeId;
            }
            if (daAipId !== undefined) {
                localVarQueryParameter['daAipId'] = daAipId;
            }
            if (daDaoIdList) {
                localVarQueryParameter['daDaoIdList'] = daDaoIdList.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Connect Part to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {Array<number>} daDaoIdList DaDao ID List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectPartToJp: (arrNodeId_1, daAipId_1, daDaoIdList_1, ...args_1) => __awaiter(this, [arrNodeId_1, daAipId_1, daDaoIdList_1, ...args_1], void 0, function* (arrNodeId, daAipId, daDaoIdList, options = {}) {
            // verify required parameter 'arrNodeId' is not null or undefined
            assertParamExists('aipConnectPartToJp', 'arrNodeId', arrNodeId);
            // verify required parameter 'daAipId' is not null or undefined
            assertParamExists('aipConnectPartToJp', 'daAipId', daAipId);
            // verify required parameter 'daDaoIdList' is not null or undefined
            assertParamExists('aipConnectPartToJp', 'daDaoIdList', daDaoIdList);
            const localVarPath = `/aip/connect-part-to-jp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (arrNodeId !== undefined) {
                localVarQueryParameter['arrNodeId'] = arrNodeId;
            }
            if (daAipId !== undefined) {
                localVarQueryParameter['daAipId'] = daAipId;
            }
            if (daDaoIdList) {
                localVarQueryParameter['daDaoIdList'] = daDaoIdList.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Connect selected to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {Array<number>} daDaoIdList DaDao ID List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectSelectedToJp: (arrNodeId_1, daAipId_1, daDaoIdList_1, ...args_1) => __awaiter(this, [arrNodeId_1, daAipId_1, daDaoIdList_1, ...args_1], void 0, function* (arrNodeId, daAipId, daDaoIdList, options = {}) {
            // verify required parameter 'arrNodeId' is not null or undefined
            assertParamExists('aipConnectSelectedToJp', 'arrNodeId', arrNodeId);
            // verify required parameter 'daAipId' is not null or undefined
            assertParamExists('aipConnectSelectedToJp', 'daAipId', daAipId);
            // verify required parameter 'daDaoIdList' is not null or undefined
            assertParamExists('aipConnectSelectedToJp', 'daDaoIdList', daDaoIdList);
            const localVarPath = `/aip/connect-selected-to-jp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (arrNodeId !== undefined) {
                localVarQueryParameter['arrNodeId'] = arrNodeId;
            }
            if (daAipId !== undefined) {
                localVarQueryParameter['daAipId'] = daAipId;
            }
            if (daDaoIdList) {
                localVarQueryParameter['daDaoIdList'] = daDaoIdList.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Connect to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectToJp: (arrNodeId_1, daAipId_1, ...args_1) => __awaiter(this, [arrNodeId_1, daAipId_1, ...args_1], void 0, function* (arrNodeId, daAipId, options = {}) {
            // verify required parameter 'arrNodeId' is not null or undefined
            assertParamExists('aipConnectToJp', 'arrNodeId', arrNodeId);
            // verify required parameter 'daAipId' is not null or undefined
            assertParamExists('aipConnectToJp', 'daAipId', daAipId);
            const localVarPath = `/aip/connect-to-jp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (arrNodeId !== undefined) {
                localVarQueryParameter['arrNodeId'] = arrNodeId;
            }
            if (daAipId !== undefined) {
                localVarQueryParameter['daAipId'] = daAipId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create dao link
         * @param {number} aipId AIP ID
         * @param {number} daoId DAO ID
         * @param {number} nodeId Node ID
         * @param {LinkType} linkType Link type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipCreateDaoLink: (aipId_1, daoId_1, nodeId_1, linkType_1, ...args_1) => __awaiter(this, [aipId_1, daoId_1, nodeId_1, linkType_1, ...args_1], void 0, function* (aipId, daoId, nodeId, linkType, options = {}) {
            // verify required parameter 'aipId' is not null or undefined
            assertParamExists('aipCreateDaoLink', 'aipId', aipId);
            // verify required parameter 'daoId' is not null or undefined
            assertParamExists('aipCreateDaoLink', 'daoId', daoId);
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('aipCreateDaoLink', 'nodeId', nodeId);
            // verify required parameter 'linkType' is not null or undefined
            assertParamExists('aipCreateDaoLink', 'linkType', linkType);
            const localVarPath = `/aip/create-dao-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (aipId !== undefined) {
                localVarQueryParameter['aipId'] = aipId;
            }
            if (daoId !== undefined) {
                localVarQueryParameter['daoId'] = daoId;
            }
            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }
            if (linkType !== undefined) {
                localVarQueryParameter['linkType'] = linkType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create dao structure
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipCreateDaoStructure: (requestBody_1, ...args_1) => __awaiter(this, [requestBody_1, ...args_1], void 0, function* (requestBody, options = {}) {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('aipCreateDaoStructure', 'requestBody', requestBody);
            const localVarPath = `/aip/create-dao-structure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete complete AIP
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDeleteCompleteAip: (requestBody_1, ...args_1) => __awaiter(this, [requestBody_1, ...args_1], void 0, function* (requestBody, options = {}) {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('aipDeleteCompleteAip', 'requestBody', requestBody);
            const localVarPath = `/aip/delete-complete-aip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete dao link
         * @param {number} daoLinkId Dao link ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDeleteDaoLink: (daoLinkId_1, ...args_1) => __awaiter(this, [daoLinkId_1, ...args_1], void 0, function* (daoLinkId, options = {}) {
            // verify required parameter 'daoLinkId' is not null or undefined
            assertParamExists('aipDeleteDaoLink', 'daoLinkId', daoLinkId);
            const localVarPath = `/aip/delete-dao-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (daoLinkId !== undefined) {
                localVarQueryParameter['daoLinkId'] = daoLinkId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete dao structure
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDeleteDaoStructure: (requestBody_1, ...args_1) => __awaiter(this, [requestBody_1, ...args_1], void 0, function* (requestBody, options = {}) {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('aipDeleteDaoStructure', 'requestBody', requestBody);
            const localVarPath = `/aip/delete-dao-structure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Download complete AIP
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDownloadCompleteAip: (requestBody_1, ...args_1) => __awaiter(this, [requestBody_1, ...args_1], void 0, function* (requestBody, options = {}) {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('aipDownloadCompleteAip', 'requestBody', requestBody);
            const localVarPath = `/aip/download-complete-aip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting the component file by file id
         * @param {number} fileId File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDownloadComponent: (fileId_1, ...args_1) => __awaiter(this, [fileId_1, ...args_1], void 0, function* (fileId, options = {}) {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('aipDownloadComponent', 'fileId', fileId);
            const localVarPath = `/aip/download-component/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Export AIP
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipExportAip: (requestBody_1, ...args_1) => __awaiter(this, [requestBody_1, ...args_1], void 0, function* (requestBody, options = {}) {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('aipExportAip', 'requestBody', requestBody);
            const localVarPath = `/aip/export-aip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Find aips by filters
         * @param {number} from
         * @param {number} count
         * @param {Array<AipFilterGen>} aipFilterGen Array of filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipFindByFilter: (from_1, count_1, aipFilterGen_1, ...args_1) => __awaiter(this, [from_1, count_1, aipFilterGen_1, ...args_1], void 0, function* (from, count, aipFilterGen, options = {}) {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('aipFindByFilter', 'from', from);
            // verify required parameter 'count' is not null or undefined
            assertParamExists('aipFindByFilter', 'count', count);
            // verify required parameter 'aipFilterGen' is not null or undefined
            assertParamExists('aipFindByFilter', 'aipFilterGen', aipFilterGen);
            const localVarPath = `/aip/find/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(aipFilterGen, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get aip detail by id
         * @param {number} aipId Aip ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipGetAip: (aipId_1, ...args_1) => __awaiter(this, [aipId_1, ...args_1], void 0, function* (aipId, options = {}) {
            // verify required parameter 'aipId' is not null or undefined
            assertParamExists('aipGetAip', 'aipId', aipId);
            const localVarPath = `/aip/{aipId}`
                .replace(`{${"aipId"}}`, encodeURIComponent(String(aipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get dao links for node by id
         * @param {number} nodeId Node ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipGetDaoLinks: (nodeId_1, ...args_1) => __awaiter(this, [nodeId_1, ...args_1], void 0, function* (nodeId, options = {}) {
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('aipGetDaoLinks', 'nodeId', nodeId);
            const localVarPath = `/aip/dao-links/{nodeId}`
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Import AIP package
         * @param {number} digitalRepositoryId Digital repository ID
         * @param {AipType} aipType Aip package type
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipImportPackage: (digitalRepositoryId_1, aipType_1, body_1, ...args_1) => __awaiter(this, [digitalRepositoryId_1, aipType_1, body_1, ...args_1], void 0, function* (digitalRepositoryId, aipType, body, options = {}) {
            // verify required parameter 'digitalRepositoryId' is not null or undefined
            assertParamExists('aipImportPackage', 'digitalRepositoryId', digitalRepositoryId);
            // verify required parameter 'aipType' is not null or undefined
            assertParamExists('aipImportPackage', 'aipType', aipType);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('aipImportPackage', 'body', body);
            const localVarPath = `/aip/import-package`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (digitalRepositoryId !== undefined) {
                localVarQueryParameter['digitalRepositoryId'] = digitalRepositoryId;
            }
            if (aipType !== undefined) {
                localVarQueryParameter['aipType'] = aipType;
            }
            localVarHeaderParameter['Content-Type'] = 'application/zip';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get level view tree for aips with ids
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipLevelViewTree: (requestBody_1, ...args_1) => __awaiter(this, [requestBody_1, ...args_1], void 0, function* (requestBody, options = {}) {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('aipLevelViewTree', 'requestBody', requestBody);
            const localVarPath = `/aip/levelViewTree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get level view tree for aips with ids
         * @param {number} aipId Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipTree: (aipId_1, ...args_1) => __awaiter(this, [aipId_1, ...args_1], void 0, function* (aipId, options = {}) {
            // verify required parameter 'aipId' is not null or undefined
            assertParamExists('aipTree', 'aipId', aipId);
            const localVarPath = `/aip/tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (aipId !== undefined) {
                localVarQueryParameter['aipId'] = aipId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update AIP
         * @param {AipUpdateType} type Type of update
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipUpdateAip: (type_1, requestBody_1, ...args_1) => __awaiter(this, [type_1, requestBody_1, ...args_1], void 0, function* (type, requestBody, options = {}) {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('aipUpdateAip', 'type', type);
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('aipUpdateAip', 'requestBody', requestBody);
            const localVarPath = `/aip/update-aip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AipsApi - functional programming interface
 */
export const AipsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AipsApiAxiosParamCreator(configuration);
    return {
        /**
         * Bulk connect logical structure to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {Array<number>} daAipIdList DaAip ID list
         * @param {number} daLevelViewId DaLevelView ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipBulkConnectLogicToJp(arrNodeId, daAipIdList, daLevelViewId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipBulkConnectLogicToJp(arrNodeId, daAipIdList, daLevelViewId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipBulkConnectLogicToJp']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Bulk connect to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {Array<number>} daAipIdList DaAip ID list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipBulkConnectToJp(arrNodeId, daAipIdList, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipBulkConnectToJp(arrNodeId, daAipIdList, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipBulkConnectToJp']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Bulk create from selected
         * @param {number} arrNodeId ArrNode ID
         * @param {Array<number>} daAipIdList DaAip ID list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipBulkCreateFromSelected(arrNodeId, daAipIdList, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipBulkCreateFromSelected(arrNodeId, daAipIdList, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipBulkCreateFromSelected']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Bulk create from selected and connect to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {Array<number>} daAipIdList DaAip ID list
         * @param {number} daLevelViewId DaLevelView ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipBulkCreateSelectedToJp(arrNodeId, daAipIdList, daLevelViewId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipBulkCreateSelectedToJp(arrNodeId, daAipIdList, daLevelViewId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipBulkCreateSelectedToJp']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create JP from selected
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {Array<number>} daDaoIdList DaDao ID List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectJpFromSelected(arrNodeId, daAipId, daDaoIdList, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipConnectJpFromSelected(arrNodeId, daAipId, daDaoIdList, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipConnectJpFromSelected']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create JP and link from selected
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {Array<number>} daDaoIdList DaDao ID List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectJpLinkFromSelected(arrNodeId, daAipId, daDaoIdList, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipConnectJpLinkFromSelected(arrNodeId, daAipId, daDaoIdList, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipConnectJpLinkFromSelected']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Connect Part to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {Array<number>} daDaoIdList DaDao ID List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectPartToJp(arrNodeId, daAipId, daDaoIdList, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipConnectPartToJp(arrNodeId, daAipId, daDaoIdList, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipConnectPartToJp']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Connect selected to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {Array<number>} daDaoIdList DaDao ID List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectSelectedToJp(arrNodeId, daAipId, daDaoIdList, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipConnectSelectedToJp(arrNodeId, daAipId, daDaoIdList, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipConnectSelectedToJp']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Connect to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectToJp(arrNodeId, daAipId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipConnectToJp(arrNodeId, daAipId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipConnectToJp']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create dao link
         * @param {number} aipId AIP ID
         * @param {number} daoId DAO ID
         * @param {number} nodeId Node ID
         * @param {LinkType} linkType Link type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipCreateDaoLink(aipId, daoId, nodeId, linkType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipCreateDaoLink(aipId, daoId, nodeId, linkType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipCreateDaoLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create dao structure
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipCreateDaoStructure(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipCreateDaoStructure(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipCreateDaoStructure']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete complete AIP
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDeleteCompleteAip(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipDeleteCompleteAip(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipDeleteCompleteAip']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete dao link
         * @param {number} daoLinkId Dao link ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDeleteDaoLink(daoLinkId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipDeleteDaoLink(daoLinkId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipDeleteDaoLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete dao structure
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDeleteDaoStructure(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipDeleteDaoStructure(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipDeleteDaoStructure']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Download complete AIP
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDownloadCompleteAip(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipDownloadCompleteAip(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipDownloadCompleteAip']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting the component file by file id
         * @param {number} fileId File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDownloadComponent(fileId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipDownloadComponent(fileId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipDownloadComponent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Export AIP
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipExportAip(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipExportAip(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipExportAip']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Find aips by filters
         * @param {number} from
         * @param {number} count
         * @param {Array<AipFilterGen>} aipFilterGen Array of filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipFindByFilter(from, count, aipFilterGen, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipFindByFilter(from, count, aipFilterGen, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipFindByFilter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get aip detail by id
         * @param {number} aipId Aip ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipGetAip(aipId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipGetAip(aipId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipGetAip']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get dao links for node by id
         * @param {number} nodeId Node ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipGetDaoLinks(nodeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipGetDaoLinks(nodeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipGetDaoLinks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Import AIP package
         * @param {number} digitalRepositoryId Digital repository ID
         * @param {AipType} aipType Aip package type
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipImportPackage(digitalRepositoryId, aipType, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipImportPackage(digitalRepositoryId, aipType, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipImportPackage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get level view tree for aips with ids
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipLevelViewTree(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipLevelViewTree(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipLevelViewTree']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get level view tree for aips with ids
         * @param {number} aipId Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipTree(aipId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipTree(aipId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipTree']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update AIP
         * @param {AipUpdateType} type Type of update
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipUpdateAip(type, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aipUpdateAip(type, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AipsApi.aipUpdateAip']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AipsApi - factory interface
 */
export const AipsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AipsApiFp(configuration);
    return {
        /**
         * Bulk connect logical structure to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {Array<number>} daAipIdList DaAip ID list
         * @param {number} daLevelViewId DaLevelView ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipBulkConnectLogicToJp(arrNodeId, daAipIdList, daLevelViewId, options) {
            return localVarFp.aipBulkConnectLogicToJp(arrNodeId, daAipIdList, daLevelViewId, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk connect to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {Array<number>} daAipIdList DaAip ID list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipBulkConnectToJp(arrNodeId, daAipIdList, options) {
            return localVarFp.aipBulkConnectToJp(arrNodeId, daAipIdList, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk create from selected
         * @param {number} arrNodeId ArrNode ID
         * @param {Array<number>} daAipIdList DaAip ID list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipBulkCreateFromSelected(arrNodeId, daAipIdList, options) {
            return localVarFp.aipBulkCreateFromSelected(arrNodeId, daAipIdList, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk create from selected and connect to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {Array<number>} daAipIdList DaAip ID list
         * @param {number} daLevelViewId DaLevelView ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipBulkCreateSelectedToJp(arrNodeId, daAipIdList, daLevelViewId, options) {
            return localVarFp.aipBulkCreateSelectedToJp(arrNodeId, daAipIdList, daLevelViewId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create JP from selected
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {Array<number>} daDaoIdList DaDao ID List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectJpFromSelected(arrNodeId, daAipId, daDaoIdList, options) {
            return localVarFp.aipConnectJpFromSelected(arrNodeId, daAipId, daDaoIdList, options).then((request) => request(axios, basePath));
        },
        /**
         * Create JP and link from selected
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {Array<number>} daDaoIdList DaDao ID List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectJpLinkFromSelected(arrNodeId, daAipId, daDaoIdList, options) {
            return localVarFp.aipConnectJpLinkFromSelected(arrNodeId, daAipId, daDaoIdList, options).then((request) => request(axios, basePath));
        },
        /**
         * Connect Part to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {Array<number>} daDaoIdList DaDao ID List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectPartToJp(arrNodeId, daAipId, daDaoIdList, options) {
            return localVarFp.aipConnectPartToJp(arrNodeId, daAipId, daDaoIdList, options).then((request) => request(axios, basePath));
        },
        /**
         * Connect selected to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {Array<number>} daDaoIdList DaDao ID List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectSelectedToJp(arrNodeId, daAipId, daDaoIdList, options) {
            return localVarFp.aipConnectSelectedToJp(arrNodeId, daAipId, daDaoIdList, options).then((request) => request(axios, basePath));
        },
        /**
         * Connect to JP
         * @param {number} arrNodeId ArrNode ID
         * @param {number} daAipId DaAip ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipConnectToJp(arrNodeId, daAipId, options) {
            return localVarFp.aipConnectToJp(arrNodeId, daAipId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create dao link
         * @param {number} aipId AIP ID
         * @param {number} daoId DAO ID
         * @param {number} nodeId Node ID
         * @param {LinkType} linkType Link type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipCreateDaoLink(aipId, daoId, nodeId, linkType, options) {
            return localVarFp.aipCreateDaoLink(aipId, daoId, nodeId, linkType, options).then((request) => request(axios, basePath));
        },
        /**
         * Create dao structure
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipCreateDaoStructure(requestBody, options) {
            return localVarFp.aipCreateDaoStructure(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete complete AIP
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDeleteCompleteAip(requestBody, options) {
            return localVarFp.aipDeleteCompleteAip(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete dao link
         * @param {number} daoLinkId Dao link ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDeleteDaoLink(daoLinkId, options) {
            return localVarFp.aipDeleteDaoLink(daoLinkId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete dao structure
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDeleteDaoStructure(requestBody, options) {
            return localVarFp.aipDeleteDaoStructure(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Download complete AIP
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDownloadCompleteAip(requestBody, options) {
            return localVarFp.aipDownloadCompleteAip(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting the component file by file id
         * @param {number} fileId File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipDownloadComponent(fileId, options) {
            return localVarFp.aipDownloadComponent(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Export AIP
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipExportAip(requestBody, options) {
            return localVarFp.aipExportAip(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Find aips by filters
         * @param {number} from
         * @param {number} count
         * @param {Array<AipFilterGen>} aipFilterGen Array of filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipFindByFilter(from, count, aipFilterGen, options) {
            return localVarFp.aipFindByFilter(from, count, aipFilterGen, options).then((request) => request(axios, basePath));
        },
        /**
         * Get aip detail by id
         * @param {number} aipId Aip ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipGetAip(aipId, options) {
            return localVarFp.aipGetAip(aipId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get dao links for node by id
         * @param {number} nodeId Node ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipGetDaoLinks(nodeId, options) {
            return localVarFp.aipGetDaoLinks(nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Import AIP package
         * @param {number} digitalRepositoryId Digital repository ID
         * @param {AipType} aipType Aip package type
         * @param {File} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipImportPackage(digitalRepositoryId, aipType, body, options) {
            return localVarFp.aipImportPackage(digitalRepositoryId, aipType, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Get level view tree for aips with ids
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipLevelViewTree(requestBody, options) {
            return localVarFp.aipLevelViewTree(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Get level view tree for aips with ids
         * @param {number} aipId Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipTree(aipId, options) {
            return localVarFp.aipTree(aipId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update AIP
         * @param {AipUpdateType} type Type of update
         * @param {Array<number>} requestBody Aip IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aipUpdateAip(type, requestBody, options) {
            return localVarFp.aipUpdateAip(type, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AipsApi - object-oriented interface
 */
export class AipsApi extends BaseAPI {
    /**
     * Bulk connect logical structure to JP
     * @param {number} arrNodeId ArrNode ID
     * @param {Array<number>} daAipIdList DaAip ID list
     * @param {number} daLevelViewId DaLevelView ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipBulkConnectLogicToJp(arrNodeId, daAipIdList, daLevelViewId, options) {
        return AipsApiFp(this.configuration).aipBulkConnectLogicToJp(arrNodeId, daAipIdList, daLevelViewId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Bulk connect to JP
     * @param {number} arrNodeId ArrNode ID
     * @param {Array<number>} daAipIdList DaAip ID list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipBulkConnectToJp(arrNodeId, daAipIdList, options) {
        return AipsApiFp(this.configuration).aipBulkConnectToJp(arrNodeId, daAipIdList, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Bulk create from selected
     * @param {number} arrNodeId ArrNode ID
     * @param {Array<number>} daAipIdList DaAip ID list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipBulkCreateFromSelected(arrNodeId, daAipIdList, options) {
        return AipsApiFp(this.configuration).aipBulkCreateFromSelected(arrNodeId, daAipIdList, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Bulk create from selected and connect to JP
     * @param {number} arrNodeId ArrNode ID
     * @param {Array<number>} daAipIdList DaAip ID list
     * @param {number} daLevelViewId DaLevelView ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipBulkCreateSelectedToJp(arrNodeId, daAipIdList, daLevelViewId, options) {
        return AipsApiFp(this.configuration).aipBulkCreateSelectedToJp(arrNodeId, daAipIdList, daLevelViewId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create JP from selected
     * @param {number} arrNodeId ArrNode ID
     * @param {number} daAipId DaAip ID
     * @param {Array<number>} daDaoIdList DaDao ID List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipConnectJpFromSelected(arrNodeId, daAipId, daDaoIdList, options) {
        return AipsApiFp(this.configuration).aipConnectJpFromSelected(arrNodeId, daAipId, daDaoIdList, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create JP and link from selected
     * @param {number} arrNodeId ArrNode ID
     * @param {number} daAipId DaAip ID
     * @param {Array<number>} daDaoIdList DaDao ID List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipConnectJpLinkFromSelected(arrNodeId, daAipId, daDaoIdList, options) {
        return AipsApiFp(this.configuration).aipConnectJpLinkFromSelected(arrNodeId, daAipId, daDaoIdList, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Connect Part to JP
     * @param {number} arrNodeId ArrNode ID
     * @param {number} daAipId DaAip ID
     * @param {Array<number>} daDaoIdList DaDao ID List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipConnectPartToJp(arrNodeId, daAipId, daDaoIdList, options) {
        return AipsApiFp(this.configuration).aipConnectPartToJp(arrNodeId, daAipId, daDaoIdList, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Connect selected to JP
     * @param {number} arrNodeId ArrNode ID
     * @param {number} daAipId DaAip ID
     * @param {Array<number>} daDaoIdList DaDao ID List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipConnectSelectedToJp(arrNodeId, daAipId, daDaoIdList, options) {
        return AipsApiFp(this.configuration).aipConnectSelectedToJp(arrNodeId, daAipId, daDaoIdList, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Connect to JP
     * @param {number} arrNodeId ArrNode ID
     * @param {number} daAipId DaAip ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipConnectToJp(arrNodeId, daAipId, options) {
        return AipsApiFp(this.configuration).aipConnectToJp(arrNodeId, daAipId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create dao link
     * @param {number} aipId AIP ID
     * @param {number} daoId DAO ID
     * @param {number} nodeId Node ID
     * @param {LinkType} linkType Link type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipCreateDaoLink(aipId, daoId, nodeId, linkType, options) {
        return AipsApiFp(this.configuration).aipCreateDaoLink(aipId, daoId, nodeId, linkType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create dao structure
     * @param {Array<number>} requestBody Aip IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipCreateDaoStructure(requestBody, options) {
        return AipsApiFp(this.configuration).aipCreateDaoStructure(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete complete AIP
     * @param {Array<number>} requestBody Aip IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipDeleteCompleteAip(requestBody, options) {
        return AipsApiFp(this.configuration).aipDeleteCompleteAip(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete dao link
     * @param {number} daoLinkId Dao link ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipDeleteDaoLink(daoLinkId, options) {
        return AipsApiFp(this.configuration).aipDeleteDaoLink(daoLinkId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete dao structure
     * @param {Array<number>} requestBody Aip IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipDeleteDaoStructure(requestBody, options) {
        return AipsApiFp(this.configuration).aipDeleteDaoStructure(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Download complete AIP
     * @param {Array<number>} requestBody Aip IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipDownloadCompleteAip(requestBody, options) {
        return AipsApiFp(this.configuration).aipDownloadCompleteAip(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting the component file by file id
     * @param {number} fileId File ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipDownloadComponent(fileId, options) {
        return AipsApiFp(this.configuration).aipDownloadComponent(fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Export AIP
     * @param {Array<number>} requestBody Aip IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipExportAip(requestBody, options) {
        return AipsApiFp(this.configuration).aipExportAip(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Find aips by filters
     * @param {number} from
     * @param {number} count
     * @param {Array<AipFilterGen>} aipFilterGen Array of filters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipFindByFilter(from, count, aipFilterGen, options) {
        return AipsApiFp(this.configuration).aipFindByFilter(from, count, aipFilterGen, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get aip detail by id
     * @param {number} aipId Aip ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipGetAip(aipId, options) {
        return AipsApiFp(this.configuration).aipGetAip(aipId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get dao links for node by id
     * @param {number} nodeId Node ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipGetDaoLinks(nodeId, options) {
        return AipsApiFp(this.configuration).aipGetDaoLinks(nodeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Import AIP package
     * @param {number} digitalRepositoryId Digital repository ID
     * @param {AipType} aipType Aip package type
     * @param {File} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipImportPackage(digitalRepositoryId, aipType, body, options) {
        return AipsApiFp(this.configuration).aipImportPackage(digitalRepositoryId, aipType, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get level view tree for aips with ids
     * @param {Array<number>} requestBody Aip IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipLevelViewTree(requestBody, options) {
        return AipsApiFp(this.configuration).aipLevelViewTree(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get level view tree for aips with ids
     * @param {number} aipId Aip IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipTree(aipId, options) {
        return AipsApiFp(this.configuration).aipTree(aipId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update AIP
     * @param {AipUpdateType} type Type of update
     * @param {Array<number>} requestBody Aip IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    aipUpdateAip(type, requestBody, options) {
        return AipsApiFp(this.configuration).aipUpdateAip(type, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DaosApi - axios parameter creator
 */
export const DaosApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Changing the dao connection scenario
         * @param {number} id dao id
         * @param {string} body new scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoChangeLinkScenario: (id_1, body_1, ...args_1) => __awaiter(this, [id_1, body_1, ...args_1], void 0, function* (id, body, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('daoChangeLinkScenario', 'id', id);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('daoChangeLinkScenario', 'body', body);
            const localVarPath = `/daos/{id}/change-scenario`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Získání stromu pro průzkumník aipu
         * @param {number} aipId Identifikátor aipu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoFindByAipIdAndTypeAndDeleteChangeIsNull: (aipId_1, ...args_1) => __awaiter(this, [aipId_1, ...args_1], void 0, function* (aipId, options = {}) {
            // verify required parameter 'aipId' is not null or undefined
            assertParamExists('daoFindByAipIdAndTypeAndDeleteChangeIsNull', 'aipId', aipId);
            const localVarPath = `/daos/aip/{aipId}`
                .replace(`{${"aipId"}}`, encodeURIComponent(String(aipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Získání informací o da dao pro view request na digital repository
         * @param {number} id Identifikátor da dao
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoGetDaoViewRequestInfo: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('daoGetDaoViewRequestInfo', 'id', id);
            const localVarPath = `/daos/component/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DaosApi - functional programming interface
 */
export const DaosApiFp = function (configuration) {
    const localVarAxiosParamCreator = DaosApiAxiosParamCreator(configuration);
    return {
        /**
         * Changing the dao connection scenario
         * @param {number} id dao id
         * @param {string} body new scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoChangeLinkScenario(id, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.daoChangeLinkScenario(id, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DaosApi.daoChangeLinkScenario']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Získání stromu pro průzkumník aipu
         * @param {number} aipId Identifikátor aipu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoFindByAipIdAndTypeAndDeleteChangeIsNull(aipId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.daoFindByAipIdAndTypeAndDeleteChangeIsNull(aipId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DaosApi.daoFindByAipIdAndTypeAndDeleteChangeIsNull']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Získání informací o da dao pro view request na digital repository
         * @param {number} id Identifikátor da dao
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoGetDaoViewRequestInfo(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.daoGetDaoViewRequestInfo(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DaosApi.daoGetDaoViewRequestInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * DaosApi - factory interface
 */
export const DaosApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DaosApiFp(configuration);
    return {
        /**
         * Changing the dao connection scenario
         * @param {number} id dao id
         * @param {string} body new scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoChangeLinkScenario(id, body, options) {
            return localVarFp.daoChangeLinkScenario(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Získání stromu pro průzkumník aipu
         * @param {number} aipId Identifikátor aipu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoFindByAipIdAndTypeAndDeleteChangeIsNull(aipId, options) {
            return localVarFp.daoFindByAipIdAndTypeAndDeleteChangeIsNull(aipId, options).then((request) => request(axios, basePath));
        },
        /**
         * Získání informací o da dao pro view request na digital repository
         * @param {number} id Identifikátor da dao
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoGetDaoViewRequestInfo(id, options) {
            return localVarFp.daoGetDaoViewRequestInfo(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DaosApi - object-oriented interface
 */
export class DaosApi extends BaseAPI {
    /**
     * Changing the dao connection scenario
     * @param {number} id dao id
     * @param {string} body new scenario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    daoChangeLinkScenario(id, body, options) {
        return DaosApiFp(this.configuration).daoChangeLinkScenario(id, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Získání stromu pro průzkumník aipu
     * @param {number} aipId Identifikátor aipu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    daoFindByAipIdAndTypeAndDeleteChangeIsNull(aipId, options) {
        return DaosApiFp(this.configuration).daoFindByAipIdAndTypeAndDeleteChangeIsNull(aipId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Získání informací o da dao pro view request na digital repository
     * @param {number} id Identifikátor da dao
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    daoGetDaoViewRequestInfo(id, options) {
        return DaosApiFp(this.configuration).daoGetDaoViewRequestInfo(id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoRepositoryFsRepos: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/daorepository`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoRepositoryFsRepos(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.daoRepositoryFsRepos(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.daoRepositoryFsRepos']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DefaultApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        daoRepositoryFsRepos(options) {
            return localVarFp.daoRepositoryFsRepos(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    daoRepositoryFsRepos(options) {
        return DefaultApiFp(this.configuration).daoRepositoryFsRepos(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DescitemsApi - axios parameter creator
 */
export const DescitemsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create attribute value
         * @param {number} fundVersionId id version AS
         * @param {NodeItem} nodeItem new attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemCreateDescItem: (fundVersionId_1, nodeItem_1, ...args_1) => __awaiter(this, [fundVersionId_1, nodeItem_1, ...args_1], void 0, function* (fundVersionId, nodeItem, options = {}) {
            // verify required parameter 'fundVersionId' is not null or undefined
            assertParamExists('descItemCreateDescItem', 'fundVersionId', fundVersionId);
            // verify required parameter 'nodeItem' is not null or undefined
            assertParamExists('descItemCreateDescItem', 'nodeItem', nodeItem);
            const localVarPath = `/descItems/{fundVersionId}/create`
                .replace(`{${"fundVersionId"}}`, encodeURIComponent(String(fundVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(nodeItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete attribute value
         * @param {number} fundVersionId id version AS
         * @param {NodeItem} nodeItem attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemDeleteDescItem: (fundVersionId_1, nodeItem_1, ...args_1) => __awaiter(this, [fundVersionId_1, nodeItem_1, ...args_1], void 0, function* (fundVersionId, nodeItem, options = {}) {
            // verify required parameter 'fundVersionId' is not null or undefined
            assertParamExists('descItemDeleteDescItem', 'fundVersionId', fundVersionId);
            // verify required parameter 'nodeItem' is not null or undefined
            assertParamExists('descItemDeleteDescItem', 'nodeItem', nodeItem);
            const localVarPath = `/descItems/{fundVersionId}`
                .replace(`{${"fundVersionId"}}`, encodeURIComponent(String(fundVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(nodeItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update attribute value
         * @param {number} fundVersionId id version AS
         * @param {boolean} createNewVersion create a new version or not?
         * @param {NodeItem} nodeItem new attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemUpdateDescItem: (fundVersionId_1, createNewVersion_1, nodeItem_1, ...args_1) => __awaiter(this, [fundVersionId_1, createNewVersion_1, nodeItem_1, ...args_1], void 0, function* (fundVersionId, createNewVersion, nodeItem, options = {}) {
            // verify required parameter 'fundVersionId' is not null or undefined
            assertParamExists('descItemUpdateDescItem', 'fundVersionId', fundVersionId);
            // verify required parameter 'createNewVersion' is not null or undefined
            assertParamExists('descItemUpdateDescItem', 'createNewVersion', createNewVersion);
            // verify required parameter 'nodeItem' is not null or undefined
            assertParamExists('descItemUpdateDescItem', 'nodeItem', nodeItem);
            const localVarPath = `/descItems/{fundVersionId}/{createNewVersion}/update`
                .replace(`{${"fundVersionId"}}`, encodeURIComponent(String(fundVersionId)))
                .replace(`{${"createNewVersion"}}`, encodeURIComponent(String(createNewVersion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(nodeItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DescitemsApi - functional programming interface
 */
export const DescitemsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DescitemsApiAxiosParamCreator(configuration);
    return {
        /**
         * Create attribute value
         * @param {number} fundVersionId id version AS
         * @param {NodeItem} nodeItem new attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemCreateDescItem(fundVersionId, nodeItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.descItemCreateDescItem(fundVersionId, nodeItem, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DescitemsApi.descItemCreateDescItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete attribute value
         * @param {number} fundVersionId id version AS
         * @param {NodeItem} nodeItem attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemDeleteDescItem(fundVersionId, nodeItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.descItemDeleteDescItem(fundVersionId, nodeItem, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DescitemsApi.descItemDeleteDescItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update attribute value
         * @param {number} fundVersionId id version AS
         * @param {boolean} createNewVersion create a new version or not?
         * @param {NodeItem} nodeItem new attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemUpdateDescItem(fundVersionId, createNewVersion, nodeItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.descItemUpdateDescItem(fundVersionId, createNewVersion, nodeItem, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DescitemsApi.descItemUpdateDescItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * DescitemsApi - factory interface
 */
export const DescitemsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DescitemsApiFp(configuration);
    return {
        /**
         * Create attribute value
         * @param {number} fundVersionId id version AS
         * @param {NodeItem} nodeItem new attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemCreateDescItem(fundVersionId, nodeItem, options) {
            return localVarFp.descItemCreateDescItem(fundVersionId, nodeItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete attribute value
         * @param {number} fundVersionId id version AS
         * @param {NodeItem} nodeItem attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemDeleteDescItem(fundVersionId, nodeItem, options) {
            return localVarFp.descItemDeleteDescItem(fundVersionId, nodeItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Update attribute value
         * @param {number} fundVersionId id version AS
         * @param {boolean} createNewVersion create a new version or not?
         * @param {NodeItem} nodeItem new attribute value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descItemUpdateDescItem(fundVersionId, createNewVersion, nodeItem, options) {
            return localVarFp.descItemUpdateDescItem(fundVersionId, createNewVersion, nodeItem, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DescitemsApi - object-oriented interface
 */
export class DescitemsApi extends BaseAPI {
    /**
     * Create attribute value
     * @param {number} fundVersionId id version AS
     * @param {NodeItem} nodeItem new attribute value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    descItemCreateDescItem(fundVersionId, nodeItem, options) {
        return DescitemsApiFp(this.configuration).descItemCreateDescItem(fundVersionId, nodeItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete attribute value
     * @param {number} fundVersionId id version AS
     * @param {NodeItem} nodeItem attribute value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    descItemDeleteDescItem(fundVersionId, nodeItem, options) {
        return DescitemsApiFp(this.configuration).descItemDeleteDescItem(fundVersionId, nodeItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update attribute value
     * @param {number} fundVersionId id version AS
     * @param {boolean} createNewVersion create a new version or not?
     * @param {NodeItem} nodeItem new attribute value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    descItemUpdateDescItem(fundVersionId, createNewVersion, nodeItem, options) {
        return DescitemsApiFp(this.configuration).descItemUpdateDescItem(fundVersionId, createNewVersion, nodeItem, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ExternalsystemsApi - axios parameter creator
 */
export const ExternalsystemsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Return list of all properties of external system
         * @param {number} [extSystemId] external system id
         * @param {number} [userId] user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemAllProperties: (extSystemId_1, userId_1, ...args_1) => __awaiter(this, [extSystemId_1, userId_1, ...args_1], void 0, function* (extSystemId, userId, options = {}) {
            const localVarPath = `/extsystem/property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (extSystemId !== undefined) {
                localVarQueryParameter['extSystemId'] = extSystemId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete one property of external system
         * @param {Array<number>} requestBody external system property id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemDeleteProperties: (requestBody_1, ...args_1) => __awaiter(this, [requestBody_1, ...args_1], void 0, function* (requestBody, options = {}) {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('externalSystemDeleteProperties', 'requestBody', requestBody);
            const localVarPath = `/extsystem/property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * External system resync
         * @param {string} id external system ID or CODE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemExternalSystemResync: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('externalSystemExternalSystemResync', 'id', id);
            const localVarPath = `/extsystem/resync/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Store one or more property of external system
         * @param {Array<ExtSystemProperty>} extSystemProperty request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemStoreProperties: (extSystemProperty_1, ...args_1) => __awaiter(this, [extSystemProperty_1, ...args_1], void 0, function* (extSystemProperty, options = {}) {
            // verify required parameter 'extSystemProperty' is not null or undefined
            assertParamExists('externalSystemStoreProperties', 'extSystemProperty', extSystemProperty);
            const localVarPath = `/extsystem/property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(extSystemProperty, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ExternalsystemsApi - functional programming interface
 */
export const ExternalsystemsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExternalsystemsApiAxiosParamCreator(configuration);
    return {
        /**
         * Return list of all properties of external system
         * @param {number} [extSystemId] external system id
         * @param {number} [userId] user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemAllProperties(extSystemId, userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.externalSystemAllProperties(extSystemId, userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExternalsystemsApi.externalSystemAllProperties']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete one property of external system
         * @param {Array<number>} requestBody external system property id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemDeleteProperties(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.externalSystemDeleteProperties(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExternalsystemsApi.externalSystemDeleteProperties']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * External system resync
         * @param {string} id external system ID or CODE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemExternalSystemResync(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.externalSystemExternalSystemResync(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExternalsystemsApi.externalSystemExternalSystemResync']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Store one or more property of external system
         * @param {Array<ExtSystemProperty>} extSystemProperty request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemStoreProperties(extSystemProperty, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.externalSystemStoreProperties(extSystemProperty, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ExternalsystemsApi.externalSystemStoreProperties']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ExternalsystemsApi - factory interface
 */
export const ExternalsystemsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExternalsystemsApiFp(configuration);
    return {
        /**
         * Return list of all properties of external system
         * @param {number} [extSystemId] external system id
         * @param {number} [userId] user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemAllProperties(extSystemId, userId, options) {
            return localVarFp.externalSystemAllProperties(extSystemId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one property of external system
         * @param {Array<number>} requestBody external system property id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemDeleteProperties(requestBody, options) {
            return localVarFp.externalSystemDeleteProperties(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * External system resync
         * @param {string} id external system ID or CODE
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemExternalSystemResync(id, options) {
            return localVarFp.externalSystemExternalSystemResync(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Store one or more property of external system
         * @param {Array<ExtSystemProperty>} extSystemProperty request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalSystemStoreProperties(extSystemProperty, options) {
            return localVarFp.externalSystemStoreProperties(extSystemProperty, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ExternalsystemsApi - object-oriented interface
 */
export class ExternalsystemsApi extends BaseAPI {
    /**
     * Return list of all properties of external system
     * @param {number} [extSystemId] external system id
     * @param {number} [userId] user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    externalSystemAllProperties(extSystemId, userId, options) {
        return ExternalsystemsApiFp(this.configuration).externalSystemAllProperties(extSystemId, userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete one property of external system
     * @param {Array<number>} requestBody external system property id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    externalSystemDeleteProperties(requestBody, options) {
        return ExternalsystemsApiFp(this.configuration).externalSystemDeleteProperties(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * External system resync
     * @param {string} id external system ID or CODE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    externalSystemExternalSystemResync(id, options) {
        return ExternalsystemsApiFp(this.configuration).externalSystemExternalSystemResync(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Store one or more property of external system
     * @param {Array<ExtSystemProperty>} extSystemProperty request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    externalSystemStoreProperties(extSystemProperty, options) {
        return ExternalsystemsApiFp(this.configuration).externalSystemStoreProperties(extSystemProperty, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FundsApi - axios parameter creator
 */
export const FundsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Vrátí jednotlivé per-fond běhy patřící do jednoho vícefondového seskupení (sledování průběhu).
         * @param {number} fundsChangeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkActionGetFundsChangeRuns: (fundsChangeId_1, ...args_1) => __awaiter(this, [fundsChangeId_1, ...args_1], void 0, function* (fundsChangeId, options = {}) {
            // verify required parameter 'fundsChangeId' is not null or undefined
            assertParamExists('bulkActionGetFundsChangeRuns', 'fundsChangeId', fundsChangeId);
            const localVarPath = `/action/funds-change/{fundsChangeId}`
                .replace(`{${"fundsChangeId"}}`, encodeURIComponent(String(fundsChangeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Rozdělí vybrané fondy podle pravidel a vrátí dostupné hromadné akce pro každou skupinu. Vstupem je buď explicitní seznam fondů, nebo filtr (výběr všech odpovídajících fondů).
         * @param {FundsActionGroupRequest} fundsActionGroupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkActionGroupFundsByRuleSet: (fundsActionGroupRequest_1, ...args_1) => __awaiter(this, [fundsActionGroupRequest_1, ...args_1], void 0, function* (fundsActionGroupRequest, options = {}) {
            // verify required parameter 'fundsActionGroupRequest' is not null or undefined
            assertParamExists('bulkActionGroupFundsByRuleSet', 'fundsActionGroupRequest', fundsActionGroupRequest);
            const localVarPath = `/action/funds/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(fundsActionGroupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Spustí hromadnou akci nad více fondy najednou. Pro každý fond zvolené skupiny pravidel naplánuje samostatný běh; fondy jiných pravidel se nespouští.
         * @param {MultiFundActionRequest} multiFundActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkActionQueueMultiFundAction: (multiFundActionRequest_1, ...args_1) => __awaiter(this, [multiFundActionRequest_1, ...args_1], void 0, function* (multiFundActionRequest, options = {}) {
            // verify required parameter 'multiFundActionRequest' is not null or undefined
            assertParamExists('bulkActionQueueMultiFundAction', 'multiFundActionRequest', multiFundActionRequest);
            const localVarPath = `/action/queue-multi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(multiFundActionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Created a new archive file (AS)
         * @param {CreateFund} createFund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundCreateFund: (createFund_1, ...args_1) => __awaiter(this, [createFund_1, ...args_1], void 0, function* (createFund, options = {}) {
            // verify required parameter 'createFund' is not null or undefined
            assertParamExists('fundCreateFund', 'createFund', createFund);
            const localVarPath = `/fund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createFund, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Export fonds
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundExportFunds: (searchParams_1, ...args_1) => __awaiter(this, [searchParams_1, ...args_1], void 0, function* (searchParams, options = {}) {
            // verify required parameter 'searchParams' is not null or undefined
            assertParamExists('fundExportFunds', 'searchParams', searchParams);
            const localVarPath = `/fund/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search for archive files (AS)
         * @param {string} [fulltext] vyhledávaný výraz
         * @param {string} [institutionIdentifier] identifikátor instituce (podpora pro kód instituce i UUID přístupového bodu)
         * @param {number} [max] maximální počet výsledků na stránku
         * @param {number} [from] Od kolikátého záznamu se mají výsledky vracet (0 &#x3D; žádné se nepřeskočí)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        fundFindFunds: (fulltext_1, institutionIdentifier_1, max_1, from_1, ...args_1) => __awaiter(this, [fulltext_1, institutionIdentifier_1, max_1, from_1, ...args_1], void 0, function* (fulltext, institutionIdentifier, max, from, options = {}) {
            const localVarPath = `/fund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fulltext !== undefined) {
                localVarQueryParameter['fulltext'] = fulltext;
            }
            if (institutionIdentifier !== undefined) {
                localVarQueryParameter['institutionIdentifier'] = institutionIdentifier;
            }
            if (max !== undefined) {
                localVarQueryParameter['max'] = max;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create DAO link
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {number} nodeId Node ID
         * @param {string} [path]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsCreateDAOLink: (fundId_1, fsrepoId_1, nodeId_1, path_1, ...args_1) => __awaiter(this, [fundId_1, fsrepoId_1, nodeId_1, path_1, ...args_1], void 0, function* (fundId, fsrepoId, nodeId, path, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundFsCreateDAOLink', 'fundId', fundId);
            // verify required parameter 'fsrepoId' is not null or undefined
            assertParamExists('fundFsCreateDAOLink', 'fsrepoId', fsrepoId);
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('fundFsCreateDAOLink', 'nodeId', nodeId);
            const localVarPath = `/fund/{fundId}/fsrepo/{fsrepoId}/linkitem/{nodeId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"fsrepoId"}}`, encodeURIComponent(String(fsrepoId)))
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get file of data
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {string} path file path in the repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepoItemData: (fundId_1, fsrepoId_1, path_1, ...args_1) => __awaiter(this, [fundId_1, fsrepoId_1, path_1, ...args_1], void 0, function* (fundId, fsrepoId, path, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundFsRepoItemData', 'fundId', fundId);
            // verify required parameter 'fsrepoId' is not null or undefined
            assertParamExists('fundFsRepoItemData', 'fsrepoId', fsrepoId);
            // verify required parameter 'path' is not null or undefined
            assertParamExists('fundFsRepoItemData', 'path', path);
            const localVarPath = `/fund/{fundId}/fsrepo/{fsrepoId}/item-data`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"fsrepoId"}}`, encodeURIComponent(String(fsrepoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return list of filesystem items
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {FsItemType} [filterType] Optional filter to return only folders or files. If not specified all items are returned
         * @param {string} [path] Optional path in the repository
         * @param {string} [lastKey] Optional parameter to return next batch of items. See FsItems for more details.
         * @param {FsItemFilterByLinked} [filterByLink] Filter for file system items by link status
         * @param {FsItemSortType} [sortingType] File sorting type
         * @param {string} [fileFilter] File filtering template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepoItems: (fundId_1, fsrepoId_1, filterType_1, path_1, lastKey_1, filterByLink_1, sortingType_1, fileFilter_1, ...args_1) => __awaiter(this, [fundId_1, fsrepoId_1, filterType_1, path_1, lastKey_1, filterByLink_1, sortingType_1, fileFilter_1, ...args_1], void 0, function* (fundId, fsrepoId, filterType, path, lastKey, filterByLink, sortingType, fileFilter, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundFsRepoItems', 'fundId', fundId);
            // verify required parameter 'fsrepoId' is not null or undefined
            assertParamExists('fundFsRepoItems', 'fsrepoId', fsrepoId);
            const localVarPath = `/fund/{fundId}/fsrepo/{fsrepoId}/items`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"fsrepoId"}}`, encodeURIComponent(String(fsrepoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filterType !== undefined) {
                localVarQueryParameter['filterType'] = filterType;
            }
            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }
            if (lastKey !== undefined) {
                localVarQueryParameter['lastKey'] = lastKey;
            }
            if (filterByLink !== undefined) {
                localVarQueryParameter['filterByLink'] = filterByLink;
            }
            if (sortingType !== undefined) {
                localVarQueryParameter['sortingType'] = sortingType;
            }
            if (fileFilter !== undefined) {
                localVarQueryParameter['fileFilter'] = fileFilter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return list of filesystem repositories
         * @param {number} fundId Fund ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepos: (fundId_1, ...args_1) => __awaiter(this, [fundId_1, ...args_1], void 0, function* (fundId, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundFsRepos', 'fundId', fundId);
            const localVarPath = `/fund/{fundId}/fsrepos`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting the AS detail
         * @param {string} id fund ID. Might be ID or fund UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundGetFund: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fundGetFund', 'id', id);
            const localVarPath = `/fund/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Import additional data to the existing fund
         * @param {string} id Fund ID. Might be ID or fund UUID
         * @param {string} importType Import type. Only \\\&#39;CSV\\\&#39; is supported
         * @param {File} dataFile File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundImportFundData: (id_1, importType_1, dataFile_1, ...args_1) => __awaiter(this, [id_1, importType_1, dataFile_1, ...args_1], void 0, function* (id, importType, dataFile, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fundImportFundData', 'id', id);
            // verify required parameter 'importType' is not null or undefined
            assertParamExists('fundImportFundData', 'importType', importType);
            // verify required parameter 'dataFile' is not null or undefined
            assertParamExists('fundImportFundData', 'dataFile', dataFile);
            const localVarPath = `/fund/{id}/import`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (importType !== undefined) {
                localVarFormParams.append('importType', importType);
            }
            if (dataFile !== undefined) {
                localVarFormParams.append('dataFile', dataFile);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search for funds
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundSearchFunds: (searchParams_1, ...args_1) => __awaiter(this, [searchParams_1, ...args_1], void 0, function* (searchParams, options = {}) {
            // verify required parameter 'searchParams' is not null or undefined
            assertParamExists('fundSearchFunds', 'searchParams', searchParams);
            const localVarPath = `/fund/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Set mode (TREE/LIST) of ArrLevel
         * @param {number} fundId Fund ID
         * @param {number} nodeId Node ID
         * @param {boolean} list TREE (-&gt; list &#x3D; false), LIST (-&gt; list &#x3D; true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundSetLevelMode: (fundId_1, nodeId_1, list_1, ...args_1) => __awaiter(this, [fundId_1, nodeId_1, list_1, ...args_1], void 0, function* (fundId, nodeId, list, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundSetLevelMode', 'fundId', fundId);
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('fundSetLevelMode', 'nodeId', nodeId);
            // verify required parameter 'list' is not null or undefined
            assertParamExists('fundSetLevelMode', 'list', list);
            const localVarPath = `/fund/{fundId}/node/{nodeId}/mode`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (list !== undefined) {
                localVarQueryParameter['list'] = list;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update of archive file (AS)
         * @param {string} id fund ID. Might be ID or fund UUID
         * @param {UpdateFund} updateFund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundUpdateFund: (id_1, updateFund_1, ...args_1) => __awaiter(this, [id_1, updateFund_1, ...args_1], void 0, function* (id, updateFund, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fundUpdateFund', 'id', id);
            // verify required parameter 'updateFund' is not null or undefined
            assertParamExists('fundUpdateFund', 'updateFund', updateFund);
            const localVarPath = `/fund/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateFund, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return list of item type id & count
         * @param {number} fundId Fund ID
         * @param {number} fundVersionId Fund ID Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundUsedItemTypes: (fundId_1, fundVersionId_1, ...args_1) => __awaiter(this, [fundId_1, fundVersionId_1, ...args_1], void 0, function* (fundId, fundVersionId, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundUsedItemTypes', 'fundId', fundId);
            // verify required parameter 'fundVersionId' is not null or undefined
            assertParamExists('fundUsedItemTypes', 'fundVersionId', fundVersionId);
            const localVarPath = `/fund/{fundId}/usedItemtypes/{fundVersionId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"fundVersionId"}}`, encodeURIComponent(String(fundVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FundsApi - functional programming interface
 */
export const FundsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FundsApiAxiosParamCreator(configuration);
    return {
        /**
         * Vrátí jednotlivé per-fond běhy patřící do jednoho vícefondového seskupení (sledování průběhu).
         * @param {number} fundsChangeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkActionGetFundsChangeRuns(fundsChangeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bulkActionGetFundsChangeRuns(fundsChangeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.bulkActionGetFundsChangeRuns']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Rozdělí vybrané fondy podle pravidel a vrátí dostupné hromadné akce pro každou skupinu. Vstupem je buď explicitní seznam fondů, nebo filtr (výběr všech odpovídajících fondů).
         * @param {FundsActionGroupRequest} fundsActionGroupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkActionGroupFundsByRuleSet(fundsActionGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bulkActionGroupFundsByRuleSet(fundsActionGroupRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.bulkActionGroupFundsByRuleSet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Spustí hromadnou akci nad více fondy najednou. Pro každý fond zvolené skupiny pravidel naplánuje samostatný běh; fondy jiných pravidel se nespouští.
         * @param {MultiFundActionRequest} multiFundActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkActionQueueMultiFundAction(multiFundActionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bulkActionQueueMultiFundAction(multiFundActionRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.bulkActionQueueMultiFundAction']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Created a new archive file (AS)
         * @param {CreateFund} createFund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundCreateFund(createFund, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundCreateFund(createFund, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundCreateFund']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Export fonds
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundExportFunds(searchParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundExportFunds(searchParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundExportFunds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Search for archive files (AS)
         * @param {string} [fulltext] vyhledávaný výraz
         * @param {string} [institutionIdentifier] identifikátor instituce (podpora pro kód instituce i UUID přístupového bodu)
         * @param {number} [max] maximální počet výsledků na stránku
         * @param {number} [from] Od kolikátého záznamu se mají výsledky vracet (0 &#x3D; žádné se nepřeskočí)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        fundFindFunds(fulltext, institutionIdentifier, max, from, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundFindFunds(fulltext, institutionIdentifier, max, from, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundFindFunds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create DAO link
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {number} nodeId Node ID
         * @param {string} [path]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsCreateDAOLink(fundId, fsrepoId, nodeId, path, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundFsCreateDAOLink(fundId, fsrepoId, nodeId, path, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundFsCreateDAOLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get file of data
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {string} path file path in the repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepoItemData(fundId, fsrepoId, path, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundFsRepoItemData(fundId, fsrepoId, path, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundFsRepoItemData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return list of filesystem items
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {FsItemType} [filterType] Optional filter to return only folders or files. If not specified all items are returned
         * @param {string} [path] Optional path in the repository
         * @param {string} [lastKey] Optional parameter to return next batch of items. See FsItems for more details.
         * @param {FsItemFilterByLinked} [filterByLink] Filter for file system items by link status
         * @param {FsItemSortType} [sortingType] File sorting type
         * @param {string} [fileFilter] File filtering template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepoItems(fundId, fsrepoId, filterType, path, lastKey, filterByLink, sortingType, fileFilter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundFsRepoItems(fundId, fsrepoId, filterType, path, lastKey, filterByLink, sortingType, fileFilter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundFsRepoItems']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return list of filesystem repositories
         * @param {number} fundId Fund ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepos(fundId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundFsRepos(fundId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundFsRepos']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting the AS detail
         * @param {string} id fund ID. Might be ID or fund UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundGetFund(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundGetFund(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundGetFund']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Import additional data to the existing fund
         * @param {string} id Fund ID. Might be ID or fund UUID
         * @param {string} importType Import type. Only \\\&#39;CSV\\\&#39; is supported
         * @param {File} dataFile File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundImportFundData(id, importType, dataFile, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundImportFundData(id, importType, dataFile, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundImportFundData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Search for funds
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundSearchFunds(searchParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundSearchFunds(searchParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundSearchFunds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Set mode (TREE/LIST) of ArrLevel
         * @param {number} fundId Fund ID
         * @param {number} nodeId Node ID
         * @param {boolean} list TREE (-&gt; list &#x3D; false), LIST (-&gt; list &#x3D; true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundSetLevelMode(fundId, nodeId, list, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundSetLevelMode(fundId, nodeId, list, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundSetLevelMode']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update of archive file (AS)
         * @param {string} id fund ID. Might be ID or fund UUID
         * @param {UpdateFund} updateFund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundUpdateFund(id, updateFund, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundUpdateFund(id, updateFund, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundUpdateFund']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return list of item type id & count
         * @param {number} fundId Fund ID
         * @param {number} fundVersionId Fund ID Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundUsedItemTypes(fundId, fundVersionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundUsedItemTypes(fundId, fundVersionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FundsApi.fundUsedItemTypes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * FundsApi - factory interface
 */
export const FundsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FundsApiFp(configuration);
    return {
        /**
         * Vrátí jednotlivé per-fond běhy patřící do jednoho vícefondového seskupení (sledování průběhu).
         * @param {number} fundsChangeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkActionGetFundsChangeRuns(fundsChangeId, options) {
            return localVarFp.bulkActionGetFundsChangeRuns(fundsChangeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Rozdělí vybrané fondy podle pravidel a vrátí dostupné hromadné akce pro každou skupinu. Vstupem je buď explicitní seznam fondů, nebo filtr (výběr všech odpovídajících fondů).
         * @param {FundsActionGroupRequest} fundsActionGroupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkActionGroupFundsByRuleSet(fundsActionGroupRequest, options) {
            return localVarFp.bulkActionGroupFundsByRuleSet(fundsActionGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Spustí hromadnou akci nad více fondy najednou. Pro každý fond zvolené skupiny pravidel naplánuje samostatný běh; fondy jiných pravidel se nespouští.
         * @param {MultiFundActionRequest} multiFundActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkActionQueueMultiFundAction(multiFundActionRequest, options) {
            return localVarFp.bulkActionQueueMultiFundAction(multiFundActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Created a new archive file (AS)
         * @param {CreateFund} createFund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundCreateFund(createFund, options) {
            return localVarFp.fundCreateFund(createFund, options).then((request) => request(axios, basePath));
        },
        /**
         * Export fonds
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundExportFunds(searchParams, options) {
            return localVarFp.fundExportFunds(searchParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for archive files (AS)
         * @param {string} [fulltext] vyhledávaný výraz
         * @param {string} [institutionIdentifier] identifikátor instituce (podpora pro kód instituce i UUID přístupového bodu)
         * @param {number} [max] maximální počet výsledků na stránku
         * @param {number} [from] Od kolikátého záznamu se mají výsledky vracet (0 &#x3D; žádné se nepřeskočí)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        fundFindFunds(fulltext, institutionIdentifier, max, from, options) {
            return localVarFp.fundFindFunds(fulltext, institutionIdentifier, max, from, options).then((request) => request(axios, basePath));
        },
        /**
         * Create DAO link
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {number} nodeId Node ID
         * @param {string} [path]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsCreateDAOLink(fundId, fsrepoId, nodeId, path, options) {
            return localVarFp.fundFsCreateDAOLink(fundId, fsrepoId, nodeId, path, options).then((request) => request(axios, basePath));
        },
        /**
         * Get file of data
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {string} path file path in the repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepoItemData(fundId, fsrepoId, path, options) {
            return localVarFp.fundFsRepoItemData(fundId, fsrepoId, path, options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of filesystem items
         * @param {number} fundId Fund ID
         * @param {number} fsrepoId FileSystem repository ID
         * @param {FsItemType} [filterType] Optional filter to return only folders or files. If not specified all items are returned
         * @param {string} [path] Optional path in the repository
         * @param {string} [lastKey] Optional parameter to return next batch of items. See FsItems for more details.
         * @param {FsItemFilterByLinked} [filterByLink] Filter for file system items by link status
         * @param {FsItemSortType} [sortingType] File sorting type
         * @param {string} [fileFilter] File filtering template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepoItems(fundId, fsrepoId, filterType, path, lastKey, filterByLink, sortingType, fileFilter, options) {
            return localVarFp.fundFsRepoItems(fundId, fsrepoId, filterType, path, lastKey, filterByLink, sortingType, fileFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of filesystem repositories
         * @param {number} fundId Fund ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundFsRepos(fundId, options) {
            return localVarFp.fundFsRepos(fundId, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting the AS detail
         * @param {string} id fund ID. Might be ID or fund UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundGetFund(id, options) {
            return localVarFp.fundGetFund(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Import additional data to the existing fund
         * @param {string} id Fund ID. Might be ID or fund UUID
         * @param {string} importType Import type. Only \\\&#39;CSV\\\&#39; is supported
         * @param {File} dataFile File to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundImportFundData(id, importType, dataFile, options) {
            return localVarFp.fundImportFundData(id, importType, dataFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for funds
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundSearchFunds(searchParams, options) {
            return localVarFp.fundSearchFunds(searchParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Set mode (TREE/LIST) of ArrLevel
         * @param {number} fundId Fund ID
         * @param {number} nodeId Node ID
         * @param {boolean} list TREE (-&gt; list &#x3D; false), LIST (-&gt; list &#x3D; true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundSetLevelMode(fundId, nodeId, list, options) {
            return localVarFp.fundSetLevelMode(fundId, nodeId, list, options).then((request) => request(axios, basePath));
        },
        /**
         * Update of archive file (AS)
         * @param {string} id fund ID. Might be ID or fund UUID
         * @param {UpdateFund} updateFund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundUpdateFund(id, updateFund, options) {
            return localVarFp.fundUpdateFund(id, updateFund, options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of item type id & count
         * @param {number} fundId Fund ID
         * @param {number} fundVersionId Fund ID Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundUsedItemTypes(fundId, fundVersionId, options) {
            return localVarFp.fundUsedItemTypes(fundId, fundVersionId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FundsApi - object-oriented interface
 */
export class FundsApi extends BaseAPI {
    /**
     * Vrátí jednotlivé per-fond běhy patřící do jednoho vícefondového seskupení (sledování průběhu).
     * @param {number} fundsChangeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkActionGetFundsChangeRuns(fundsChangeId, options) {
        return FundsApiFp(this.configuration).bulkActionGetFundsChangeRuns(fundsChangeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Rozdělí vybrané fondy podle pravidel a vrátí dostupné hromadné akce pro každou skupinu. Vstupem je buď explicitní seznam fondů, nebo filtr (výběr všech odpovídajících fondů).
     * @param {FundsActionGroupRequest} fundsActionGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkActionGroupFundsByRuleSet(fundsActionGroupRequest, options) {
        return FundsApiFp(this.configuration).bulkActionGroupFundsByRuleSet(fundsActionGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Spustí hromadnou akci nad více fondy najednou. Pro každý fond zvolené skupiny pravidel naplánuje samostatný běh; fondy jiných pravidel se nespouští.
     * @param {MultiFundActionRequest} multiFundActionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkActionQueueMultiFundAction(multiFundActionRequest, options) {
        return FundsApiFp(this.configuration).bulkActionQueueMultiFundAction(multiFundActionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Created a new archive file (AS)
     * @param {CreateFund} createFund
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCreateFund(createFund, options) {
        return FundsApiFp(this.configuration).fundCreateFund(createFund, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Export fonds
     * @param {SearchParams} searchParams search parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundExportFunds(searchParams, options) {
        return FundsApiFp(this.configuration).fundExportFunds(searchParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for archive files (AS)
     * @param {string} [fulltext] vyhledávaný výraz
     * @param {string} [institutionIdentifier] identifikátor instituce (podpora pro kód instituce i UUID přístupového bodu)
     * @param {number} [max] maximální počet výsledků na stránku
     * @param {number} [from] Od kolikátého záznamu se mají výsledky vracet (0 &#x3D; žádné se nepřeskočí)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    fundFindFunds(fulltext, institutionIdentifier, max, from, options) {
        return FundsApiFp(this.configuration).fundFindFunds(fulltext, institutionIdentifier, max, from, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create DAO link
     * @param {number} fundId Fund ID
     * @param {number} fsrepoId FileSystem repository ID
     * @param {number} nodeId Node ID
     * @param {string} [path]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundFsCreateDAOLink(fundId, fsrepoId, nodeId, path, options) {
        return FundsApiFp(this.configuration).fundFsCreateDAOLink(fundId, fsrepoId, nodeId, path, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get file of data
     * @param {number} fundId Fund ID
     * @param {number} fsrepoId FileSystem repository ID
     * @param {string} path file path in the repository
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundFsRepoItemData(fundId, fsrepoId, path, options) {
        return FundsApiFp(this.configuration).fundFsRepoItemData(fundId, fsrepoId, path, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return list of filesystem items
     * @param {number} fundId Fund ID
     * @param {number} fsrepoId FileSystem repository ID
     * @param {FsItemType} [filterType] Optional filter to return only folders or files. If not specified all items are returned
     * @param {string} [path] Optional path in the repository
     * @param {string} [lastKey] Optional parameter to return next batch of items. See FsItems for more details.
     * @param {FsItemFilterByLinked} [filterByLink] Filter for file system items by link status
     * @param {FsItemSortType} [sortingType] File sorting type
     * @param {string} [fileFilter] File filtering template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundFsRepoItems(fundId, fsrepoId, filterType, path, lastKey, filterByLink, sortingType, fileFilter, options) {
        return FundsApiFp(this.configuration).fundFsRepoItems(fundId, fsrepoId, filterType, path, lastKey, filterByLink, sortingType, fileFilter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return list of filesystem repositories
     * @param {number} fundId Fund ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundFsRepos(fundId, options) {
        return FundsApiFp(this.configuration).fundFsRepos(fundId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting the AS detail
     * @param {string} id fund ID. Might be ID or fund UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundGetFund(id, options) {
        return FundsApiFp(this.configuration).fundGetFund(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Import additional data to the existing fund
     * @param {string} id Fund ID. Might be ID or fund UUID
     * @param {string} importType Import type. Only \\\&#39;CSV\\\&#39; is supported
     * @param {File} dataFile File to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundImportFundData(id, importType, dataFile, options) {
        return FundsApiFp(this.configuration).fundImportFundData(id, importType, dataFile, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for funds
     * @param {SearchParams} searchParams search parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundSearchFunds(searchParams, options) {
        return FundsApiFp(this.configuration).fundSearchFunds(searchParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set mode (TREE/LIST) of ArrLevel
     * @param {number} fundId Fund ID
     * @param {number} nodeId Node ID
     * @param {boolean} list TREE (-&gt; list &#x3D; false), LIST (-&gt; list &#x3D; true)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundSetLevelMode(fundId, nodeId, list, options) {
        return FundsApiFp(this.configuration).fundSetLevelMode(fundId, nodeId, list, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update of archive file (AS)
     * @param {string} id fund ID. Might be ID or fund UUID
     * @param {UpdateFund} updateFund
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundUpdateFund(id, updateFund, options) {
        return FundsApiFp(this.configuration).fundUpdateFund(id, updateFund, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return list of item type id & count
     * @param {number} fundId Fund ID
     * @param {number} fundVersionId Fund ID Version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundUsedItemTypes(fundId, fundVersionId, options) {
        return FundsApiFp(this.configuration).fundUsedItemTypes(fundId, fundVersionId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InstitutionApi - axios parameter creator
 */
export const InstitutionApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create institution
         * @param {Institution} institution item of institution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instCreate: (institution_1, ...args_1) => __awaiter(this, [institution_1, ...args_1], void 0, function* (institution, options = {}) {
            // verify required parameter 'institution' is not null or undefined
            assertParamExists('instCreate', 'institution', institution);
            const localVarPath = `/institution/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(institution, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete institution
         * @param {number} id institution id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instDelete: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('instDelete', 'id', id);
            const localVarPath = `/institution/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get list of Institutions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instGetAll: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/institution/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get institution by id
         * @param {string} id institution id or internalCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instGetById: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('instGetById', 'id', id);
            const localVarPath = `/institution/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get list of type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instGetTypes: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/institution/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update institution
         * @param {number} id institution id
         * @param {Institution} institution item of institurion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instUpdate: (id_1, institution_1, ...args_1) => __awaiter(this, [id_1, institution_1, ...args_1], void 0, function* (id, institution, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('instUpdate', 'id', id);
            // verify required parameter 'institution' is not null or undefined
            assertParamExists('instUpdate', 'institution', institution);
            const localVarPath = `/institution/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(institution, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * InstitutionApi - functional programming interface
 */
export const InstitutionApiFp = function (configuration) {
    const localVarAxiosParamCreator = InstitutionApiAxiosParamCreator(configuration);
    return {
        /**
         * Create institution
         * @param {Institution} institution item of institution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instCreate(institution, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.instCreate(institution, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['InstitutionApi.instCreate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete institution
         * @param {number} id institution id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.instDelete(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['InstitutionApi.instDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get list of Institutions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instGetAll(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.instGetAll(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['InstitutionApi.instGetAll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get institution by id
         * @param {string} id institution id or internalCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instGetById(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.instGetById(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['InstitutionApi.instGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get list of type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instGetTypes(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.instGetTypes(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['InstitutionApi.instGetTypes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update institution
         * @param {number} id institution id
         * @param {Institution} institution item of institurion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instUpdate(id, institution, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.instUpdate(id, institution, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['InstitutionApi.instUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * InstitutionApi - factory interface
 */
export const InstitutionApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InstitutionApiFp(configuration);
    return {
        /**
         * Create institution
         * @param {Institution} institution item of institution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instCreate(institution, options) {
            return localVarFp.instCreate(institution, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete institution
         * @param {number} id institution id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instDelete(id, options) {
            return localVarFp.instDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of Institutions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instGetAll(options) {
            return localVarFp.instGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * Get institution by id
         * @param {string} id institution id or internalCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instGetById(id, options) {
            return localVarFp.instGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instGetTypes(options) {
            return localVarFp.instGetTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * Update institution
         * @param {number} id institution id
         * @param {Institution} institution item of institurion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instUpdate(id, institution, options) {
            return localVarFp.instUpdate(id, institution, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InstitutionApi - object-oriented interface
 */
export class InstitutionApi extends BaseAPI {
    /**
     * Create institution
     * @param {Institution} institution item of institution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instCreate(institution, options) {
        return InstitutionApiFp(this.configuration).instCreate(institution, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete institution
     * @param {number} id institution id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instDelete(id, options) {
        return InstitutionApiFp(this.configuration).instDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get list of Institutions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instGetAll(options) {
        return InstitutionApiFp(this.configuration).instGetAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get institution by id
     * @param {string} id institution id or internalCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instGetById(id, options) {
        return InstitutionApiFp(this.configuration).instGetById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get list of type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instGetTypes(options) {
        return InstitutionApiFp(this.configuration).instGetTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update institution
     * @param {number} id institution id
     * @param {Institution} institution item of institurion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instUpdate(id, institution, options) {
        return InstitutionApiFp(this.configuration).instUpdate(id, institution, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * IoApi - axios parameter creator
 */
export const IoApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create export file of funds or access points
         * @param {ExportParams} exportParams Export request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioExportRequest: (exportParams_1, ...args_1) => __awaiter(this, [exportParams_1, ...args_1], void 0, function* (exportParams, options = {}) {
            // verify required parameter 'exportParams' is not null or undefined
            assertParamExists('ioExportRequest', 'exportParams', exportParams);
            const localVarPath = `/io/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(exportParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting the generated file by request id
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioGetExportFile: (requestId_1, ...args_1) => __awaiter(this, [requestId_1, ...args_1], void 0, function* (requestId, options = {}) {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('ioGetExportFile', 'requestId', requestId);
            const localVarPath = `/io/file/{requestId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting the export status by request id
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioGetExportStatus: (requestId_1, ...args_1) => __awaiter(this, [requestId_1, ...args_1], void 0, function* (requestId, options = {}) {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('ioGetExportStatus', 'requestId', requestId);
            const localVarPath = `/io/export-status/{requestId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * IoApi - functional programming interface
 */
export const IoApiFp = function (configuration) {
    const localVarAxiosParamCreator = IoApiAxiosParamCreator(configuration);
    return {
        /**
         * Create export file of funds or access points
         * @param {ExportParams} exportParams Export request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioExportRequest(exportParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ioExportRequest(exportParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IoApi.ioExportRequest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting the generated file by request id
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioGetExportFile(requestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ioGetExportFile(requestId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IoApi.ioGetExportFile']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting the export status by request id
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioGetExportStatus(requestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ioGetExportStatus(requestId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IoApi.ioGetExportStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * IoApi - factory interface
 */
export const IoApiFactory = function (configuration, basePath, axios) {
    const localVarFp = IoApiFp(configuration);
    return {
        /**
         * Create export file of funds or access points
         * @param {ExportParams} exportParams Export request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioExportRequest(exportParams, options) {
            return localVarFp.ioExportRequest(exportParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting the generated file by request id
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioGetExportFile(requestId, options) {
            return localVarFp.ioGetExportFile(requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting the export status by request id
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ioGetExportStatus(requestId, options) {
            return localVarFp.ioGetExportStatus(requestId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * IoApi - object-oriented interface
 */
export class IoApi extends BaseAPI {
    /**
     * Create export file of funds or access points
     * @param {ExportParams} exportParams Export request parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ioExportRequest(exportParams, options) {
        return IoApiFp(this.configuration).ioExportRequest(exportParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting the generated file by request id
     * @param {number} requestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ioGetExportFile(requestId, options) {
        return IoApiFp(this.configuration).ioGetExportFile(requestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting the export status by request id
     * @param {number} requestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ioGetExportStatus(requestId, options) {
        return IoApiFp(this.configuration).ioGetExportStatus(requestId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NodeApi - axios parameter creator
 */
export const NodeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Copies the attribute of the specified type from the node\'s parent
         * @param {number} versionId version id of tree
         * @param {number} descItemTypeId id of the attribute we want to copy
         * @param {NodeBase} nodeBase node to assign values from the older brother
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeCopyOlderSiblingAttribute: (versionId_1, descItemTypeId_1, nodeBase_1, ...args_1) => __awaiter(this, [versionId_1, descItemTypeId_1, nodeBase_1, ...args_1], void 0, function* (versionId, descItemTypeId, nodeBase, options = {}) {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('nodeCopyOlderSiblingAttribute', 'versionId', versionId);
            // verify required parameter 'descItemTypeId' is not null or undefined
            assertParamExists('nodeCopyOlderSiblingAttribute', 'descItemTypeId', descItemTypeId);
            // verify required parameter 'nodeBase' is not null or undefined
            assertParamExists('nodeCopyOlderSiblingAttribute', 'nodeBase', nodeBase);
            const localVarPath = `/node/copyOlderSiblingAttribute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (versionId !== undefined) {
                localVarQueryParameter['versionId'] = versionId;
            }
            if (descItemTypeId !== undefined) {
                localVarQueryParameter['descItemTypeId'] = descItemTypeId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(nodeBase, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get data for a unit of description (JP)
         * @param {NodeDataParam} nodeDataParam
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetNodeData: (nodeDataParam_1, ...args_1) => __awaiter(this, [nodeDataParam_1, ...args_1], void 0, function* (nodeDataParam, options = {}) {
            // verify required parameter 'nodeDataParam' is not null or undefined
            assertParamExists('nodeGetNodeData', 'nodeDataParam', nodeDataParam);
            const localVarPath = `/node/node-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(nodeDataParam, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get basic information about a node by its numeric ID.
         * @param {number} nodeId Node ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetNodeInfoById: (nodeId_1, ...args_1) => __awaiter(this, [nodeId_1, ...args_1], void 0, function* (nodeId, options = {}) {
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('nodeGetNodeInfoById', 'nodeId', nodeId);
            const localVarPath = `/node/info/id/{nodeId}`
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get basic information about a node by its UUID.
         * @param {string} nodeUuid Node UUID (36 characters)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetNodeInfoByUuid: (nodeUuid_1, ...args_1) => __awaiter(this, [nodeUuid_1, ...args_1], void 0, function* (nodeUuid, options = {}) {
            // verify required parameter 'nodeUuid' is not null or undefined
            assertParamExists('nodeGetNodeInfoByUuid', 'nodeUuid', nodeUuid);
            const localVarPath = `/node/info/uuid/{nodeUuid}`
                .replace(`{${"nodeUuid"}}`, encodeURIComponent(String(nodeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get quote by fundVersionId & nodeId
         * @param {number} fundVersionId
         * @param {number} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetPlainText: (fundVersionId_1, nodeId_1, ...args_1) => __awaiter(this, [fundVersionId_1, nodeId_1, ...args_1], void 0, function* (fundVersionId, nodeId, options = {}) {
            // verify required parameter 'fundVersionId' is not null or undefined
            assertParamExists('nodeGetPlainText', 'fundVersionId', fundVersionId);
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('nodeGetPlainText', 'nodeId', nodeId);
            const localVarPath = `/node/plain-text/{fundVersionId}/{nodeId}`
                .replace(`{${"fundVersionId"}}`, encodeURIComponent(String(fundVersionId)))
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search for nodes in archive file (fund)
         * @param {number} fundId Fund ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetSearchResult: (fundId_1, ...args_1) => __awaiter(this, [fundId_1, ...args_1], void 0, function* (fundId, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('nodeGetSearchResult', 'fundId', fundId);
            const localVarPath = `/node/search/{fundId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search for archive files (funds)
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeSearch: (searchParams_1, ...args_1) => __awaiter(this, [searchParams_1, ...args_1], void 0, function* (searchParams, options = {}) {
            // verify required parameter 'searchParams' is not null or undefined
            assertParamExists('nodeSearch', 'searchParams', searchParams);
            const localVarPath = `/node/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NodeApi - functional programming interface
 */
export const NodeApiFp = function (configuration) {
    const localVarAxiosParamCreator = NodeApiAxiosParamCreator(configuration);
    return {
        /**
         * Copies the attribute of the specified type from the node\'s parent
         * @param {number} versionId version id of tree
         * @param {number} descItemTypeId id of the attribute we want to copy
         * @param {NodeBase} nodeBase node to assign values from the older brother
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeCopyOlderSiblingAttribute(versionId, descItemTypeId, nodeBase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nodeCopyOlderSiblingAttribute(versionId, descItemTypeId, nodeBase, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NodeApi.nodeCopyOlderSiblingAttribute']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get data for a unit of description (JP)
         * @param {NodeDataParam} nodeDataParam
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetNodeData(nodeDataParam, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nodeGetNodeData(nodeDataParam, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NodeApi.nodeGetNodeData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get basic information about a node by its numeric ID.
         * @param {number} nodeId Node ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetNodeInfoById(nodeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nodeGetNodeInfoById(nodeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NodeApi.nodeGetNodeInfoById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get basic information about a node by its UUID.
         * @param {string} nodeUuid Node UUID (36 characters)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetNodeInfoByUuid(nodeUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nodeGetNodeInfoByUuid(nodeUuid, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NodeApi.nodeGetNodeInfoByUuid']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get quote by fundVersionId & nodeId
         * @param {number} fundVersionId
         * @param {number} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetPlainText(fundVersionId, nodeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nodeGetPlainText(fundVersionId, nodeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NodeApi.nodeGetPlainText']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Search for nodes in archive file (fund)
         * @param {number} fundId Fund ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetSearchResult(fundId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nodeGetSearchResult(fundId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NodeApi.nodeGetSearchResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Search for archive files (funds)
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeSearch(searchParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nodeSearch(searchParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['NodeApi.nodeSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * NodeApi - factory interface
 */
export const NodeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NodeApiFp(configuration);
    return {
        /**
         * Copies the attribute of the specified type from the node\'s parent
         * @param {number} versionId version id of tree
         * @param {number} descItemTypeId id of the attribute we want to copy
         * @param {NodeBase} nodeBase node to assign values from the older brother
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeCopyOlderSiblingAttribute(versionId, descItemTypeId, nodeBase, options) {
            return localVarFp.nodeCopyOlderSiblingAttribute(versionId, descItemTypeId, nodeBase, options).then((request) => request(axios, basePath));
        },
        /**
         * Get data for a unit of description (JP)
         * @param {NodeDataParam} nodeDataParam
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetNodeData(nodeDataParam, options) {
            return localVarFp.nodeGetNodeData(nodeDataParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Get basic information about a node by its numeric ID.
         * @param {number} nodeId Node ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetNodeInfoById(nodeId, options) {
            return localVarFp.nodeGetNodeInfoById(nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get basic information about a node by its UUID.
         * @param {string} nodeUuid Node UUID (36 characters)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetNodeInfoByUuid(nodeUuid, options) {
            return localVarFp.nodeGetNodeInfoByUuid(nodeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get quote by fundVersionId & nodeId
         * @param {number} fundVersionId
         * @param {number} nodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetPlainText(fundVersionId, nodeId, options) {
            return localVarFp.nodeGetPlainText(fundVersionId, nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for nodes in archive file (fund)
         * @param {number} fundId Fund ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeGetSearchResult(fundId, options) {
            return localVarFp.nodeGetSearchResult(fundId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for archive files (funds)
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeSearch(searchParams, options) {
            return localVarFp.nodeSearch(searchParams, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NodeApi - object-oriented interface
 */
export class NodeApi extends BaseAPI {
    /**
     * Copies the attribute of the specified type from the node\'s parent
     * @param {number} versionId version id of tree
     * @param {number} descItemTypeId id of the attribute we want to copy
     * @param {NodeBase} nodeBase node to assign values from the older brother
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodeCopyOlderSiblingAttribute(versionId, descItemTypeId, nodeBase, options) {
        return NodeApiFp(this.configuration).nodeCopyOlderSiblingAttribute(versionId, descItemTypeId, nodeBase, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get data for a unit of description (JP)
     * @param {NodeDataParam} nodeDataParam
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodeGetNodeData(nodeDataParam, options) {
        return NodeApiFp(this.configuration).nodeGetNodeData(nodeDataParam, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get basic information about a node by its numeric ID.
     * @param {number} nodeId Node ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodeGetNodeInfoById(nodeId, options) {
        return NodeApiFp(this.configuration).nodeGetNodeInfoById(nodeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get basic information about a node by its UUID.
     * @param {string} nodeUuid Node UUID (36 characters)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodeGetNodeInfoByUuid(nodeUuid, options) {
        return NodeApiFp(this.configuration).nodeGetNodeInfoByUuid(nodeUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get quote by fundVersionId & nodeId
     * @param {number} fundVersionId
     * @param {number} nodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodeGetPlainText(fundVersionId, nodeId, options) {
        return NodeApiFp(this.configuration).nodeGetPlainText(fundVersionId, nodeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for nodes in archive file (fund)
     * @param {number} fundId Fund ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodeGetSearchResult(fundId, options) {
        return NodeApiFp(this.configuration).nodeGetSearchResult(fundId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search for archive files (funds)
     * @param {SearchParams} searchParams search parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodeSearch(searchParams, options) {
        return NodeApiFp(this.configuration).nodeSearch(searchParams, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OutputApi - axios parameter creator
 */
export const OutputApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Adding nodes to output
         * @param {number} outputId output id
         * @param {Array<number>} requestBody list of node ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputAddNodesNamedOutput: (outputId_1, requestBody_1, ...args_1) => __awaiter(this, [outputId_1, requestBody_1, ...args_1], void 0, function* (outputId, requestBody, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputAddNodesNamedOutput', 'outputId', outputId);
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('outputAddNodesNamedOutput', 'requestBody', requestBody);
            const localVarPath = `/funds/out/{outputId}/nodes/add`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Adding template to output
         * @param {number} outputId output id
         * @param {number} templateId template id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputAddOutputTemplate: (outputId_1, templateId_1, ...args_1) => __awaiter(this, [outputId_1, templateId_1, ...args_1], void 0, function* (outputId, templateId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputAddOutputTemplate', 'outputId', outputId);
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('outputAddOutputTemplate', 'templateId', templateId);
            const localVarPath = `/funds/out/{outputId}/template/{templateId}`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Adding limiting register to output
         * @param {number} outputId output id
         * @param {number} scopeId scope id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputAddRestrictedScope: (outputId_1, scopeId_1, ...args_1) => __awaiter(this, [outputId_1, scopeId_1, ...args_1], void 0, function* (outputId, scopeId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputAddRestrictedScope', 'outputId', outputId);
            // verify required parameter 'scopeId' is not null or undefined
            assertParamExists('outputAddRestrictedScope', 'scopeId', scopeId);
            const localVarPath = `/funds/out/{outputId}/restrict/{scopeId}`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)))
                .replace(`{${"scopeId"}}`, encodeURIComponent(String(scopeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creating copy of output
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputCloneOutput: (outputId_1, ...args_1) => __awaiter(this, [outputId_1, ...args_1], void 0, function* (outputId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputCloneOutput', 'outputId', outputId);
            const localVarPath = `/funds/out/{outputId}/clone`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creating a new named output
         * @param {number} fundVersionId fund version id
         * @param {OutputNameParam} outputNameParam output parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputCreateNamedOutput: (fundVersionId_1, outputNameParam_1, ...args_1) => __awaiter(this, [fundVersionId_1, outputNameParam_1, ...args_1], void 0, function* (fundVersionId, outputNameParam, options = {}) {
            // verify required parameter 'fundVersionId' is not null or undefined
            assertParamExists('outputCreateNamedOutput', 'fundVersionId', fundVersionId);
            // verify required parameter 'outputNameParam' is not null or undefined
            assertParamExists('outputCreateNamedOutput', 'outputNameParam', outputNameParam);
            const localVarPath = `/funds/out/{fundVersionId}`
                .replace(`{${"fundVersionId"}}`, encodeURIComponent(String(fundVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(outputNameParam, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create output item
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {OutputItem} outputItem body output item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputCreateOutputItem: (outputId_1, outputVersion_1, outputItem_1, ...args_1) => __awaiter(this, [outputId_1, outputVersion_1, outputItem_1, ...args_1], void 0, function* (outputId, outputVersion, outputItem, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputCreateOutputItem', 'outputId', outputId);
            // verify required parameter 'outputVersion' is not null or undefined
            assertParamExists('outputCreateOutputItem', 'outputVersion', outputVersion);
            // verify required parameter 'outputItem' is not null or undefined
            assertParamExists('outputCreateOutputItem', 'outputItem', outputItem);
            const localVarPath = `/funds/out/item/{outputId}/{outputVersion}/create`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)))
                .replace(`{${"outputVersion"}}`, encodeURIComponent(String(outputVersion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(outputItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deleting named output
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteNamedOutput: (outputId_1, ...args_1) => __awaiter(this, [outputId_1, ...args_1], void 0, function* (outputId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputDeleteNamedOutput', 'outputId', outputId);
            const localVarPath = `/funds/out/{outputId}`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete output item
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} outputItemId output item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteOutputItem: (outputId_1, outputVersion_1, outputItemId_1, ...args_1) => __awaiter(this, [outputId_1, outputVersion_1, outputItemId_1, ...args_1], void 0, function* (outputId, outputVersion, outputItemId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputDeleteOutputItem', 'outputId', outputId);
            // verify required parameter 'outputVersion' is not null or undefined
            assertParamExists('outputDeleteOutputItem', 'outputVersion', outputVersion);
            // verify required parameter 'outputItemId' is not null or undefined
            assertParamExists('outputDeleteOutputItem', 'outputItemId', outputItemId);
            const localVarPath = `/funds/out/item/{outputId}/{outputVersion}/{outputItemId}`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)))
                .replace(`{${"outputVersion"}}`, encodeURIComponent(String(outputVersion)))
                .replace(`{${"outputItemId"}}`, encodeURIComponent(String(outputItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deleting attribute values ​​by type
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} itemTypeId item type id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteOutputItemsByType: (outputId_1, outputVersion_1, itemTypeId_1, ...args_1) => __awaiter(this, [outputId_1, outputVersion_1, itemTypeId_1, ...args_1], void 0, function* (outputId, outputVersion, itemTypeId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputDeleteOutputItemsByType', 'outputId', outputId);
            // verify required parameter 'outputVersion' is not null or undefined
            assertParamExists('outputDeleteOutputItemsByType', 'outputVersion', outputVersion);
            // verify required parameter 'itemTypeId' is not null or undefined
            assertParamExists('outputDeleteOutputItemsByType', 'itemTypeId', itemTypeId);
            const localVarPath = `/funds/out/item/{outputId}/{outputVersion}/by-type/{itemTypeId}`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)))
                .replace(`{${"outputVersion"}}`, encodeURIComponent(String(outputVersion)))
                .replace(`{${"itemTypeId"}}`, encodeURIComponent(String(itemTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deleting template from output
         * @param {number} outputId output id
         * @param {number} templateId template id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteOutputTemplate: (outputId_1, templateId_1, ...args_1) => __awaiter(this, [outputId_1, templateId_1, ...args_1], void 0, function* (outputId, templateId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputDeleteOutputTemplate', 'outputId', outputId);
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('outputDeleteOutputTemplate', 'templateId', templateId);
            const localVarPath = `/funds/out/{outputId}/template/{templateId}`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deleting limiting register from output
         * @param {number} outputId output id
         * @param {number} scopeId scope id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteRestrictedScope: (outputId_1, scopeId_1, ...args_1) => __awaiter(this, [outputId_1, scopeId_1, ...args_1], void 0, function* (outputId, scopeId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputDeleteRestrictedScope', 'outputId', outputId);
            // verify required parameter 'scopeId' is not null or undefined
            assertParamExists('outputDeleteRestrictedScope', 'scopeId', scopeId);
            const localVarPath = `/funds/out/{outputId}/restrict/{scopeId}`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)))
                .replace(`{${"scopeId"}}`, encodeURIComponent(String(scopeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Generate output
         * @param {number} outputId output id
         * @param {boolean} forced forced
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGenerateOutput: (outputId_1, forced_1, ...args_1) => __awaiter(this, [outputId_1, forced_1, ...args_1], void 0, function* (outputId, forced, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputGenerateOutput', 'outputId', outputId);
            // verify required parameter 'forced' is not null or undefined
            assertParamExists('outputGenerateOutput', 'forced', forced);
            const localVarPath = `/funds/out/{outputId}/generate`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (forced !== undefined) {
                localVarQueryParameter['forced'] = forced;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting output details: an output object linked to a named output, with a list of connected nodes.
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGetOutput: (outputId_1, ...args_1) => __awaiter(this, [outputId_1, ...args_1], void 0, function* (outputId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputGetOutput', 'outputId', outputId);
            const localVarPath = `/funds/out/{outputId}`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting data for the form
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGetOutputFormData: (outputId_1, ...args_1) => __awaiter(this, [outputId_1, ...args_1], void 0, function* (outputId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputGetOutputFormData', 'outputId', outputId);
            const localVarPath = `/funds/out/{outputId}/form`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting output types
         * @param {number} fundVersionId fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGetOutputTypes: (fundVersionId_1, ...args_1) => __awaiter(this, [fundVersionId_1, ...args_1], void 0, function* (fundVersionId, options = {}) {
            // verify required parameter 'fundVersionId' is not null or undefined
            assertParamExists('outputGetOutputTypes', 'fundVersionId', fundVersionId);
            const localVarPath = `/funds/out/types/{fundVersionId}`
                .replace(`{${"fundVersionId"}}`, encodeURIComponent(String(fundVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting list of outputs – an output object linked to a named output object
         * @param {number} fundVersionId fund version id
         * @param {OutputState} [state] output state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGetOutputs: (fundVersionId_1, state_1, ...args_1) => __awaiter(this, [fundVersionId_1, state_1, ...args_1], void 0, function* (fundVersionId, state, options = {}) {
            // verify required parameter 'fundVersionId' is not null or undefined
            assertParamExists('outputGetOutputs', 'fundVersionId', fundVersionId);
            const localVarPath = `/funds/out/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fundVersionId !== undefined) {
                localVarQueryParameter['fundVersionId'] = fundVersionId;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Downloading a CSV file from an attribute value
         * @param {number} outputId output id
         * @param {number} descItemObjectId desc item object id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputOutputItemCsvExport: (outputId_1, descItemObjectId_1, ...args_1) => __awaiter(this, [outputId_1, descItemObjectId_1, ...args_1], void 0, function* (outputId, descItemObjectId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputOutputItemCsvExport', 'outputId', outputId);
            // verify required parameter 'descItemObjectId' is not null or undefined
            assertParamExists('outputOutputItemCsvExport', 'descItemObjectId', descItemObjectId);
            const localVarPath = `/funds/out/item/{outputId}/csv/export`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (descItemObjectId !== undefined) {
                localVarQueryParameter['descItemObjectId'] = descItemObjectId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Import a CSV file; a new entry will be created with the file\'s contents
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} descItemTypeId desc item type id
         * @param {File} file CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputOutputItemCsvImport: (outputId_1, outputVersion_1, descItemTypeId_1, file_1, ...args_1) => __awaiter(this, [outputId_1, outputVersion_1, descItemTypeId_1, file_1, ...args_1], void 0, function* (outputId, outputVersion, descItemTypeId, file, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputOutputItemCsvImport', 'outputId', outputId);
            // verify required parameter 'outputVersion' is not null or undefined
            assertParamExists('outputOutputItemCsvImport', 'outputVersion', outputVersion);
            // verify required parameter 'descItemTypeId' is not null or undefined
            assertParamExists('outputOutputItemCsvImport', 'descItemTypeId', descItemTypeId);
            // verify required parameter 'file' is not null or undefined
            assertParamExists('outputOutputItemCsvImport', 'file', file);
            const localVarPath = `/funds/out/item/{outputId}/csv/import`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (outputVersion !== undefined) {
                localVarFormParams.append('outputVersion', outputVersion);
            }
            if (descItemTypeId !== undefined) {
                localVarFormParams.append('descItemTypeId', descItemTypeId);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Removing nodes from output
         * @param {number} outputId output id
         * @param {Array<number>} requestBody list of node ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputRemoveNodesNamedOutput: (outputId_1, requestBody_1, ...args_1) => __awaiter(this, [outputId_1, requestBody_1, ...args_1], void 0, function* (outputId, requestBody, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputRemoveNodesNamedOutput', 'outputId', outputId);
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('outputRemoveNodesNamedOutput', 'requestBody', requestBody);
            const localVarPath = `/funds/out/{outputId}/nodes/remove`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Reset status of a named output to \"Open\"
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputRevertToOpenState: (outputId_1, ...args_1) => __awaiter(this, [outputId_1, ...args_1], void 0, function* (outputId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputRevertToOpenState', 'outputId', outputId);
            const localVarPath = `/funds/out/{outputId}/revert`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Send output
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputSendOutput: (outputId_1, ...args_1) => __awaiter(this, [outputId_1, ...args_1], void 0, function* (outputId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputSendOutput', 'outputId', outputId);
            const localVarPath = `/funds/out/{outputId}/send`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Set the attribute to \"Undefined\"
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} outputItemTypeId output item type id
         * @param {number} [outputItemSpecId] output item spec id
         * @param {number} [outputItemObjectId] output item object id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputSetNotIdentifiedOutputItem: (outputId_1, outputVersion_1, outputItemTypeId_1, outputItemSpecId_1, outputItemObjectId_1, ...args_1) => __awaiter(this, [outputId_1, outputVersion_1, outputItemTypeId_1, outputItemSpecId_1, outputItemObjectId_1, ...args_1], void 0, function* (outputId, outputVersion, outputItemTypeId, outputItemSpecId, outputItemObjectId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputSetNotIdentifiedOutputItem', 'outputId', outputId);
            // verify required parameter 'outputVersion' is not null or undefined
            assertParamExists('outputSetNotIdentifiedOutputItem', 'outputVersion', outputVersion);
            // verify required parameter 'outputItemTypeId' is not null or undefined
            assertParamExists('outputSetNotIdentifiedOutputItem', 'outputItemTypeId', outputItemTypeId);
            const localVarPath = `/funds/out/item/{outputId}/{outputVersion}/undefined/set`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)))
                .replace(`{${"outputVersion"}}`, encodeURIComponent(String(outputVersion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (outputItemTypeId !== undefined) {
                localVarQueryParameter['outputItemTypeId'] = outputItemTypeId;
            }
            if (outputItemSpecId !== undefined) {
                localVarQueryParameter['outputItemSpecId'] = outputItemSpecId;
            }
            if (outputItemObjectId !== undefined) {
                localVarQueryParameter['outputItemObjectId'] = outputItemObjectId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Set user-defined/automatic attribute type editing
         * @param {number} outputId output id
         * @param {number} itemTypeId item type id
         * @param {boolean} manual true/false — manual (user-defined)/automatic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputSetOutputItemMode: (outputId_1, itemTypeId_1, manual_1, ...args_1) => __awaiter(this, [outputId_1, itemTypeId_1, manual_1, ...args_1], void 0, function* (outputId, itemTypeId, manual, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputSetOutputItemMode', 'outputId', outputId);
            // verify required parameter 'itemTypeId' is not null or undefined
            assertParamExists('outputSetOutputItemMode', 'itemTypeId', itemTypeId);
            // verify required parameter 'manual' is not null or undefined
            assertParamExists('outputSetOutputItemMode', 'manual', manual);
            const localVarPath = `/funds/out/{outputId}/{itemTypeId}/{manual}`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)))
                .replace(`{${"itemTypeId"}}`, encodeURIComponent(String(itemTypeId)))
                .replace(`{${"manual"}}`, encodeURIComponent(String(manual)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Reset the attribute setting to \"Undefined\"
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} outputItemObjectId output item object id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputUnsetNotIdentifiedOutputItem: (outputId_1, outputVersion_1, outputItemObjectId_1, ...args_1) => __awaiter(this, [outputId_1, outputVersion_1, outputItemObjectId_1, ...args_1], void 0, function* (outputId, outputVersion, outputItemObjectId, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputUnsetNotIdentifiedOutputItem', 'outputId', outputId);
            // verify required parameter 'outputVersion' is not null or undefined
            assertParamExists('outputUnsetNotIdentifiedOutputItem', 'outputVersion', outputVersion);
            // verify required parameter 'outputItemObjectId' is not null or undefined
            assertParamExists('outputUnsetNotIdentifiedOutputItem', 'outputItemObjectId', outputItemObjectId);
            const localVarPath = `/funds/out/item/{outputId}/{outputVersion}/{outputItemObjectId}/undefined/unset`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)))
                .replace(`{${"outputVersion"}}`, encodeURIComponent(String(outputVersion)))
                .replace(`{${"outputItemObjectId"}}`, encodeURIComponent(String(outputItemObjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update output
         * @param {number} outputId output id
         * @param {OutputNameParam} outputNameParam output parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputUpdateNamedOutput: (outputId_1, outputNameParam_1, ...args_1) => __awaiter(this, [outputId_1, outputNameParam_1, ...args_1], void 0, function* (outputId, outputNameParam, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputUpdateNamedOutput', 'outputId', outputId);
            // verify required parameter 'outputNameParam' is not null or undefined
            assertParamExists('outputUpdateNamedOutput', 'outputNameParam', outputNameParam);
            const localVarPath = `/funds/out/{outputId}/update`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(outputNameParam, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update output item
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {OutputItem} outputItem body output item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputUpdateOutputItem: (outputId_1, outputVersion_1, outputItem_1, ...args_1) => __awaiter(this, [outputId_1, outputVersion_1, outputItem_1, ...args_1], void 0, function* (outputId, outputVersion, outputItem, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputUpdateOutputItem', 'outputId', outputId);
            // verify required parameter 'outputVersion' is not null or undefined
            assertParamExists('outputUpdateOutputItem', 'outputVersion', outputVersion);
            // verify required parameter 'outputItem' is not null or undefined
            assertParamExists('outputUpdateOutputItem', 'outputItem', outputItem);
            const localVarPath = `/funds/out/item/{outputId}/{outputVersion}/update`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)))
                .replace(`{${"outputVersion"}}`, encodeURIComponent(String(outputVersion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(outputItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Configuration of generated outputs
         * @param {number} outputId output id
         * @param {OutputSettings} outputSettings body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputUpdateOutputSettings: (outputId_1, outputSettings_1, ...args_1) => __awaiter(this, [outputId_1, outputSettings_1, ...args_1], void 0, function* (outputId, outputSettings, options = {}) {
            // verify required parameter 'outputId' is not null or undefined
            assertParamExists('outputUpdateOutputSettings', 'outputId', outputId);
            // verify required parameter 'outputSettings' is not null or undefined
            assertParamExists('outputUpdateOutputSettings', 'outputSettings', outputSettings);
            const localVarPath = `/funds/out/{outputId}/settings`
                .replace(`{${"outputId"}}`, encodeURIComponent(String(outputId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(outputSettings, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OutputApi - functional programming interface
 */
export const OutputApiFp = function (configuration) {
    const localVarAxiosParamCreator = OutputApiAxiosParamCreator(configuration);
    return {
        /**
         * Adding nodes to output
         * @param {number} outputId output id
         * @param {Array<number>} requestBody list of node ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputAddNodesNamedOutput(outputId, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputAddNodesNamedOutput(outputId, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputAddNodesNamedOutput']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Adding template to output
         * @param {number} outputId output id
         * @param {number} templateId template id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputAddOutputTemplate(outputId, templateId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputAddOutputTemplate(outputId, templateId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputAddOutputTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Adding limiting register to output
         * @param {number} outputId output id
         * @param {number} scopeId scope id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputAddRestrictedScope(outputId, scopeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputAddRestrictedScope(outputId, scopeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputAddRestrictedScope']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creating copy of output
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputCloneOutput(outputId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputCloneOutput(outputId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputCloneOutput']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creating a new named output
         * @param {number} fundVersionId fund version id
         * @param {OutputNameParam} outputNameParam output parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputCreateNamedOutput(fundVersionId, outputNameParam, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputCreateNamedOutput(fundVersionId, outputNameParam, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputCreateNamedOutput']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create output item
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {OutputItem} outputItem body output item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputCreateOutputItem(outputId, outputVersion, outputItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputCreateOutputItem(outputId, outputVersion, outputItem, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputCreateOutputItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deleting named output
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteNamedOutput(outputId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputDeleteNamedOutput(outputId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputDeleteNamedOutput']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete output item
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} outputItemId output item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteOutputItem(outputId, outputVersion, outputItemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputDeleteOutputItem(outputId, outputVersion, outputItemId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputDeleteOutputItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deleting attribute values ​​by type
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} itemTypeId item type id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteOutputItemsByType(outputId, outputVersion, itemTypeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputDeleteOutputItemsByType(outputId, outputVersion, itemTypeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputDeleteOutputItemsByType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deleting template from output
         * @param {number} outputId output id
         * @param {number} templateId template id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteOutputTemplate(outputId, templateId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputDeleteOutputTemplate(outputId, templateId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputDeleteOutputTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deleting limiting register from output
         * @param {number} outputId output id
         * @param {number} scopeId scope id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteRestrictedScope(outputId, scopeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputDeleteRestrictedScope(outputId, scopeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputDeleteRestrictedScope']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Generate output
         * @param {number} outputId output id
         * @param {boolean} forced forced
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGenerateOutput(outputId, forced, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputGenerateOutput(outputId, forced, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputGenerateOutput']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting output details: an output object linked to a named output, with a list of connected nodes.
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGetOutput(outputId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputGetOutput(outputId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputGetOutput']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting data for the form
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGetOutputFormData(outputId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputGetOutputFormData(outputId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputGetOutputFormData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting output types
         * @param {number} fundVersionId fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGetOutputTypes(fundVersionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputGetOutputTypes(fundVersionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputGetOutputTypes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting list of outputs – an output object linked to a named output object
         * @param {number} fundVersionId fund version id
         * @param {OutputState} [state] output state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGetOutputs(fundVersionId, state, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputGetOutputs(fundVersionId, state, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputGetOutputs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Downloading a CSV file from an attribute value
         * @param {number} outputId output id
         * @param {number} descItemObjectId desc item object id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputOutputItemCsvExport(outputId, descItemObjectId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputOutputItemCsvExport(outputId, descItemObjectId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputOutputItemCsvExport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Import a CSV file; a new entry will be created with the file\'s contents
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} descItemTypeId desc item type id
         * @param {File} file CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputOutputItemCsvImport(outputId, outputVersion, descItemTypeId, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputOutputItemCsvImport(outputId, outputVersion, descItemTypeId, file, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputOutputItemCsvImport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Removing nodes from output
         * @param {number} outputId output id
         * @param {Array<number>} requestBody list of node ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputRemoveNodesNamedOutput(outputId, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputRemoveNodesNamedOutput(outputId, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputRemoveNodesNamedOutput']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Reset status of a named output to \"Open\"
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputRevertToOpenState(outputId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputRevertToOpenState(outputId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputRevertToOpenState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Send output
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputSendOutput(outputId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputSendOutput(outputId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputSendOutput']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Set the attribute to \"Undefined\"
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} outputItemTypeId output item type id
         * @param {number} [outputItemSpecId] output item spec id
         * @param {number} [outputItemObjectId] output item object id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputSetNotIdentifiedOutputItem(outputId, outputVersion, outputItemTypeId, outputItemSpecId, outputItemObjectId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputSetNotIdentifiedOutputItem(outputId, outputVersion, outputItemTypeId, outputItemSpecId, outputItemObjectId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputSetNotIdentifiedOutputItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Set user-defined/automatic attribute type editing
         * @param {number} outputId output id
         * @param {number} itemTypeId item type id
         * @param {boolean} manual true/false — manual (user-defined)/automatic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputSetOutputItemMode(outputId, itemTypeId, manual, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputSetOutputItemMode(outputId, itemTypeId, manual, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputSetOutputItemMode']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Reset the attribute setting to \"Undefined\"
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} outputItemObjectId output item object id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputUnsetNotIdentifiedOutputItem(outputId, outputVersion, outputItemObjectId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputUnsetNotIdentifiedOutputItem(outputId, outputVersion, outputItemObjectId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputUnsetNotIdentifiedOutputItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update output
         * @param {number} outputId output id
         * @param {OutputNameParam} outputNameParam output parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputUpdateNamedOutput(outputId, outputNameParam, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputUpdateNamedOutput(outputId, outputNameParam, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputUpdateNamedOutput']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update output item
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {OutputItem} outputItem body output item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputUpdateOutputItem(outputId, outputVersion, outputItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputUpdateOutputItem(outputId, outputVersion, outputItem, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputUpdateOutputItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Configuration of generated outputs
         * @param {number} outputId output id
         * @param {OutputSettings} outputSettings body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputUpdateOutputSettings(outputId, outputSettings, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.outputUpdateOutputSettings(outputId, outputSettings, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OutputApi.outputUpdateOutputSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * OutputApi - factory interface
 */
export const OutputApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OutputApiFp(configuration);
    return {
        /**
         * Adding nodes to output
         * @param {number} outputId output id
         * @param {Array<number>} requestBody list of node ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputAddNodesNamedOutput(outputId, requestBody, options) {
            return localVarFp.outputAddNodesNamedOutput(outputId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Adding template to output
         * @param {number} outputId output id
         * @param {number} templateId template id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputAddOutputTemplate(outputId, templateId, options) {
            return localVarFp.outputAddOutputTemplate(outputId, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Adding limiting register to output
         * @param {number} outputId output id
         * @param {number} scopeId scope id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputAddRestrictedScope(outputId, scopeId, options) {
            return localVarFp.outputAddRestrictedScope(outputId, scopeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creating copy of output
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputCloneOutput(outputId, options) {
            return localVarFp.outputCloneOutput(outputId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creating a new named output
         * @param {number} fundVersionId fund version id
         * @param {OutputNameParam} outputNameParam output parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputCreateNamedOutput(fundVersionId, outputNameParam, options) {
            return localVarFp.outputCreateNamedOutput(fundVersionId, outputNameParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Create output item
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {OutputItem} outputItem body output item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputCreateOutputItem(outputId, outputVersion, outputItem, options) {
            return localVarFp.outputCreateOutputItem(outputId, outputVersion, outputItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Deleting named output
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteNamedOutput(outputId, options) {
            return localVarFp.outputDeleteNamedOutput(outputId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete output item
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} outputItemId output item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteOutputItem(outputId, outputVersion, outputItemId, options) {
            return localVarFp.outputDeleteOutputItem(outputId, outputVersion, outputItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deleting attribute values ​​by type
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} itemTypeId item type id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteOutputItemsByType(outputId, outputVersion, itemTypeId, options) {
            return localVarFp.outputDeleteOutputItemsByType(outputId, outputVersion, itemTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deleting template from output
         * @param {number} outputId output id
         * @param {number} templateId template id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteOutputTemplate(outputId, templateId, options) {
            return localVarFp.outputDeleteOutputTemplate(outputId, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deleting limiting register from output
         * @param {number} outputId output id
         * @param {number} scopeId scope id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputDeleteRestrictedScope(outputId, scopeId, options) {
            return localVarFp.outputDeleteRestrictedScope(outputId, scopeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate output
         * @param {number} outputId output id
         * @param {boolean} forced forced
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGenerateOutput(outputId, forced, options) {
            return localVarFp.outputGenerateOutput(outputId, forced, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting output details: an output object linked to a named output, with a list of connected nodes.
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGetOutput(outputId, options) {
            return localVarFp.outputGetOutput(outputId, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting data for the form
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGetOutputFormData(outputId, options) {
            return localVarFp.outputGetOutputFormData(outputId, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting output types
         * @param {number} fundVersionId fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGetOutputTypes(fundVersionId, options) {
            return localVarFp.outputGetOutputTypes(fundVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting list of outputs – an output object linked to a named output object
         * @param {number} fundVersionId fund version id
         * @param {OutputState} [state] output state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputGetOutputs(fundVersionId, state, options) {
            return localVarFp.outputGetOutputs(fundVersionId, state, options).then((request) => request(axios, basePath));
        },
        /**
         * Downloading a CSV file from an attribute value
         * @param {number} outputId output id
         * @param {number} descItemObjectId desc item object id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputOutputItemCsvExport(outputId, descItemObjectId, options) {
            return localVarFp.outputOutputItemCsvExport(outputId, descItemObjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Import a CSV file; a new entry will be created with the file\'s contents
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} descItemTypeId desc item type id
         * @param {File} file CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputOutputItemCsvImport(outputId, outputVersion, descItemTypeId, file, options) {
            return localVarFp.outputOutputItemCsvImport(outputId, outputVersion, descItemTypeId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Removing nodes from output
         * @param {number} outputId output id
         * @param {Array<number>} requestBody list of node ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputRemoveNodesNamedOutput(outputId, requestBody, options) {
            return localVarFp.outputRemoveNodesNamedOutput(outputId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset status of a named output to \"Open\"
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputRevertToOpenState(outputId, options) {
            return localVarFp.outputRevertToOpenState(outputId, options).then((request) => request(axios, basePath));
        },
        /**
         * Send output
         * @param {number} outputId output id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputSendOutput(outputId, options) {
            return localVarFp.outputSendOutput(outputId, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the attribute to \"Undefined\"
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} outputItemTypeId output item type id
         * @param {number} [outputItemSpecId] output item spec id
         * @param {number} [outputItemObjectId] output item object id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputSetNotIdentifiedOutputItem(outputId, outputVersion, outputItemTypeId, outputItemSpecId, outputItemObjectId, options) {
            return localVarFp.outputSetNotIdentifiedOutputItem(outputId, outputVersion, outputItemTypeId, outputItemSpecId, outputItemObjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Set user-defined/automatic attribute type editing
         * @param {number} outputId output id
         * @param {number} itemTypeId item type id
         * @param {boolean} manual true/false — manual (user-defined)/automatic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputSetOutputItemMode(outputId, itemTypeId, manual, options) {
            return localVarFp.outputSetOutputItemMode(outputId, itemTypeId, manual, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset the attribute setting to \"Undefined\"
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {number} outputItemObjectId output item object id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputUnsetNotIdentifiedOutputItem(outputId, outputVersion, outputItemObjectId, options) {
            return localVarFp.outputUnsetNotIdentifiedOutputItem(outputId, outputVersion, outputItemObjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update output
         * @param {number} outputId output id
         * @param {OutputNameParam} outputNameParam output parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputUpdateNamedOutput(outputId, outputNameParam, options) {
            return localVarFp.outputUpdateNamedOutput(outputId, outputNameParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Update output item
         * @param {number} outputId output id
         * @param {number} outputVersion output version
         * @param {OutputItem} outputItem body output item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputUpdateOutputItem(outputId, outputVersion, outputItem, options) {
            return localVarFp.outputUpdateOutputItem(outputId, outputVersion, outputItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Configuration of generated outputs
         * @param {number} outputId output id
         * @param {OutputSettings} outputSettings body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        outputUpdateOutputSettings(outputId, outputSettings, options) {
            return localVarFp.outputUpdateOutputSettings(outputId, outputSettings, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OutputApi - object-oriented interface
 */
export class OutputApi extends BaseAPI {
    /**
     * Adding nodes to output
     * @param {number} outputId output id
     * @param {Array<number>} requestBody list of node ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputAddNodesNamedOutput(outputId, requestBody, options) {
        return OutputApiFp(this.configuration).outputAddNodesNamedOutput(outputId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Adding template to output
     * @param {number} outputId output id
     * @param {number} templateId template id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputAddOutputTemplate(outputId, templateId, options) {
        return OutputApiFp(this.configuration).outputAddOutputTemplate(outputId, templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Adding limiting register to output
     * @param {number} outputId output id
     * @param {number} scopeId scope id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputAddRestrictedScope(outputId, scopeId, options) {
        return OutputApiFp(this.configuration).outputAddRestrictedScope(outputId, scopeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creating copy of output
     * @param {number} outputId output id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputCloneOutput(outputId, options) {
        return OutputApiFp(this.configuration).outputCloneOutput(outputId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creating a new named output
     * @param {number} fundVersionId fund version id
     * @param {OutputNameParam} outputNameParam output parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputCreateNamedOutput(fundVersionId, outputNameParam, options) {
        return OutputApiFp(this.configuration).outputCreateNamedOutput(fundVersionId, outputNameParam, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create output item
     * @param {number} outputId output id
     * @param {number} outputVersion output version
     * @param {OutputItem} outputItem body output item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputCreateOutputItem(outputId, outputVersion, outputItem, options) {
        return OutputApiFp(this.configuration).outputCreateOutputItem(outputId, outputVersion, outputItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deleting named output
     * @param {number} outputId output id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputDeleteNamedOutput(outputId, options) {
        return OutputApiFp(this.configuration).outputDeleteNamedOutput(outputId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete output item
     * @param {number} outputId output id
     * @param {number} outputVersion output version
     * @param {number} outputItemId output item id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputDeleteOutputItem(outputId, outputVersion, outputItemId, options) {
        return OutputApiFp(this.configuration).outputDeleteOutputItem(outputId, outputVersion, outputItemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deleting attribute values ​​by type
     * @param {number} outputId output id
     * @param {number} outputVersion output version
     * @param {number} itemTypeId item type id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputDeleteOutputItemsByType(outputId, outputVersion, itemTypeId, options) {
        return OutputApiFp(this.configuration).outputDeleteOutputItemsByType(outputId, outputVersion, itemTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deleting template from output
     * @param {number} outputId output id
     * @param {number} templateId template id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputDeleteOutputTemplate(outputId, templateId, options) {
        return OutputApiFp(this.configuration).outputDeleteOutputTemplate(outputId, templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deleting limiting register from output
     * @param {number} outputId output id
     * @param {number} scopeId scope id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputDeleteRestrictedScope(outputId, scopeId, options) {
        return OutputApiFp(this.configuration).outputDeleteRestrictedScope(outputId, scopeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Generate output
     * @param {number} outputId output id
     * @param {boolean} forced forced
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputGenerateOutput(outputId, forced, options) {
        return OutputApiFp(this.configuration).outputGenerateOutput(outputId, forced, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting output details: an output object linked to a named output, with a list of connected nodes.
     * @param {number} outputId output id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputGetOutput(outputId, options) {
        return OutputApiFp(this.configuration).outputGetOutput(outputId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting data for the form
     * @param {number} outputId output id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputGetOutputFormData(outputId, options) {
        return OutputApiFp(this.configuration).outputGetOutputFormData(outputId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting output types
     * @param {number} fundVersionId fund version id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputGetOutputTypes(fundVersionId, options) {
        return OutputApiFp(this.configuration).outputGetOutputTypes(fundVersionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting list of outputs – an output object linked to a named output object
     * @param {number} fundVersionId fund version id
     * @param {OutputState} [state] output state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputGetOutputs(fundVersionId, state, options) {
        return OutputApiFp(this.configuration).outputGetOutputs(fundVersionId, state, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Downloading a CSV file from an attribute value
     * @param {number} outputId output id
     * @param {number} descItemObjectId desc item object id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputOutputItemCsvExport(outputId, descItemObjectId, options) {
        return OutputApiFp(this.configuration).outputOutputItemCsvExport(outputId, descItemObjectId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Import a CSV file; a new entry will be created with the file\'s contents
     * @param {number} outputId output id
     * @param {number} outputVersion output version
     * @param {number} descItemTypeId desc item type id
     * @param {File} file CSV file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputOutputItemCsvImport(outputId, outputVersion, descItemTypeId, file, options) {
        return OutputApiFp(this.configuration).outputOutputItemCsvImport(outputId, outputVersion, descItemTypeId, file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Removing nodes from output
     * @param {number} outputId output id
     * @param {Array<number>} requestBody list of node ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputRemoveNodesNamedOutput(outputId, requestBody, options) {
        return OutputApiFp(this.configuration).outputRemoveNodesNamedOutput(outputId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Reset status of a named output to \"Open\"
     * @param {number} outputId output id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputRevertToOpenState(outputId, options) {
        return OutputApiFp(this.configuration).outputRevertToOpenState(outputId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Send output
     * @param {number} outputId output id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputSendOutput(outputId, options) {
        return OutputApiFp(this.configuration).outputSendOutput(outputId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set the attribute to \"Undefined\"
     * @param {number} outputId output id
     * @param {number} outputVersion output version
     * @param {number} outputItemTypeId output item type id
     * @param {number} [outputItemSpecId] output item spec id
     * @param {number} [outputItemObjectId] output item object id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputSetNotIdentifiedOutputItem(outputId, outputVersion, outputItemTypeId, outputItemSpecId, outputItemObjectId, options) {
        return OutputApiFp(this.configuration).outputSetNotIdentifiedOutputItem(outputId, outputVersion, outputItemTypeId, outputItemSpecId, outputItemObjectId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set user-defined/automatic attribute type editing
     * @param {number} outputId output id
     * @param {number} itemTypeId item type id
     * @param {boolean} manual true/false — manual (user-defined)/automatic
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputSetOutputItemMode(outputId, itemTypeId, manual, options) {
        return OutputApiFp(this.configuration).outputSetOutputItemMode(outputId, itemTypeId, manual, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Reset the attribute setting to \"Undefined\"
     * @param {number} outputId output id
     * @param {number} outputVersion output version
     * @param {number} outputItemObjectId output item object id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputUnsetNotIdentifiedOutputItem(outputId, outputVersion, outputItemObjectId, options) {
        return OutputApiFp(this.configuration).outputUnsetNotIdentifiedOutputItem(outputId, outputVersion, outputItemObjectId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update output
     * @param {number} outputId output id
     * @param {OutputNameParam} outputNameParam output parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputUpdateNamedOutput(outputId, outputNameParam, options) {
        return OutputApiFp(this.configuration).outputUpdateNamedOutput(outputId, outputNameParam, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update output item
     * @param {number} outputId output id
     * @param {number} outputVersion output version
     * @param {OutputItem} outputItem body output item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputUpdateOutputItem(outputId, outputVersion, outputItem, options) {
        return OutputApiFp(this.configuration).outputUpdateOutputItem(outputId, outputVersion, outputItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Configuration of generated outputs
     * @param {number} outputId output id
     * @param {OutputSettings} outputSettings body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    outputUpdateOutputSettings(outputId, outputSettings, options) {
        return OutputApiFp(this.configuration).outputUpdateOutputSettings(outputId, outputSettings, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PublicationApi - axios parameter creator
 */
export const PublicationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Download the prepared XML.  The client should only call this with an ID it received from `/available`. The download succeeds as long as the XML file is physically present on the server; each successful download updates the internal audit trail of the last fetch.  The file is returned as `application/xml` with header `Content-Disposition: attachment; filename=\"{mark}-{fundNumber}-{publicationId}.xml\"`. If the fund has neither `mark` nor `fundNumber` set, the fallback `fundId-{fundId}-{publicationId}.xml` is used.  HTTP responses: - 200 + XML — the file is available - 403       — the publication type has been deactivated - 404       — unknown ID, or an ID in an internal state that is not exposed to the client (e.g. preparation in progress — such IDs are never returned by `/available` and the client should not encounter them) - 410       — the file is permanently unavailable to the client (publication invalidated by the user, or retention expired)
         * @param {number} id Publication identifier (ARR_EXPORT.export_id).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationDownloadPublication: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('publicationDownloadPublication', 'id', id);
            const localVarPath = `/publications/download/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of prepared XML exports for a given target system.  On the first call `lastTransaction` is omitted. The response carries `nextTransaction`, which the caller stores and sends in the next request as `lastTransaction`. This way only new exports since the previous call are returned.  At most 100 records are returned. If multiple prepared exports exist for the same fund, only the most recent one is included.  If the publication type (target system) is inactive, the call returns 403 — information about prepared exports is not exposed in that case.
         * @param {string} targetSystem Publication type code (ARR_EXPORT_TYPE.code), which also identifies the target system.
         * @param {string} [lastTransaction] Opaque key of the last already-processed transaction. Omitted on the first call. The caller must not parse the key — Elza reserves the right to change its format in the future.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationGetAvailablePublications: (targetSystem_1, lastTransaction_1, ...args_1) => __awaiter(this, [targetSystem_1, lastTransaction_1, ...args_1], void 0, function* (targetSystem, lastTransaction, options = {}) {
            // verify required parameter 'targetSystem' is not null or undefined
            assertParamExists('publicationGetAvailablePublications', 'targetSystem', targetSystem);
            const localVarPath = `/publications/available/{targetSystem}`
                .replace(`{${"targetSystem"}}`, encodeURIComponent(String(targetSystem)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (lastTransaction !== undefined) {
                localVarQueryParameter['lastTransaction'] = lastTransaction;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Report the publication outcome from the publication system.  The client reports the outcome of a publication it has been working with — typically after a successful `/download/{id}`, but a report from a publication that was prepared and not yet marked as fetched is also accepted (e.g. when the download response was lost in transit but the publication system still processed the file).  - status OK    — publication succeeded - status ERROR — publication failed  The call is last-writer-wins: a publication system that gets resynchronised may report the same publication any number of times — identical replays are no-ops, new values silently overwrite. Rate-limiting / conflict detection may be added in a later revision.
         * @param {number} id Publication identifier (ARR_EXPORT.export_id).
         * @param {PublicationStatusReport} publicationStatusReport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationReportPublicationStatus: (id_1, publicationStatusReport_1, ...args_1) => __awaiter(this, [id_1, publicationStatusReport_1, ...args_1], void 0, function* (id, publicationStatusReport, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('publicationReportPublicationStatus', 'id', id);
            // verify required parameter 'publicationStatusReport' is not null or undefined
            assertParamExists('publicationReportPublicationStatus', 'publicationStatusReport', publicationStatusReport);
            const localVarPath = `/publications/status/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(publicationStatusReport, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PublicationApi - functional programming interface
 */
export const PublicationApiFp = function (configuration) {
    const localVarAxiosParamCreator = PublicationApiAxiosParamCreator(configuration);
    return {
        /**
         * Download the prepared XML.  The client should only call this with an ID it received from `/available`. The download succeeds as long as the XML file is physically present on the server; each successful download updates the internal audit trail of the last fetch.  The file is returned as `application/xml` with header `Content-Disposition: attachment; filename=\"{mark}-{fundNumber}-{publicationId}.xml\"`. If the fund has neither `mark` nor `fundNumber` set, the fallback `fundId-{fundId}-{publicationId}.xml` is used.  HTTP responses: - 200 + XML — the file is available - 403       — the publication type has been deactivated - 404       — unknown ID, or an ID in an internal state that is not exposed to the client (e.g. preparation in progress — such IDs are never returned by `/available` and the client should not encounter them) - 410       — the file is permanently unavailable to the client (publication invalidated by the user, or retention expired)
         * @param {number} id Publication identifier (ARR_EXPORT.export_id).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationDownloadPublication(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publicationDownloadPublication(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PublicationApi.publicationDownloadPublication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get the list of prepared XML exports for a given target system.  On the first call `lastTransaction` is omitted. The response carries `nextTransaction`, which the caller stores and sends in the next request as `lastTransaction`. This way only new exports since the previous call are returned.  At most 100 records are returned. If multiple prepared exports exist for the same fund, only the most recent one is included.  If the publication type (target system) is inactive, the call returns 403 — information about prepared exports is not exposed in that case.
         * @param {string} targetSystem Publication type code (ARR_EXPORT_TYPE.code), which also identifies the target system.
         * @param {string} [lastTransaction] Opaque key of the last already-processed transaction. Omitted on the first call. The caller must not parse the key — Elza reserves the right to change its format in the future.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationGetAvailablePublications(targetSystem, lastTransaction, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publicationGetAvailablePublications(targetSystem, lastTransaction, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PublicationApi.publicationGetAvailablePublications']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Report the publication outcome from the publication system.  The client reports the outcome of a publication it has been working with — typically after a successful `/download/{id}`, but a report from a publication that was prepared and not yet marked as fetched is also accepted (e.g. when the download response was lost in transit but the publication system still processed the file).  - status OK    — publication succeeded - status ERROR — publication failed  The call is last-writer-wins: a publication system that gets resynchronised may report the same publication any number of times — identical replays are no-ops, new values silently overwrite. Rate-limiting / conflict detection may be added in a later revision.
         * @param {number} id Publication identifier (ARR_EXPORT.export_id).
         * @param {PublicationStatusReport} publicationStatusReport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationReportPublicationStatus(id, publicationStatusReport, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publicationReportPublicationStatus(id, publicationStatusReport, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PublicationApi.publicationReportPublicationStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * PublicationApi - factory interface
 */
export const PublicationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PublicationApiFp(configuration);
    return {
        /**
         * Download the prepared XML.  The client should only call this with an ID it received from `/available`. The download succeeds as long as the XML file is physically present on the server; each successful download updates the internal audit trail of the last fetch.  The file is returned as `application/xml` with header `Content-Disposition: attachment; filename=\"{mark}-{fundNumber}-{publicationId}.xml\"`. If the fund has neither `mark` nor `fundNumber` set, the fallback `fundId-{fundId}-{publicationId}.xml` is used.  HTTP responses: - 200 + XML — the file is available - 403       — the publication type has been deactivated - 404       — unknown ID, or an ID in an internal state that is not exposed to the client (e.g. preparation in progress — such IDs are never returned by `/available` and the client should not encounter them) - 410       — the file is permanently unavailable to the client (publication invalidated by the user, or retention expired)
         * @param {number} id Publication identifier (ARR_EXPORT.export_id).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationDownloadPublication(id, options) {
            return localVarFp.publicationDownloadPublication(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of prepared XML exports for a given target system.  On the first call `lastTransaction` is omitted. The response carries `nextTransaction`, which the caller stores and sends in the next request as `lastTransaction`. This way only new exports since the previous call are returned.  At most 100 records are returned. If multiple prepared exports exist for the same fund, only the most recent one is included.  If the publication type (target system) is inactive, the call returns 403 — information about prepared exports is not exposed in that case.
         * @param {string} targetSystem Publication type code (ARR_EXPORT_TYPE.code), which also identifies the target system.
         * @param {string} [lastTransaction] Opaque key of the last already-processed transaction. Omitted on the first call. The caller must not parse the key — Elza reserves the right to change its format in the future.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationGetAvailablePublications(targetSystem, lastTransaction, options) {
            return localVarFp.publicationGetAvailablePublications(targetSystem, lastTransaction, options).then((request) => request(axios, basePath));
        },
        /**
         * Report the publication outcome from the publication system.  The client reports the outcome of a publication it has been working with — typically after a successful `/download/{id}`, but a report from a publication that was prepared and not yet marked as fetched is also accepted (e.g. when the download response was lost in transit but the publication system still processed the file).  - status OK    — publication succeeded - status ERROR — publication failed  The call is last-writer-wins: a publication system that gets resynchronised may report the same publication any number of times — identical replays are no-ops, new values silently overwrite. Rate-limiting / conflict detection may be added in a later revision.
         * @param {number} id Publication identifier (ARR_EXPORT.export_id).
         * @param {PublicationStatusReport} publicationStatusReport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationReportPublicationStatus(id, publicationStatusReport, options) {
            return localVarFp.publicationReportPublicationStatus(id, publicationStatusReport, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PublicationApi - object-oriented interface
 */
export class PublicationApi extends BaseAPI {
    /**
     * Download the prepared XML.  The client should only call this with an ID it received from `/available`. The download succeeds as long as the XML file is physically present on the server; each successful download updates the internal audit trail of the last fetch.  The file is returned as `application/xml` with header `Content-Disposition: attachment; filename=\"{mark}-{fundNumber}-{publicationId}.xml\"`. If the fund has neither `mark` nor `fundNumber` set, the fallback `fundId-{fundId}-{publicationId}.xml` is used.  HTTP responses: - 200 + XML — the file is available - 403       — the publication type has been deactivated - 404       — unknown ID, or an ID in an internal state that is not exposed to the client (e.g. preparation in progress — such IDs are never returned by `/available` and the client should not encounter them) - 410       — the file is permanently unavailable to the client (publication invalidated by the user, or retention expired)
     * @param {number} id Publication identifier (ARR_EXPORT.export_id).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicationDownloadPublication(id, options) {
        return PublicationApiFp(this.configuration).publicationDownloadPublication(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of prepared XML exports for a given target system.  On the first call `lastTransaction` is omitted. The response carries `nextTransaction`, which the caller stores and sends in the next request as `lastTransaction`. This way only new exports since the previous call are returned.  At most 100 records are returned. If multiple prepared exports exist for the same fund, only the most recent one is included.  If the publication type (target system) is inactive, the call returns 403 — information about prepared exports is not exposed in that case.
     * @param {string} targetSystem Publication type code (ARR_EXPORT_TYPE.code), which also identifies the target system.
     * @param {string} [lastTransaction] Opaque key of the last already-processed transaction. Omitted on the first call. The caller must not parse the key — Elza reserves the right to change its format in the future.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicationGetAvailablePublications(targetSystem, lastTransaction, options) {
        return PublicationApiFp(this.configuration).publicationGetAvailablePublications(targetSystem, lastTransaction, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Report the publication outcome from the publication system.  The client reports the outcome of a publication it has been working with — typically after a successful `/download/{id}`, but a report from a publication that was prepared and not yet marked as fetched is also accepted (e.g. when the download response was lost in transit but the publication system still processed the file).  - status OK    — publication succeeded - status ERROR — publication failed  The call is last-writer-wins: a publication system that gets resynchronised may report the same publication any number of times — identical replays are no-ops, new values silently overwrite. Rate-limiting / conflict detection may be added in a later revision.
     * @param {number} id Publication identifier (ARR_EXPORT.export_id).
     * @param {PublicationStatusReport} publicationStatusReport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicationReportPublicationStatus(id, publicationStatusReport, options) {
        return PublicationApiFp(this.configuration).publicationReportPublicationStatus(id, publicationStatusReport, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PublicationInternalApi - axios parameter creator
 */
export const PublicationInternalApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Copy an existing publication into another target system.  The target publication type must have a compatible filter setting (same {
         * @param {number} fundId Fund ID
         * @param {number} publicationId Publication ID (ARR_EXPORT.export_id).
         * @param {CopyPublication} copyPublication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationCopyFundPublication: (fundId_1, publicationId_1, copyPublication_1, ...args_1) => __awaiter(this, [fundId_1, publicationId_1, copyPublication_1, ...args_1], void 0, function* (fundId, publicationId, copyPublication, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundPublicationCopyFundPublication', 'fundId', fundId);
            // verify required parameter 'publicationId' is not null or undefined
            assertParamExists('fundPublicationCopyFundPublication', 'publicationId', publicationId);
            // verify required parameter 'copyPublication' is not null or undefined
            assertParamExists('fundPublicationCopyFundPublication', 'copyPublication', copyPublication);
            const localVarPath = `/fund/{fundId}/publication/{publicationId}/copy`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"publicationId"}}`, encodeURIComponent(String(publicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(copyPublication, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Enqueue a new publication for the current open version of the fund.  Rejected with 409 if the current fund version already has a publication of the same type in {
         * @param {number} fundId Fund ID
         * @param {CreatePublication} createPublication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationCreateFundPublication: (fundId_1, createPublication_1, ...args_1) => __awaiter(this, [fundId_1, createPublication_1, ...args_1], void 0, function* (fundId, createPublication, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundPublicationCreateFundPublication', 'fundId', fundId);
            // verify required parameter 'createPublication' is not null or undefined
            assertParamExists('fundPublicationCreateFundPublication', 'createPublication', createPublication);
            const localVarPath = `/fund/{fundId}/publication`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createPublication, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Download the prepared XML from the UI.  Unlike the public {
         * @param {number} fundId Fund ID
         * @param {number} publicationId Publication ID (ARR_EXPORT.export_id).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationDownloadFundPublication: (fundId_1, publicationId_1, ...args_1) => __awaiter(this, [fundId_1, publicationId_1, ...args_1], void 0, function* (fundId, publicationId, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundPublicationDownloadFundPublication', 'fundId', fundId);
            // verify required parameter 'publicationId' is not null or undefined
            assertParamExists('fundPublicationDownloadFundPublication', 'publicationId', publicationId);
            const localVarPath = `/fund/{fundId}/publication/{publicationId}/download`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"publicationId"}}`, encodeURIComponent(String(publicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invalidate a publication.  The associated DMS file is deleted from disk; the {
         * @param {number} fundId Fund ID
         * @param {number} publicationId Publication ID (ARR_EXPORT.export_id).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationInvalidateFundPublication: (fundId_1, publicationId_1, ...args_1) => __awaiter(this, [fundId_1, publicationId_1, ...args_1], void 0, function* (fundId, publicationId, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundPublicationInvalidateFundPublication', 'fundId', fundId);
            // verify required parameter 'publicationId' is not null or undefined
            assertParamExists('fundPublicationInvalidateFundPublication', 'publicationId', publicationId);
            const localVarPath = `/fund/{fundId}/publication/{publicationId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"publicationId"}}`, encodeURIComponent(String(publicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return the publications for a fund, newest first.  The UI must paginate — the list can grow large.
         * @param {number} fundId Fund ID
         * @param {number} [publicationTypeId] Optional filter on publication type.
         * @param {number} [offset] Offset for pagination.
         * @param {number} [limit] Page size.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationListFundPublications: (fundId_1, publicationTypeId_1, offset_1, limit_1, ...args_1) => __awaiter(this, [fundId_1, publicationTypeId_1, offset_1, limit_1, ...args_1], void 0, function* (fundId, publicationTypeId, offset, limit, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('fundPublicationListFundPublications', 'fundId', fundId);
            const localVarPath = `/fund/{fundId}/publication`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (publicationTypeId !== undefined) {
                localVarQueryParameter['publicationTypeId'] = publicationTypeId;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a new publication type.
         * @param {PublicationType} publicationType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationTypeAdminCreatePublicationType: (publicationType_1, ...args_1) => __awaiter(this, [publicationType_1, ...args_1], void 0, function* (publicationType, options = {}) {
            // verify required parameter 'publicationType' is not null or undefined
            assertParamExists('publicationTypeAdminCreatePublicationType', 'publicationType', publicationType);
            const localVarPath = `/publication/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(publicationType, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Remove a publication type.  Deactivating via {
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationTypeAdminDeletePublicationType: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('publicationTypeAdminDeletePublicationType', 'id', id);
            const localVarPath = `/publication/types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return all publication types, including inactive ones.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationTypeAdminListPublicationTypes: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/publication/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update an existing publication type.
         * @param {number} id
         * @param {PublicationType} publicationType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationTypeAdminUpdatePublicationType: (id_1, publicationType_1, ...args_1) => __awaiter(this, [id_1, publicationType_1, ...args_1], void 0, function* (id, publicationType, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('publicationTypeAdminUpdatePublicationType', 'id', id);
            // verify required parameter 'publicationType' is not null or undefined
            assertParamExists('publicationTypeAdminUpdatePublicationType', 'publicationType', publicationType);
            const localVarPath = `/publication/types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(publicationType, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PublicationInternalApi - functional programming interface
 */
export const PublicationInternalApiFp = function (configuration) {
    const localVarAxiosParamCreator = PublicationInternalApiAxiosParamCreator(configuration);
    return {
        /**
         * Copy an existing publication into another target system.  The target publication type must have a compatible filter setting (same {
         * @param {number} fundId Fund ID
         * @param {number} publicationId Publication ID (ARR_EXPORT.export_id).
         * @param {CopyPublication} copyPublication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationCopyFundPublication(fundId, publicationId, copyPublication, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundPublicationCopyFundPublication(fundId, publicationId, copyPublication, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PublicationInternalApi.fundPublicationCopyFundPublication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Enqueue a new publication for the current open version of the fund.  Rejected with 409 if the current fund version already has a publication of the same type in {
         * @param {number} fundId Fund ID
         * @param {CreatePublication} createPublication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationCreateFundPublication(fundId, createPublication, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundPublicationCreateFundPublication(fundId, createPublication, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PublicationInternalApi.fundPublicationCreateFundPublication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Download the prepared XML from the UI.  Unlike the public {
         * @param {number} fundId Fund ID
         * @param {number} publicationId Publication ID (ARR_EXPORT.export_id).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationDownloadFundPublication(fundId, publicationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundPublicationDownloadFundPublication(fundId, publicationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PublicationInternalApi.fundPublicationDownloadFundPublication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Invalidate a publication.  The associated DMS file is deleted from disk; the {
         * @param {number} fundId Fund ID
         * @param {number} publicationId Publication ID (ARR_EXPORT.export_id).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationInvalidateFundPublication(fundId, publicationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundPublicationInvalidateFundPublication(fundId, publicationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PublicationInternalApi.fundPublicationInvalidateFundPublication']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return the publications for a fund, newest first.  The UI must paginate — the list can grow large.
         * @param {number} fundId Fund ID
         * @param {number} [publicationTypeId] Optional filter on publication type.
         * @param {number} [offset] Offset for pagination.
         * @param {number} [limit] Page size.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationListFundPublications(fundId, publicationTypeId, offset, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fundPublicationListFundPublications(fundId, publicationTypeId, offset, limit, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PublicationInternalApi.fundPublicationListFundPublications']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a new publication type.
         * @param {PublicationType} publicationType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationTypeAdminCreatePublicationType(publicationType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publicationTypeAdminCreatePublicationType(publicationType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PublicationInternalApi.publicationTypeAdminCreatePublicationType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Remove a publication type.  Deactivating via {
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationTypeAdminDeletePublicationType(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publicationTypeAdminDeletePublicationType(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PublicationInternalApi.publicationTypeAdminDeletePublicationType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Return all publication types, including inactive ones.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationTypeAdminListPublicationTypes(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publicationTypeAdminListPublicationTypes(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PublicationInternalApi.publicationTypeAdminListPublicationTypes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update an existing publication type.
         * @param {number} id
         * @param {PublicationType} publicationType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationTypeAdminUpdatePublicationType(id, publicationType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publicationTypeAdminUpdatePublicationType(id, publicationType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PublicationInternalApi.publicationTypeAdminUpdatePublicationType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * PublicationInternalApi - factory interface
 */
export const PublicationInternalApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PublicationInternalApiFp(configuration);
    return {
        /**
         * Copy an existing publication into another target system.  The target publication type must have a compatible filter setting (same {
         * @param {number} fundId Fund ID
         * @param {number} publicationId Publication ID (ARR_EXPORT.export_id).
         * @param {CopyPublication} copyPublication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationCopyFundPublication(fundId, publicationId, copyPublication, options) {
            return localVarFp.fundPublicationCopyFundPublication(fundId, publicationId, copyPublication, options).then((request) => request(axios, basePath));
        },
        /**
         * Enqueue a new publication for the current open version of the fund.  Rejected with 409 if the current fund version already has a publication of the same type in {
         * @param {number} fundId Fund ID
         * @param {CreatePublication} createPublication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationCreateFundPublication(fundId, createPublication, options) {
            return localVarFp.fundPublicationCreateFundPublication(fundId, createPublication, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the prepared XML from the UI.  Unlike the public {
         * @param {number} fundId Fund ID
         * @param {number} publicationId Publication ID (ARR_EXPORT.export_id).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationDownloadFundPublication(fundId, publicationId, options) {
            return localVarFp.fundPublicationDownloadFundPublication(fundId, publicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Invalidate a publication.  The associated DMS file is deleted from disk; the {
         * @param {number} fundId Fund ID
         * @param {number} publicationId Publication ID (ARR_EXPORT.export_id).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationInvalidateFundPublication(fundId, publicationId, options) {
            return localVarFp.fundPublicationInvalidateFundPublication(fundId, publicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the publications for a fund, newest first.  The UI must paginate — the list can grow large.
         * @param {number} fundId Fund ID
         * @param {number} [publicationTypeId] Optional filter on publication type.
         * @param {number} [offset] Offset for pagination.
         * @param {number} [limit] Page size.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fundPublicationListFundPublications(fundId, publicationTypeId, offset, limit, options) {
            return localVarFp.fundPublicationListFundPublications(fundId, publicationTypeId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new publication type.
         * @param {PublicationType} publicationType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationTypeAdminCreatePublicationType(publicationType, options) {
            return localVarFp.publicationTypeAdminCreatePublicationType(publicationType, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a publication type.  Deactivating via {
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationTypeAdminDeletePublicationType(id, options) {
            return localVarFp.publicationTypeAdminDeletePublicationType(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Return all publication types, including inactive ones.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationTypeAdminListPublicationTypes(options) {
            return localVarFp.publicationTypeAdminListPublicationTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing publication type.
         * @param {number} id
         * @param {PublicationType} publicationType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicationTypeAdminUpdatePublicationType(id, publicationType, options) {
            return localVarFp.publicationTypeAdminUpdatePublicationType(id, publicationType, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PublicationInternalApi - object-oriented interface
 */
export class PublicationInternalApi extends BaseAPI {
    /**
     * Copy an existing publication into another target system.  The target publication type must have a compatible filter setting (same {
     * @param {number} fundId Fund ID
     * @param {number} publicationId Publication ID (ARR_EXPORT.export_id).
     * @param {CopyPublication} copyPublication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundPublicationCopyFundPublication(fundId, publicationId, copyPublication, options) {
        return PublicationInternalApiFp(this.configuration).fundPublicationCopyFundPublication(fundId, publicationId, copyPublication, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Enqueue a new publication for the current open version of the fund.  Rejected with 409 if the current fund version already has a publication of the same type in {
     * @param {number} fundId Fund ID
     * @param {CreatePublication} createPublication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundPublicationCreateFundPublication(fundId, createPublication, options) {
        return PublicationInternalApiFp(this.configuration).fundPublicationCreateFundPublication(fundId, createPublication, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Download the prepared XML from the UI.  Unlike the public {
     * @param {number} fundId Fund ID
     * @param {number} publicationId Publication ID (ARR_EXPORT.export_id).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundPublicationDownloadFundPublication(fundId, publicationId, options) {
        return PublicationInternalApiFp(this.configuration).fundPublicationDownloadFundPublication(fundId, publicationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Invalidate a publication.  The associated DMS file is deleted from disk; the {
     * @param {number} fundId Fund ID
     * @param {number} publicationId Publication ID (ARR_EXPORT.export_id).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundPublicationInvalidateFundPublication(fundId, publicationId, options) {
        return PublicationInternalApiFp(this.configuration).fundPublicationInvalidateFundPublication(fundId, publicationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return the publications for a fund, newest first.  The UI must paginate — the list can grow large.
     * @param {number} fundId Fund ID
     * @param {number} [publicationTypeId] Optional filter on publication type.
     * @param {number} [offset] Offset for pagination.
     * @param {number} [limit] Page size.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundPublicationListFundPublications(fundId, publicationTypeId, offset, limit, options) {
        return PublicationInternalApiFp(this.configuration).fundPublicationListFundPublications(fundId, publicationTypeId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new publication type.
     * @param {PublicationType} publicationType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicationTypeAdminCreatePublicationType(publicationType, options) {
        return PublicationInternalApiFp(this.configuration).publicationTypeAdminCreatePublicationType(publicationType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a publication type.  Deactivating via {
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicationTypeAdminDeletePublicationType(id, options) {
        return PublicationInternalApiFp(this.configuration).publicationTypeAdminDeletePublicationType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return all publication types, including inactive ones.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicationTypeAdminListPublicationTypes(options) {
        return PublicationInternalApiFp(this.configuration).publicationTypeAdminListPublicationTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an existing publication type.
     * @param {number} id
     * @param {PublicationType} publicationType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicationTypeAdminUpdatePublicationType(id, publicationType, options) {
        return PublicationInternalApiFp(this.configuration).publicationTypeAdminUpdatePublicationType(id, publicationType, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ReportApi - axios parameter creator
 */
export const ReportApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Run generating statistics
         * @param {string} code statistický kód pro generování
         * @param {ReportReportParameters} reportReportParameters hodnoty zadaných parametrů
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGenerateReport: (code_1, reportReportParameters_1, ...args_1) => __awaiter(this, [code_1, reportReportParameters_1, ...args_1], void 0, function* (code, reportReportParameters, options = {}) {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('reportGenerateReport', 'code', code);
            // verify required parameter 'reportReportParameters' is not null or undefined
            assertParamExists('reportGenerateReport', 'reportReportParameters', reportReportParameters);
            const localVarPath = `/report/generate/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(reportReportParameters, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting a list of categories  and report definitions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetDefinitions: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/report/definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Download statistics results by request id
         * @param {number} requestId
         * @param {ReportReportFormat} format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetReport: (requestId_1, format_1, ...args_1) => __awaiter(this, [requestId_1, format_1, ...args_1], void 0, function* (requestId, format, options = {}) {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('reportGetReport', 'requestId', requestId);
            // verify required parameter 'format' is not null or undefined
            assertParamExists('reportGetReport', 'format', format);
            const localVarPath = `/report/{requestId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the status of running statistics
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetReportStatus: (requestId_1, ...args_1) => __awaiter(this, [requestId_1, ...args_1], void 0, function* (requestId, options = {}) {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('reportGetReportStatus', 'requestId', requestId);
            const localVarPath = `/report/status/{requestId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ReportApi - functional programming interface
 */
export const ReportApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration);
    return {
        /**
         * Run generating statistics
         * @param {string} code statistický kód pro generování
         * @param {ReportReportParameters} reportReportParameters hodnoty zadaných parametrů
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGenerateReport(code, reportReportParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportGenerateReport(code, reportReportParameters, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReportApi.reportGenerateReport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting a list of categories  and report definitions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetDefinitions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportGetDefinitions(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReportApi.reportGetDefinitions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Download statistics results by request id
         * @param {number} requestId
         * @param {ReportReportFormat} format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetReport(requestId, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportGetReport(requestId, format, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReportApi.reportGetReport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get the status of running statistics
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetReportStatus(requestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportGetReportStatus(requestId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReportApi.reportGetReportStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ReportApi - factory interface
 */
export const ReportApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReportApiFp(configuration);
    return {
        /**
         * Run generating statistics
         * @param {string} code statistický kód pro generování
         * @param {ReportReportParameters} reportReportParameters hodnoty zadaných parametrů
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGenerateReport(code, reportReportParameters, options) {
            return localVarFp.reportGenerateReport(code, reportReportParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting a list of categories  and report definitions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetDefinitions(options) {
            return localVarFp.reportGetDefinitions(options).then((request) => request(axios, basePath));
        },
        /**
         * Download statistics results by request id
         * @param {number} requestId
         * @param {ReportReportFormat} format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetReport(requestId, format, options) {
            return localVarFp.reportGetReport(requestId, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the status of running statistics
         * @param {number} requestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGetReportStatus(requestId, options) {
            return localVarFp.reportGetReportStatus(requestId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReportApi - object-oriented interface
 */
export class ReportApi extends BaseAPI {
    /**
     * Run generating statistics
     * @param {string} code statistický kód pro generování
     * @param {ReportReportParameters} reportReportParameters hodnoty zadaných parametrů
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportGenerateReport(code, reportReportParameters, options) {
        return ReportApiFp(this.configuration).reportGenerateReport(code, reportReportParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting a list of categories  and report definitions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportGetDefinitions(options) {
        return ReportApiFp(this.configuration).reportGetDefinitions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Download statistics results by request id
     * @param {number} requestId
     * @param {ReportReportFormat} format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportGetReport(requestId, format, options) {
        return ReportApiFp(this.configuration).reportGetReport(requestId, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the status of running statistics
     * @param {number} requestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportGetReportStatus(requestId, options) {
        return ReportApiFp(this.configuration).reportGetReportStatus(requestId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RulesApi - axios parameter creator
 */
export const RulesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns item types together with their specifications and rendering hints. By default all item types across loaded rule sets; when `ruleSetCode` is given, only the item types available in that rule set.  Public URL: `GET /api/v1/rules/itemTypes`.  Localized strings (`name`, `shortcut`, `description` on `ItemType` and `ItemTypeSpec`, plus `name` on `ItemTableColumn`) honour the `Accept-Language` request header when provided; otherwise the server default language is used.  Replaces the legacy `GET /api/rule/descItemTypes`.
         * @param {string} [ruleSetCode] When set, return only the item types available in this rule set (&#x60;RulRuleSet.code&#x60;); otherwise all loaded rule sets.
         * @param {string} [acceptLanguage] Preferred language for localized strings (e.g. \&quot;cs\&quot;, \&quot;en\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rulesListItemTypes: (ruleSetCode_1, acceptLanguage_1, ...args_1) => __awaiter(this, [ruleSetCode_1, acceptLanguage_1, ...args_1], void 0, function* (ruleSetCode, acceptLanguage, options = {}) {
            const localVarPath = `/rules/itemTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ruleSetCode !== undefined) {
                localVarQueryParameter['ruleSetCode'] = ruleSetCode;
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all types of parts.  Public URL: `GET /api/v1/rules/partTypes`.  Replaces the legacy `GET /api/structure/part-type`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rulesListPartTypes: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/rules/partTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RulesApi - functional programming interface
 */
export const RulesApiFp = function (configuration) {
    const localVarAxiosParamCreator = RulesApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns item types together with their specifications and rendering hints. By default all item types across loaded rule sets; when `ruleSetCode` is given, only the item types available in that rule set.  Public URL: `GET /api/v1/rules/itemTypes`.  Localized strings (`name`, `shortcut`, `description` on `ItemType` and `ItemTypeSpec`, plus `name` on `ItemTableColumn`) honour the `Accept-Language` request header when provided; otherwise the server default language is used.  Replaces the legacy `GET /api/rule/descItemTypes`.
         * @param {string} [ruleSetCode] When set, return only the item types available in this rule set (&#x60;RulRuleSet.code&#x60;); otherwise all loaded rule sets.
         * @param {string} [acceptLanguage] Preferred language for localized strings (e.g. \&quot;cs\&quot;, \&quot;en\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rulesListItemTypes(ruleSetCode, acceptLanguage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rulesListItemTypes(ruleSetCode, acceptLanguage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RulesApi.rulesListItemTypes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns all types of parts.  Public URL: `GET /api/v1/rules/partTypes`.  Replaces the legacy `GET /api/structure/part-type`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rulesListPartTypes(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rulesListPartTypes(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RulesApi.rulesListPartTypes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * RulesApi - factory interface
 */
export const RulesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RulesApiFp(configuration);
    return {
        /**
         * Returns item types together with their specifications and rendering hints. By default all item types across loaded rule sets; when `ruleSetCode` is given, only the item types available in that rule set.  Public URL: `GET /api/v1/rules/itemTypes`.  Localized strings (`name`, `shortcut`, `description` on `ItemType` and `ItemTypeSpec`, plus `name` on `ItemTableColumn`) honour the `Accept-Language` request header when provided; otherwise the server default language is used.  Replaces the legacy `GET /api/rule/descItemTypes`.
         * @param {string} [ruleSetCode] When set, return only the item types available in this rule set (&#x60;RulRuleSet.code&#x60;); otherwise all loaded rule sets.
         * @param {string} [acceptLanguage] Preferred language for localized strings (e.g. \&quot;cs\&quot;, \&quot;en\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rulesListItemTypes(ruleSetCode, acceptLanguage, options) {
            return localVarFp.rulesListItemTypes(ruleSetCode, acceptLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all types of parts.  Public URL: `GET /api/v1/rules/partTypes`.  Replaces the legacy `GET /api/structure/part-type`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rulesListPartTypes(options) {
            return localVarFp.rulesListPartTypes(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RulesApi - object-oriented interface
 */
export class RulesApi extends BaseAPI {
    /**
     * Returns item types together with their specifications and rendering hints. By default all item types across loaded rule sets; when `ruleSetCode` is given, only the item types available in that rule set.  Public URL: `GET /api/v1/rules/itemTypes`.  Localized strings (`name`, `shortcut`, `description` on `ItemType` and `ItemTypeSpec`, plus `name` on `ItemTableColumn`) honour the `Accept-Language` request header when provided; otherwise the server default language is used.  Replaces the legacy `GET /api/rule/descItemTypes`.
     * @param {string} [ruleSetCode] When set, return only the item types available in this rule set (&#x60;RulRuleSet.code&#x60;); otherwise all loaded rule sets.
     * @param {string} [acceptLanguage] Preferred language for localized strings (e.g. \&quot;cs\&quot;, \&quot;en\&quot;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rulesListItemTypes(ruleSetCode, acceptLanguage, options) {
        return RulesApiFp(this.configuration).rulesListItemTypes(ruleSetCode, acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all types of parts.  Public URL: `GET /api/v1/rules/partTypes`.  Replaces the legacy `GET /api/structure/part-type`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rulesListPartTypes(options) {
        return RulesApiFp(this.configuration).rulesListPartTypes(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SearchApi - axios parameter creator
 */
export const SearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Searches for array descriptions
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchArchDesc: (searchParams_1, ...args_1) => __awaiter(this, [searchParams_1, ...args_1], void 0, function* (searchParams, options = {}) {
            // verify required parameter 'searchParams' is not null or undefined
            assertParamExists('searchArchDesc', 'searchParams', searchParams);
            const localVarPath = `/search-arr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Searches for entity
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEntity: (searchParams_1, ...args_1) => __awaiter(this, [searchParams_1, ...args_1], void 0, function* (searchParams, options = {}) {
            // verify required parameter 'searchParams' is not null or undefined
            assertParamExists('searchEntity', 'searchParams', searchParams);
            const localVarPath = `/search-ap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SearchApi - functional programming interface
 */
export const SearchApiFp = function (configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration);
    return {
        /**
         * Searches for array descriptions
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchArchDesc(searchParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchArchDesc(searchParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SearchApi.searchArchDesc']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Searches for entity
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEntity(searchParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchEntity(searchParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SearchApi.searchEntity']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * SearchApi - factory interface
 */
export const SearchApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SearchApiFp(configuration);
    return {
        /**
         * Searches for array descriptions
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchArchDesc(searchParams, options) {
            return localVarFp.searchArchDesc(searchParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches for entity
         * @param {SearchParams} searchParams search parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEntity(searchParams, options) {
            return localVarFp.searchEntity(searchParams, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SearchApi - object-oriented interface
 */
export class SearchApi extends BaseAPI {
    /**
     * Searches for array descriptions
     * @param {SearchParams} searchParams search parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchArchDesc(searchParams, options) {
        return SearchApiFp(this.configuration).searchArchDesc(searchParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Searches for entity
     * @param {SearchParams} searchParams search parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchEntity(searchParams, options) {
        return SearchApiFp(this.configuration).searchEntity(searchParams, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * StructureApi - axios parameter creator
 */
export const StructureApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Confirms the value of a structured data type. Sets the value
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoConfirm: (fundId_1, structuredObjectId_1, ...args_1) => __awaiter(this, [fundId_1, structuredObjectId_1, ...args_1], void 0, function* (fundId, structuredObjectId, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoConfirm', 'fundId', fundId);
            // verify required parameter 'structuredObjectId' is not null or undefined
            assertParamExists('sdoConfirm', 'structuredObjectId', structuredObjectId);
            const localVarPath = `/funds/sdo/{fundId}/{structuredObjectId}/confirm`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"structuredObjectId"}}`, encodeURIComponent(String(structuredObjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creating duplicates of a structured data type and an auto-increment field
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {SdoCopyObjectParam} sdoCopyObjectParam batch of data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoCopyObject: (fundId_1, structuredObjectId_1, sdoCopyObjectParam_1, ...args_1) => __awaiter(this, [fundId_1, structuredObjectId_1, sdoCopyObjectParam_1, ...args_1], void 0, function* (fundId, structuredObjectId, sdoCopyObjectParam, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoCopyObject', 'fundId', fundId);
            // verify required parameter 'structuredObjectId' is not null or undefined
            assertParamExists('sdoCopyObject', 'structuredObjectId', structuredObjectId);
            // verify required parameter 'sdoCopyObjectParam' is not null or undefined
            assertParamExists('sdoCopyObject', 'sdoCopyObjectParam', sdoCopyObjectParam);
            const localVarPath = `/funds/sdo/{fundId}/{structuredObjectId}/copy`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"structuredObjectId"}}`, encodeURIComponent(String(structuredObjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sdoCopyObjectParam, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create item value of a structured data type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {StructuredObjectItem} structuredObjectItem node item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoCreateItem: (fundId_1, structuredObjectId_1, structuredObjectItem_1, ...args_1) => __awaiter(this, [fundId_1, structuredObjectId_1, structuredObjectItem_1, ...args_1], void 0, function* (fundId, structuredObjectId, structuredObjectItem, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoCreateItem', 'fundId', fundId);
            // verify required parameter 'structuredObjectId' is not null or undefined
            assertParamExists('sdoCreateItem', 'structuredObjectId', structuredObjectId);
            // verify required parameter 'structuredObjectItem' is not null or undefined
            assertParamExists('sdoCreateItem', 'structuredObjectItem', structuredObjectItem);
            const localVarPath = `/funds/sdo/{fundId}/item/{structuredObjectId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"structuredObjectId"}}`, encodeURIComponent(String(structuredObjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(structuredObjectItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creating object of the structured data type
         * @param {number} fundId fund id
         * @param {string} body structured data type code
         * @param {string} [value] value for the structured data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoCreateObject: (fundId_1, body_1, value_1, ...args_1) => __awaiter(this, [fundId_1, body_1, value_1, ...args_1], void 0, function* (fundId, body, value, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoCreateObject', 'fundId', fundId);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sdoCreateObject', 'body', body);
            const localVarPath = `/funds/sdo/{fundId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }
            localVarHeaderParameter['Content-Type'] = 'text/plain';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete item value of a structured data type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structured object id
         * @param {number} itemObjectId item object id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoDeleteItem: (fundId_1, structuredObjectId_1, itemObjectId_1, ...args_1) => __awaiter(this, [fundId_1, structuredObjectId_1, itemObjectId_1, ...args_1], void 0, function* (fundId, structuredObjectId, itemObjectId, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoDeleteItem', 'fundId', fundId);
            // verify required parameter 'structuredObjectId' is not null or undefined
            assertParamExists('sdoDeleteItem', 'structuredObjectId', structuredObjectId);
            // verify required parameter 'itemObjectId' is not null or undefined
            assertParamExists('sdoDeleteItem', 'itemObjectId', itemObjectId);
            const localVarPath = `/funds/sdo/{fundId}/item/{structuredObjectId}/{itemObjectId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"structuredObjectId"}}`, encodeURIComponent(String(structuredObjectId)))
                .replace(`{${"itemObjectId"}}`, encodeURIComponent(String(itemObjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete items based on the value of a data type structure by attribute type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structured object id
         * @param {number} itemTypeId item type id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoDeleteItemsByType: (fundId_1, structuredObjectId_1, itemTypeId_1, ...args_1) => __awaiter(this, [fundId_1, structuredObjectId_1, itemTypeId_1, ...args_1], void 0, function* (fundId, structuredObjectId, itemTypeId, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoDeleteItemsByType', 'fundId', fundId);
            // verify required parameter 'structuredObjectId' is not null or undefined
            assertParamExists('sdoDeleteItemsByType', 'structuredObjectId', structuredObjectId);
            // verify required parameter 'itemTypeId' is not null or undefined
            assertParamExists('sdoDeleteItemsByType', 'itemTypeId', itemTypeId);
            const localVarPath = `/funds/sdo/{fundId}/item/{structuredObjectId}/by-type/{itemTypeId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"structuredObjectId"}}`, encodeURIComponent(String(structuredObjectId)))
                .replace(`{${"itemTypeId"}}`, encodeURIComponent(String(itemTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deleting a value(s) of a structured data type
         * @param {number} fundId fund id
         * @param {Array<number>} requestBody list of id value(s) of structured data type
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoDeleteObjects: (fundId_1, requestBody_1, fundVersionId_1, ...args_1) => __awaiter(this, [fundId_1, requestBody_1, fundVersionId_1, ...args_1], void 0, function* (fundId, requestBody, fundVersionId, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoDeleteObjects', 'fundId', fundId);
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('sdoDeleteObjects', 'requestBody', requestBody);
            const localVarPath = `/funds/sdo/{fundId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fundVersionId !== undefined) {
                localVarQueryParameter['fundVersionId'] = fundVersionId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * GET Finds available and enabled AS extensions: findFundStructureExtension()
         * @param {number} fundId fund id
         * @param {string} structureTypeCode structure type code
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoFindFundStructureExtension: (fundId_1, structureTypeCode_1, fundVersionId_1, ...args_1) => __awaiter(this, [fundId_1, structureTypeCode_1, fundVersionId_1, ...args_1], void 0, function* (fundId, structureTypeCode, fundVersionId, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoFindFundStructureExtension', 'fundId', fundId);
            // verify required parameter 'structureTypeCode' is not null or undefined
            assertParamExists('sdoFindFundStructureExtension', 'structureTypeCode', structureTypeCode);
            const localVarPath = `/funds/sdo/{fundId}/extension/{structureTypeCode}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"structureTypeCode"}}`, encodeURIComponent(String(structureTypeCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fundVersionId !== undefined) {
                localVarQueryParameter['fundVersionId'] = fundVersionId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * GET Searching for values of a structured data type: findStructObj()
         * @param {number} fundId fund id
         * @param {string} structureTypeCode structure type code
         * @param {string} [search] text for filtering (optional)
         * @param {boolean} [assignable] assignable value
         * @param {number} [from] from default &#x3D; 0
         * @param {number} [count] max number of items
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoFindStructObj: (fundId_1, structureTypeCode_1, search_1, assignable_1, from_1, count_1, fundVersionId_1, ...args_1) => __awaiter(this, [fundId_1, structureTypeCode_1, search_1, assignable_1, from_1, count_1, fundVersionId_1, ...args_1], void 0, function* (fundId, structureTypeCode, search, assignable, from, count, fundVersionId, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoFindStructObj', 'fundId', fundId);
            // verify required parameter 'structureTypeCode' is not null or undefined
            assertParamExists('sdoFindStructObj', 'structureTypeCode', structureTypeCode);
            const localVarPath = `/funds/sdo/{fundId}/search/{structureTypeCode}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"structureTypeCode"}}`, encodeURIComponent(String(structureTypeCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (assignable !== undefined) {
                localVarQueryParameter['assignable'] = assignable;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }
            if (fundVersionId !== undefined) {
                localVarQueryParameter['fundVersionId'] = fundVersionId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * GET Lists the possible data types that can be used in AS: findStructureTypes()
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoFindStructureTypes: (fundVersionId_1, ...args_1) => __awaiter(this, [fundVersionId_1, ...args_1], void 0, function* (fundVersionId, options = {}) {
            const localVarPath = `/funds/sdo/type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fundVersionId !== undefined) {
                localVarQueryParameter['fundVersionId'] = fundVersionId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * GET Getting data for a structured data type form: getFormStructureItems()
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structured object id
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoGetFormStructureItems: (fundId_1, structuredObjectId_1, fundVersionId_1, ...args_1) => __awaiter(this, [fundId_1, structuredObjectId_1, fundVersionId_1, ...args_1], void 0, function* (fundId, structuredObjectId, fundVersionId, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoGetFormStructureItems', 'fundId', fundId);
            // verify required parameter 'structuredObjectId' is not null or undefined
            assertParamExists('sdoGetFormStructureItems', 'structuredObjectId', structuredObjectId);
            const localVarPath = `/funds/sdo/{fundId}/item/{structuredObjectId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"structuredObjectId"}}`, encodeURIComponent(String(structuredObjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fundVersionId !== undefined) {
                localVarQueryParameter['fundVersionId'] = fundVersionId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Getting the value of a structured data type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoGetObject: (fundId_1, structuredObjectId_1, fundVersionId_1, ...args_1) => __awaiter(this, [fundId_1, structuredObjectId_1, fundVersionId_1, ...args_1], void 0, function* (fundId, structuredObjectId, fundVersionId, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoGetObject', 'fundId', fundId);
            // verify required parameter 'structuredObjectId' is not null or undefined
            assertParamExists('sdoGetObject', 'structuredObjectId', structuredObjectId);
            const localVarPath = `/funds/sdo/{fundId}/{structuredObjectId}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"structuredObjectId"}}`, encodeURIComponent(String(structuredObjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fundVersionId !== undefined) {
                localVarQueryParameter['fundVersionId'] = fundVersionId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Assignability settings.
         * @param {number} fundId fund id
         * @param {boolean} assignable assignable value
         * @param {Array<number>} requestBody value ids for a structured data type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoSetDataAssignable: (fundId_1, assignable_1, requestBody_1, ...args_1) => __awaiter(this, [fundId_1, assignable_1, requestBody_1, ...args_1], void 0, function* (fundId, assignable, requestBody, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoSetDataAssignable', 'fundId', fundId);
            // verify required parameter 'assignable' is not null or undefined
            assertParamExists('sdoSetDataAssignable', 'assignable', assignable);
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('sdoSetDataAssignable', 'requestBody', requestBody);
            const localVarPath = `/funds/sdo/{fundId}/assignable/{assignable}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"assignable"}}`, encodeURIComponent(String(assignable)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * PUT Sets a specific extension on the AS: setFundStructureExtensions()
         * @param {number} fundId fund id
         * @param {string} structureTypeCode structure type code
         * @param {Array<string>} requestBody structure ext codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoSetFundStructureExtensions: (fundId_1, structureTypeCode_1, requestBody_1, ...args_1) => __awaiter(this, [fundId_1, structureTypeCode_1, requestBody_1, ...args_1], void 0, function* (fundId, structureTypeCode, requestBody, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoSetFundStructureExtensions', 'fundId', fundId);
            // verify required parameter 'structureTypeCode' is not null or undefined
            assertParamExists('sdoSetFundStructureExtensions', 'structureTypeCode', structureTypeCode);
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('sdoSetFundStructureExtensions', 'requestBody', requestBody);
            const localVarPath = `/funds/sdo/{fundId}/extension/{structureTypeCode}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"structureTypeCode"}}`, encodeURIComponent(String(structureTypeCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update item value of a structured data type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {boolean} createNewVersion create a new version
         * @param {StructuredObjectItem} structuredObjectItem node item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoUpdateItem: (fundId_1, structuredObjectId_1, createNewVersion_1, structuredObjectItem_1, ...args_1) => __awaiter(this, [fundId_1, structuredObjectId_1, createNewVersion_1, structuredObjectItem_1, ...args_1], void 0, function* (fundId, structuredObjectId, createNewVersion, structuredObjectItem, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoUpdateItem', 'fundId', fundId);
            // verify required parameter 'structuredObjectId' is not null or undefined
            assertParamExists('sdoUpdateItem', 'structuredObjectId', structuredObjectId);
            // verify required parameter 'createNewVersion' is not null or undefined
            assertParamExists('sdoUpdateItem', 'createNewVersion', createNewVersion);
            // verify required parameter 'structuredObjectItem' is not null or undefined
            assertParamExists('sdoUpdateItem', 'structuredObjectItem', structuredObjectItem);
            const localVarPath = `/funds/sdo/{fundId}/item/{structuredObjectId}/{createNewVersion}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"structuredObjectId"}}`, encodeURIComponent(String(structuredObjectId)))
                .replace(`{${"createNewVersion"}}`, encodeURIComponent(String(createNewVersion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(structuredObjectItem, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Bulk update of items/values of a structural type
         * @param {number} fundId fund id
         * @param {string} structureTypeCode structure type code
         * @param {SdoBatchUpdateParam} sdoBatchUpdateParam batch of data to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoUpdateObjects: (fundId_1, structureTypeCode_1, sdoBatchUpdateParam_1, ...args_1) => __awaiter(this, [fundId_1, structureTypeCode_1, sdoBatchUpdateParam_1, ...args_1], void 0, function* (fundId, structureTypeCode, sdoBatchUpdateParam, options = {}) {
            // verify required parameter 'fundId' is not null or undefined
            assertParamExists('sdoUpdateObjects', 'fundId', fundId);
            // verify required parameter 'structureTypeCode' is not null or undefined
            assertParamExists('sdoUpdateObjects', 'structureTypeCode', structureTypeCode);
            // verify required parameter 'sdoBatchUpdateParam' is not null or undefined
            assertParamExists('sdoUpdateObjects', 'sdoBatchUpdateParam', sdoBatchUpdateParam);
            const localVarPath = `/funds/sdo/{fundId}/batchUpdate/{structureTypeCode}`
                .replace(`{${"fundId"}}`, encodeURIComponent(String(fundId)))
                .replace(`{${"structureTypeCode"}}`, encodeURIComponent(String(structureTypeCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sdoBatchUpdateParam, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * StructureApi - functional programming interface
 */
export const StructureApiFp = function (configuration) {
    const localVarAxiosParamCreator = StructureApiAxiosParamCreator(configuration);
    return {
        /**
         * Confirms the value of a structured data type. Sets the value
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoConfirm(fundId, structuredObjectId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoConfirm(fundId, structuredObjectId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoConfirm']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creating duplicates of a structured data type and an auto-increment field
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {SdoCopyObjectParam} sdoCopyObjectParam batch of data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoCopyObject(fundId, structuredObjectId, sdoCopyObjectParam, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoCopyObject(fundId, structuredObjectId, sdoCopyObjectParam, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoCopyObject']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create item value of a structured data type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {StructuredObjectItem} structuredObjectItem node item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoCreateItem(fundId, structuredObjectId, structuredObjectItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoCreateItem(fundId, structuredObjectId, structuredObjectItem, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoCreateItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creating object of the structured data type
         * @param {number} fundId fund id
         * @param {string} body structured data type code
         * @param {string} [value] value for the structured data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoCreateObject(fundId, body, value, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoCreateObject(fundId, body, value, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoCreateObject']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete item value of a structured data type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structured object id
         * @param {number} itemObjectId item object id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoDeleteItem(fundId, structuredObjectId, itemObjectId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoDeleteItem(fundId, structuredObjectId, itemObjectId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoDeleteItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete items based on the value of a data type structure by attribute type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structured object id
         * @param {number} itemTypeId item type id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoDeleteItemsByType(fundId, structuredObjectId, itemTypeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoDeleteItemsByType(fundId, structuredObjectId, itemTypeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoDeleteItemsByType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deleting a value(s) of a structured data type
         * @param {number} fundId fund id
         * @param {Array<number>} requestBody list of id value(s) of structured data type
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoDeleteObjects(fundId, requestBody, fundVersionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoDeleteObjects(fundId, requestBody, fundVersionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoDeleteObjects']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * GET Finds available and enabled AS extensions: findFundStructureExtension()
         * @param {number} fundId fund id
         * @param {string} structureTypeCode structure type code
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoFindFundStructureExtension(fundId, structureTypeCode, fundVersionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoFindFundStructureExtension(fundId, structureTypeCode, fundVersionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoFindFundStructureExtension']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * GET Searching for values of a structured data type: findStructObj()
         * @param {number} fundId fund id
         * @param {string} structureTypeCode structure type code
         * @param {string} [search] text for filtering (optional)
         * @param {boolean} [assignable] assignable value
         * @param {number} [from] from default &#x3D; 0
         * @param {number} [count] max number of items
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoFindStructObj(fundId, structureTypeCode, search, assignable, from, count, fundVersionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoFindStructObj(fundId, structureTypeCode, search, assignable, from, count, fundVersionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoFindStructObj']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * GET Lists the possible data types that can be used in AS: findStructureTypes()
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoFindStructureTypes(fundVersionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoFindStructureTypes(fundVersionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoFindStructureTypes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * GET Getting data for a structured data type form: getFormStructureItems()
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structured object id
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoGetFormStructureItems(fundId, structuredObjectId, fundVersionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoGetFormStructureItems(fundId, structuredObjectId, fundVersionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoGetFormStructureItems']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Getting the value of a structured data type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoGetObject(fundId, structuredObjectId, fundVersionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoGetObject(fundId, structuredObjectId, fundVersionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoGetObject']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Assignability settings.
         * @param {number} fundId fund id
         * @param {boolean} assignable assignable value
         * @param {Array<number>} requestBody value ids for a structured data type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoSetDataAssignable(fundId, assignable, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoSetDataAssignable(fundId, assignable, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoSetDataAssignable']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * PUT Sets a specific extension on the AS: setFundStructureExtensions()
         * @param {number} fundId fund id
         * @param {string} structureTypeCode structure type code
         * @param {Array<string>} requestBody structure ext codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoSetFundStructureExtensions(fundId, structureTypeCode, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoSetFundStructureExtensions(fundId, structureTypeCode, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoSetFundStructureExtensions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update item value of a structured data type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {boolean} createNewVersion create a new version
         * @param {StructuredObjectItem} structuredObjectItem node item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoUpdateItem(fundId, structuredObjectId, createNewVersion, structuredObjectItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoUpdateItem(fundId, structuredObjectId, createNewVersion, structuredObjectItem, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoUpdateItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Bulk update of items/values of a structural type
         * @param {number} fundId fund id
         * @param {string} structureTypeCode structure type code
         * @param {SdoBatchUpdateParam} sdoBatchUpdateParam batch of data to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoUpdateObjects(fundId, structureTypeCode, sdoBatchUpdateParam, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sdoUpdateObjects(fundId, structureTypeCode, sdoBatchUpdateParam, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StructureApi.sdoUpdateObjects']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * StructureApi - factory interface
 */
export const StructureApiFactory = function (configuration, basePath, axios) {
    const localVarFp = StructureApiFp(configuration);
    return {
        /**
         * Confirms the value of a structured data type. Sets the value
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoConfirm(fundId, structuredObjectId, options) {
            return localVarFp.sdoConfirm(fundId, structuredObjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creating duplicates of a structured data type and an auto-increment field
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {SdoCopyObjectParam} sdoCopyObjectParam batch of data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoCopyObject(fundId, structuredObjectId, sdoCopyObjectParam, options) {
            return localVarFp.sdoCopyObject(fundId, structuredObjectId, sdoCopyObjectParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Create item value of a structured data type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {StructuredObjectItem} structuredObjectItem node item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoCreateItem(fundId, structuredObjectId, structuredObjectItem, options) {
            return localVarFp.sdoCreateItem(fundId, structuredObjectId, structuredObjectItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Creating object of the structured data type
         * @param {number} fundId fund id
         * @param {string} body structured data type code
         * @param {string} [value] value for the structured data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoCreateObject(fundId, body, value, options) {
            return localVarFp.sdoCreateObject(fundId, body, value, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete item value of a structured data type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structured object id
         * @param {number} itemObjectId item object id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoDeleteItem(fundId, structuredObjectId, itemObjectId, options) {
            return localVarFp.sdoDeleteItem(fundId, structuredObjectId, itemObjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete items based on the value of a data type structure by attribute type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structured object id
         * @param {number} itemTypeId item type id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoDeleteItemsByType(fundId, structuredObjectId, itemTypeId, options) {
            return localVarFp.sdoDeleteItemsByType(fundId, structuredObjectId, itemTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deleting a value(s) of a structured data type
         * @param {number} fundId fund id
         * @param {Array<number>} requestBody list of id value(s) of structured data type
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoDeleteObjects(fundId, requestBody, fundVersionId, options) {
            return localVarFp.sdoDeleteObjects(fundId, requestBody, fundVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * GET Finds available and enabled AS extensions: findFundStructureExtension()
         * @param {number} fundId fund id
         * @param {string} structureTypeCode structure type code
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoFindFundStructureExtension(fundId, structureTypeCode, fundVersionId, options) {
            return localVarFp.sdoFindFundStructureExtension(fundId, structureTypeCode, fundVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * GET Searching for values of a structured data type: findStructObj()
         * @param {number} fundId fund id
         * @param {string} structureTypeCode structure type code
         * @param {string} [search] text for filtering (optional)
         * @param {boolean} [assignable] assignable value
         * @param {number} [from] from default &#x3D; 0
         * @param {number} [count] max number of items
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoFindStructObj(fundId, structureTypeCode, search, assignable, from, count, fundVersionId, options) {
            return localVarFp.sdoFindStructObj(fundId, structureTypeCode, search, assignable, from, count, fundVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * GET Lists the possible data types that can be used in AS: findStructureTypes()
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoFindStructureTypes(fundVersionId, options) {
            return localVarFp.sdoFindStructureTypes(fundVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * GET Getting data for a structured data type form: getFormStructureItems()
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structured object id
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoGetFormStructureItems(fundId, structuredObjectId, fundVersionId, options) {
            return localVarFp.sdoGetFormStructureItems(fundId, structuredObjectId, fundVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Getting the value of a structured data type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {number} [fundVersionId] fund version id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoGetObject(fundId, structuredObjectId, fundVersionId, options) {
            return localVarFp.sdoGetObject(fundId, structuredObjectId, fundVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Assignability settings.
         * @param {number} fundId fund id
         * @param {boolean} assignable assignable value
         * @param {Array<number>} requestBody value ids for a structured data type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoSetDataAssignable(fundId, assignable, requestBody, options) {
            return localVarFp.sdoSetDataAssignable(fundId, assignable, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * PUT Sets a specific extension on the AS: setFundStructureExtensions()
         * @param {number} fundId fund id
         * @param {string} structureTypeCode structure type code
         * @param {Array<string>} requestBody structure ext codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoSetFundStructureExtensions(fundId, structureTypeCode, requestBody, options) {
            return localVarFp.sdoSetFundStructureExtensions(fundId, structureTypeCode, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Update item value of a structured data type
         * @param {number} fundId fund id
         * @param {number} structuredObjectId structure data id
         * @param {boolean} createNewVersion create a new version
         * @param {StructuredObjectItem} structuredObjectItem node item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoUpdateItem(fundId, structuredObjectId, createNewVersion, structuredObjectItem, options) {
            return localVarFp.sdoUpdateItem(fundId, structuredObjectId, createNewVersion, structuredObjectItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk update of items/values of a structural type
         * @param {number} fundId fund id
         * @param {string} structureTypeCode structure type code
         * @param {SdoBatchUpdateParam} sdoBatchUpdateParam batch of data to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sdoUpdateObjects(fundId, structureTypeCode, sdoBatchUpdateParam, options) {
            return localVarFp.sdoUpdateObjects(fundId, structureTypeCode, sdoBatchUpdateParam, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * StructureApi - object-oriented interface
 */
export class StructureApi extends BaseAPI {
    /**
     * Confirms the value of a structured data type. Sets the value
     * @param {number} fundId fund id
     * @param {number} structuredObjectId structure data id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoConfirm(fundId, structuredObjectId, options) {
        return StructureApiFp(this.configuration).sdoConfirm(fundId, structuredObjectId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creating duplicates of a structured data type and an auto-increment field
     * @param {number} fundId fund id
     * @param {number} structuredObjectId structure data id
     * @param {SdoCopyObjectParam} sdoCopyObjectParam batch of data to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoCopyObject(fundId, structuredObjectId, sdoCopyObjectParam, options) {
        return StructureApiFp(this.configuration).sdoCopyObject(fundId, structuredObjectId, sdoCopyObjectParam, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create item value of a structured data type
     * @param {number} fundId fund id
     * @param {number} structuredObjectId structure data id
     * @param {StructuredObjectItem} structuredObjectItem node item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoCreateItem(fundId, structuredObjectId, structuredObjectItem, options) {
        return StructureApiFp(this.configuration).sdoCreateItem(fundId, structuredObjectId, structuredObjectItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creating object of the structured data type
     * @param {number} fundId fund id
     * @param {string} body structured data type code
     * @param {string} [value] value for the structured data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoCreateObject(fundId, body, value, options) {
        return StructureApiFp(this.configuration).sdoCreateObject(fundId, body, value, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete item value of a structured data type
     * @param {number} fundId fund id
     * @param {number} structuredObjectId structured object id
     * @param {number} itemObjectId item object id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoDeleteItem(fundId, structuredObjectId, itemObjectId, options) {
        return StructureApiFp(this.configuration).sdoDeleteItem(fundId, structuredObjectId, itemObjectId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete items based on the value of a data type structure by attribute type
     * @param {number} fundId fund id
     * @param {number} structuredObjectId structured object id
     * @param {number} itemTypeId item type id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoDeleteItemsByType(fundId, structuredObjectId, itemTypeId, options) {
        return StructureApiFp(this.configuration).sdoDeleteItemsByType(fundId, structuredObjectId, itemTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deleting a value(s) of a structured data type
     * @param {number} fundId fund id
     * @param {Array<number>} requestBody list of id value(s) of structured data type
     * @param {number} [fundVersionId] fund version id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoDeleteObjects(fundId, requestBody, fundVersionId, options) {
        return StructureApiFp(this.configuration).sdoDeleteObjects(fundId, requestBody, fundVersionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * GET Finds available and enabled AS extensions: findFundStructureExtension()
     * @param {number} fundId fund id
     * @param {string} structureTypeCode structure type code
     * @param {number} [fundVersionId] fund version id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoFindFundStructureExtension(fundId, structureTypeCode, fundVersionId, options) {
        return StructureApiFp(this.configuration).sdoFindFundStructureExtension(fundId, structureTypeCode, fundVersionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * GET Searching for values of a structured data type: findStructObj()
     * @param {number} fundId fund id
     * @param {string} structureTypeCode structure type code
     * @param {string} [search] text for filtering (optional)
     * @param {boolean} [assignable] assignable value
     * @param {number} [from] from default &#x3D; 0
     * @param {number} [count] max number of items
     * @param {number} [fundVersionId] fund version id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoFindStructObj(fundId, structureTypeCode, search, assignable, from, count, fundVersionId, options) {
        return StructureApiFp(this.configuration).sdoFindStructObj(fundId, structureTypeCode, search, assignable, from, count, fundVersionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * GET Lists the possible data types that can be used in AS: findStructureTypes()
     * @param {number} [fundVersionId] fund version id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoFindStructureTypes(fundVersionId, options) {
        return StructureApiFp(this.configuration).sdoFindStructureTypes(fundVersionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * GET Getting data for a structured data type form: getFormStructureItems()
     * @param {number} fundId fund id
     * @param {number} structuredObjectId structured object id
     * @param {number} [fundVersionId] fund version id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoGetFormStructureItems(fundId, structuredObjectId, fundVersionId, options) {
        return StructureApiFp(this.configuration).sdoGetFormStructureItems(fundId, structuredObjectId, fundVersionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Getting the value of a structured data type
     * @param {number} fundId fund id
     * @param {number} structuredObjectId structure data id
     * @param {number} [fundVersionId] fund version id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoGetObject(fundId, structuredObjectId, fundVersionId, options) {
        return StructureApiFp(this.configuration).sdoGetObject(fundId, structuredObjectId, fundVersionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Assignability settings.
     * @param {number} fundId fund id
     * @param {boolean} assignable assignable value
     * @param {Array<number>} requestBody value ids for a structured data type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoSetDataAssignable(fundId, assignable, requestBody, options) {
        return StructureApiFp(this.configuration).sdoSetDataAssignable(fundId, assignable, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * PUT Sets a specific extension on the AS: setFundStructureExtensions()
     * @param {number} fundId fund id
     * @param {string} structureTypeCode structure type code
     * @param {Array<string>} requestBody structure ext codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoSetFundStructureExtensions(fundId, structureTypeCode, requestBody, options) {
        return StructureApiFp(this.configuration).sdoSetFundStructureExtensions(fundId, structureTypeCode, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update item value of a structured data type
     * @param {number} fundId fund id
     * @param {number} structuredObjectId structure data id
     * @param {boolean} createNewVersion create a new version
     * @param {StructuredObjectItem} structuredObjectItem node item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoUpdateItem(fundId, structuredObjectId, createNewVersion, structuredObjectItem, options) {
        return StructureApiFp(this.configuration).sdoUpdateItem(fundId, structuredObjectId, createNewVersion, structuredObjectItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Bulk update of items/values of a structural type
     * @param {number} fundId fund id
     * @param {string} structureTypeCode structure type code
     * @param {SdoBatchUpdateParam} sdoBatchUpdateParam batch of data to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sdoUpdateObjects(fundId, structureTypeCode, sdoBatchUpdateParam, options) {
        return StructureApiFp(this.configuration).sdoUpdateObjects(fundId, structureTypeCode, sdoBatchUpdateParam, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TasksApi - axios parameter creator
 */
export const TasksApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Task list for a given user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksGetMyTasks: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/tasks/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TasksApi - functional programming interface
 */
export const TasksApiFp = function (configuration) {
    const localVarAxiosParamCreator = TasksApiAxiosParamCreator(configuration);
    return {
        /**
         * Task list for a given user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksGetMyTasks(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tasksGetMyTasks(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TasksApi.tasksGetMyTasks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * TasksApi - factory interface
 */
export const TasksApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TasksApiFp(configuration);
    return {
        /**
         * Task list for a given user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksGetMyTasks(options) {
            return localVarFp.tasksGetMyTasks(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TasksApi - object-oriented interface
 */
export class TasksApi extends BaseAPI {
    /**
     * Task list for a given user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksGetMyTasks(options) {
        return TasksApiFp(this.configuration).tasksGetMyTasks(options).then((request) => request(this.axios, this.basePath));
    }
}
